import * as i0 from '@angular/core';
import { APP_BOOTSTRAP_LISTENER, Component, Input, Directive, Injectable, EventEmitter, ViewChild, Output, ErrorHandler, SecurityContext, Pipe, ChangeDetectionStrategy, HostListener, Inject, NgModule, InjectionToken, NgZone } from '@angular/core';
import * as i1 from '@angular/router';
import { NavigationEnd, PRIMARY_OUTLET, RouteConfigLoadStart, RouteConfigLoadEnd, RouterModule } from '@angular/router';
import { filter, tap, catchError, finalize, shareReplay, first, map, mergeMap } from 'rxjs/operators';
import * as i1$1 from '@angular/common';
import { DOCUMENT, CommonModule } from '@angular/common';
import { Subject, throwError, BehaviorSubject, tap as tap$1, combineLatest } from 'rxjs';
import * as i2 from '@angular/forms';
import { UntypedFormGroup, UntypedFormControl, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import * as i5 from '@progress/kendo-angular-dialog';
import { DialogModule } from '@progress/kendo-angular-dialog';
import * as i1$2 from '@angular/common/http';
import { HttpResponse, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { __decorate } from 'tslib';
import { BlockUI } from 'ng-block-ui';
import { process } from '@progress/kendo-data-query';
import * as i2$1 from '@angular/platform-browser';
import * as i2$2 from '@progress/kendo-angular-popup';
import { PopupService, PopupModule } from '@progress/kendo-angular-popup';
import * as i3 from '@progress/kendo-angular-dropdowns';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { ResizeBatchService } from '@progress/kendo-angular-common';
import * as i4 from '@progress/kendo-angular-dateinputs';
import { DateInputModule, DateInputsModule } from '@progress/kendo-angular-dateinputs';

class AuthenticationService {
}

const AnalyticsInitializer = (authenticationService) => async () => authenticationService.getAuthInfo().subscribe(authInfo => {
    // no code, no point
    if (!authInfo.gaTrackingCode)
        return;
    // add the analytics script to the dom
    let scriptElement = document.createElement('script');
    scriptElement.async = true;
    scriptElement.src = `https://www.googletagmanager.com/gtag/js?id=${authInfo.gaTrackingCode}`;
    document.head.appendChild(scriptElement);
    // add the gtag function
    scriptElement = document.createElement('script');
    scriptElement.innerText = `
                window.dataLayer = window.dataLayer || [];
                function gtag() { dataLayer.push(arguments); }
                gtag('js', new Date());

                gtag('config', '${authInfo.gaTrackingCode}');
            `;
    document.head.appendChild(scriptElement);
});
const ANALYTICS_INITIALIZIER_PROVIDER = {
    deps: [
        AuthenticationService,
    ],
    multi: true,
    provide: APP_BOOTSTRAP_LISTENER,
    useFactory: AnalyticsInitializer,
};

class BreadcrumbComponent {
    constructor(activatedRoute, router) {
        this.activatedRoute = activatedRoute;
        this.router = router;
        this.breadcrumbs = [];
    }
    ngOnInit() {
        const ROUTE_DATA_BREADCRUMB = "breadcrumb";
        this.router.events;
        //subscribe to the NavigationEnd event
        this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(event => {
            //set breadcrumbs
            let root = this.activatedRoute.root;
            this.breadcrumbs = this.getBreadcrumbs(root);
        });
        let root = this.activatedRoute.root;
        this.breadcrumbs = this.getBreadcrumbs(root);
    }
    getBreadcrumbs(route, url = "", breadcrumbs = []) {
        const ROUTE_DATA_BREADCRUMB = "breadcrumb";
        //get the child routes
        let children = route.children;
        //return if there are no more children
        if (children.length === 0) {
            return breadcrumbs;
        }
        //iterate over each children
        for (let child of children) {
            //verify primary route
            if (child.outlet !== PRIMARY_OUTLET) {
                continue;
            }
            //verify the custom data property "breadcrumb" is specified on the route
            if (!child.snapshot.data.hasOwnProperty(ROUTE_DATA_BREADCRUMB)) {
                return this.getBreadcrumbs(child, url, breadcrumbs);
            }
            //get the route's URL segment, we do it this way because we have so many nested modules
            let pathroots = child.pathFromRoot;
            let arr = [];
            pathroots.forEach(path => {
                let pathurl = '';
                path.url.subscribe(url => {
                    url.forEach(e => {
                        pathurl = e.toString();
                        if (arr.indexOf(pathurl) === -1 && pathurl !== "") {
                            arr.push(pathurl);
                        }
                    });
                });
            });
            let routeURL = arr.join("/");
            //append route URL to URL
            url = `/${routeURL}`;
            //add breadcrumb
            let breadcrumb = {
                label: child.snapshot.data[ROUTE_DATA_BREADCRUMB],
                params: {},
                url: url
            };
            //Ensure no duplicate breadcrumbs are created
            //this can happen when using the rootpath
            if (breadcrumbs.filter(e => e.label === breadcrumb.label).length === 0) {
                breadcrumbs.push(breadcrumb);
            }
            //recursive
            return this.getBreadcrumbs(child, url, breadcrumbs);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.1", ngImport: i0, type: BreadcrumbComponent, deps: [{ token: i1.ActivatedRoute }, { token: i1.Router }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.1", type: BreadcrumbComponent, selector: "cl-breadcrumb", ngImport: i0, template: "<div style=\"margin-top:10px;\">\r\n    <span *ngFor=\"let breadcrumb of breadcrumbs; let last = last;\">\r\n        <span *ngIf=\"!last\">\r\n            <a style=\"color:#4D4D4D !important\" [routerLink]=\"[breadcrumb.url, breadcrumb.params]\">{{breadcrumb.label}}</a>&nbsp;>&nbsp;\r\n        </span>\r\n        <span *ngIf=\"last && breadcrumbs.length > 1\">\r\n            {{breadcrumb.label}}\r\n        </span>\r\n    </span>\r\n</div>", dependencies: [{ kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.RouterLink, selector: "[routerLink]", inputs: ["target", "queryParams", "fragment", "queryParamsHandling", "state", "info", "relativeTo", "preserveFragment", "skipLocationChange", "replaceUrl", "routerLink"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.1", ngImport: i0, type: BreadcrumbComponent, decorators: [{
            type: Component,
            args: [{ selector: "cl-breadcrumb", template: "<div style=\"margin-top:10px;\">\r\n    <span *ngFor=\"let breadcrumb of breadcrumbs; let last = last;\">\r\n        <span *ngIf=\"!last\">\r\n            <a style=\"color:#4D4D4D !important\" [routerLink]=\"[breadcrumb.url, breadcrumb.params]\">{{breadcrumb.label}}</a>&nbsp;>&nbsp;\r\n        </span>\r\n        <span *ngIf=\"last && breadcrumbs.length > 1\">\r\n            {{breadcrumb.label}}\r\n        </span>\r\n    </span>\r\n</div>" }]
        }], ctorParameters: () => [{ type: i1.ActivatedRoute }, { type: i1.Router }] });

class ButtonComponent {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.1", ngImport: i0, type: ButtonComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.1", type: ButtonComponent, selector: "cl-button", inputs: { isPrimary: "isPrimary", text: "text", icon: "icon", tooltip: "tooltip", isDisabled: "isDisabled" }, ngImport: i0, template: "<button class=\"btn\"\n        [ngClass]=\"isPrimary ? 'btn-primary' : 'btn-default'\"\n        [title]=\"tooltip\"\n        [disabled]=\"isDisabled\">\n  <span aria-hidden=\"true\">{{text}}</span>\n  <span *ngIf=\"icon\" aria-hidden=\"true\">&nbsp;&nbsp;<i class=\"fas fa-{{icon}}\"></i></span>\n</button>", dependencies: [{ kind: "directive", type: i1$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.1", ngImport: i0, type: ButtonComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cl-button', template: "<button class=\"btn\"\n        [ngClass]=\"isPrimary ? 'btn-primary' : 'btn-default'\"\n        [title]=\"tooltip\"\n        [disabled]=\"isDisabled\">\n  <span aria-hidden=\"true\">{{text}}</span>\n  <span *ngIf=\"icon\" aria-hidden=\"true\">&nbsp;&nbsp;<i class=\"fas fa-{{icon}}\"></i></span>\n</button>" }]
        }], propDecorators: { isPrimary: [{
                type: Input
            }], text: [{
                type: Input
            }], icon: [{
                type: Input
            }], tooltip: [{
                type: Input
            }], isDisabled: [{
                type: Input
            }] } });

const CustomHttpHeaders = {
    "dateRevive": "Date-Revive",
    "disableSpinner": "Disable-Spinner",
    "sessionExpiration": "X-Session-Expiration",
    "suppressedErrorCodes": "Suppressed-Error-Codes",
    "utcDate": "Utc-Date"
};

var SecurityType;
(function (SecurityType) {
    SecurityType["blank"] = "00000000-0000-0000-0000-000000000000";
    SecurityType["api"] = "3E79C3A4-B97D-40E5-A169-F4DC1C074E67";
    SecurityType["campusLogic"] = "4297A597-7EB5-4202-8DA0-6843F2E8AA6A";
    SecurityType["donor"] = "4B1B9228-EB47-4C5A-A4EF-69C2A1B6EB04";
    SecurityType["employee"] = "4C1ABF7F-0C96-40E1-AF82-B787093DC889";
    SecurityType["externalReviewer"] = "FBDD135F-310F-427C-813D-EF821396608A";
    SecurityType["parent"] = "C48467CF-3598-422F-80E2-CC3D741D27F9";
    SecurityType["student"] = "27E06782-F64F-47ED-8F94-0B1F52B6AE5B";
})(SecurityType || (SecurityType = {}));
class SecurityTypeHelper {
    static { this.getDisplayName = (id) => {
        switch (id) {
            case SecurityType.blank:
                return 'Blank';
            case SecurityType.api:
                return 'Api';
            case SecurityType.campusLogic:
                return 'CampusLogic';
            case SecurityType.donor:
                return 'Donor';
            case SecurityType.employee:
                return 'Employee';
            case SecurityType.externalReviewer:
                return 'ExternalReviewer';
            case SecurityType.parent:
                return 'Parent';
            case SecurityType.student:
                return 'Student';
            default:
                return '';
        }
    }; }
}

class ContainerComponent {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.1", ngImport: i0, type: ContainerComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.1", type: ContainerComponent, selector: "cl-container", ngImport: i0, template: '<router-outlet></router-outlet>', isInline: true, dependencies: [{ kind: "directive", type: i1.RouterOutlet, selector: "router-outlet", inputs: ["name"], outputs: ["activate", "deactivate", "attach", "detach"], exportAs: ["outlet"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.1", ngImport: i0, type: ContainerComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'cl-container',
                    template: '<router-outlet></router-outlet>',
                }]
        }] });

class CustomModalBaseComponent {
    constructor() {
        this.visible = false;
    }
    activate() {
        this.visible = true;
        let promise = new Promise(resolve => {
            this.onClose = (data) => {
                resolve(data);
                this.visible = false;
            };
        });
        return promise;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.1", ngImport: i0, type: CustomModalBaseComponent, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.1", type: CustomModalBaseComponent, inputs: { id: "id", visible: "visible" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.1", ngImport: i0, type: CustomModalBaseComponent, decorators: [{
            type: Directive
        }], ctorParameters: () => [], propDecorators: { id: [{
                type: Input
            }], visible: [{
                type: Input
            }] } });

/**
 * The one stop shop for all your custom modal needs.
 */
class CustomModalService {
    constructor() {
        this.modals = [];
    }
    /**
     * Adds modal to array of active modals.
     * @param modal The modal to add.
     */
    add(modal) {
        this.modals.push(modal);
    }
    /**
     * Removes modal from array of active modals.
     * @param id The ID of the modal component to remove.
     */
    remove(id) {
        this.modals = this.modals.filter(x => x.id !== id);
    }
    /**
     * Activates the modal for interaction.
     * @param id The ID of the modal component to activate.
     */
    activate(id) {
        let modal = this.modals.find(x => x.id === id);
        return modal.activate();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.1", ngImport: i0, type: CustomModalService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.1", ngImport: i0, type: CustomModalService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.1", ngImport: i0, type: CustomModalService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [] });

class DownloadService {
    downloadBlob(blob, fileName) {
        if (!blob)
            return;
        const element = document.createElement('a');
        const url = URL.createObjectURL(blob);
        if (fileName)
            element.download = fileName;
        element.href = url;
        element.click();
        URL.revokeObjectURL(url);
    }
    downloadResponse(httpResponse) {
        // look for filename
        const fileName = httpResponse.headers.get('content-disposition')?.split(';')
            .find(value => value.trim().startsWith('filename'))?.split('=')[1].replace(/"/g, '');
        this.downloadBlob(httpResponse.body, fileName ?? null);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.1", ngImport: i0, type: DownloadService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.1", ngImport: i0, type: DownloadService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.1", ngImport: i0, type: DownloadService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

class ErrorValidationMessageComponent {
    constructor() { }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.1", ngImport: i0, type: ErrorValidationMessageComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.1", type: ErrorValidationMessageComponent, selector: "cl-error-validation-message", inputs: { accessibilityMessage: "accessibilityMessage", message: "message" }, ngImport: i0, template: "<span class=\"form-required\" role=\"alert\" attr.aria-label=\"Error: {{ accessibilityMessage ? accessibilityMessage : message }}\">\n  <span aria-hidden=\"true\"><i class=\"fa fa-exclamation-circle\"></i>&nbsp;&nbsp;{{message}}</span>\n</span>" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.1", ngImport: i0, type: ErrorValidationMessageComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cl-error-validation-message', template: "<span class=\"form-required\" role=\"alert\" attr.aria-label=\"Error: {{ accessibilityMessage ? accessibilityMessage : message }}\">\n  <span aria-hidden=\"true\"><i class=\"fa fa-exclamation-circle\"></i>&nbsp;&nbsp;{{message}}</span>\n</span>" }]
        }], ctorParameters: () => [], propDecorators: { accessibilityMessage: [{
                type: Input
            }], message: [{
                type: Input
            }] } });

var ModalType;
(function (ModalType) {
    ModalType[ModalType["confirmation"] = 0] = "confirmation";
    ModalType[ModalType["dialog"] = 1] = "dialog";
    ModalType[ModalType["navigation"] = 2] = "navigation";
    ModalType[ModalType["okcancel"] = 3] = "okcancel";
    ModalType[ModalType["publish"] = 4] = "publish";
    ModalType[ModalType["confirmCancel"] = 5] = "confirmCancel";
    ModalType[ModalType["continueCancel"] = 6] = "continueCancel";
    ModalType[ModalType["confirmCancelHtml"] = 7] = "confirmCancelHtml";
})(ModalType || (ModalType = {}));

class ModalService {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.1", ngImport: i0, type: ModalService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.1", ngImport: i0, type: ModalService, providedIn: "root" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.1", ngImport: i0, type: ModalService, decorators: [{
            type: Injectable,
            args: [{ "providedIn": "root" }]
        }] });

class ImageUploadModalComponent {
    constructor(modalService) {
        this.modalService = modalService;
        this.outputImgWidth = 256;
        this.outputImgHeight = 256;
        this.uploadSuccess = new EventEmitter();
        // Use this if you need to use the FileName in your blobUploader callback
        this.fileNameOut = new EventEmitter();
        this.imageUrl$ = new Subject();
        this.zoom = 100;
        this.onDragLeaveImageView = (ev) => this.imageView.nativeElement.classList.remove('drag-over');
        this.closeModal = () => this.show$.next(false);
    }
    ngOnInit() {
        // set image scaling variables based on the desired dimensions
        this.scaledRatio = this.outputImgWidth / this.outputImgHeight;
        this.outputIsLandscape = (this.outputImgWidth >= this.outputImgHeight);
        this.scaledWidth = (this.outputIsLandscape) ? 256 : (256 * this.scaledRatio);
        this.scaledHeight = (this.outputIsLandscape) ? (this.scaledWidth / this.scaledRatio) : 256;
        this.scaledWidthOffset = (this.outputIsLandscape) ? -128 : Math.ceil(this.scaledWidth / -2);
        this.scaledHeightOffset = (this.outputIsLandscape) ? Math.ceil(this.scaledHeight / -2) : -128;
    }
    ngAfterViewInit() {
        const module = this;
        this.imageDragger.nativeElement.addEventListener('touchstart', (ev) => {
            ev.preventDefault();
            if (ev.targetTouches.length === 0)
                return;
            // We currently don't support multiple touch points, but instead acknowledge only the first one.
            const touchItem = ev.targetTouches.item(0);
            module.lastTouchY = touchItem.clientY;
            module.lastTouchX = touchItem.clientX;
            module.touchItemId = touchItem.identifier;
        });
        this.imageDragger.nativeElement.addEventListener('touchmove', (ev) => {
            ev.preventDefault();
            if (ev.changedTouches.length === 0)
                return;
            let touchItem;
            let n = 0;
            let trav;
            for (n = 0; n < ev.changedTouches.length; n++) {
                trav = ev.changedTouches.item(n);
                if (trav.identifier === module.touchItemId) {
                    touchItem = trav;
                    break;
                }
            }
            if (touchItem === null)
                return;
            const diffX = module.lastTouchX - touchItem.clientX;
            const diffY = module.lastTouchY - touchItem.clientY;
            module.lastTouchX = touchItem.clientX;
            module.lastTouchY = touchItem.clientY;
            module.repositionImage(module, diffX, diffY);
        });
        this.imageDragger.nativeElement.addEventListener('touchend', (ev) => {
            this.resetTouchItemId(ev, module);
        });
        this.imageDragger.nativeElement.addEventListener('touchcancel', (ev) => {
            this.resetTouchItemId(ev, module);
        });
    }
    onDragOverImageView(ev) {
        ev.preventDefault();
        this.imageView.nativeElement.classList.add('drag-over');
    }
    onDropOnImageView(ev) {
        ev.preventDefault();
        if (this.movingImage)
            return;
        this.imageView.nativeElement.classList.remove('drag-over');
        const dataTransfer = ev.dataTransfer;
        if (!dataTransfer) {
            console.log('missing dataTransfer attribute');
            return;
        }
        if (dataTransfer.files.length === 0) {
            console.log('no items found in dataTransfer attribute');
            return;
        }
        if (dataTransfer.files.length > 1) {
            this.modalService.activate(ModalType.dialog, 'You may select only one file', 'An error occurred.');
            return;
        }
        const file = dataTransfer.files[0];
        if (!file) {
            console.log('failed to get file object');
            return;
        }
        this.bindToFile(file);
    }
    fileSelected(ev) {
        if (!ev.currentTarget) {
            console.log('expected currentTarget to be set');
            return;
        }
        const files = ev.currentTarget.files;
        if (!files || files.length === 0) {
            console.log('file list is empty or invalid');
            return;
        }
        if (files.length > 1) {
            this.modalService.activate(ModalType.dialog, 'You may select only one file', 'An error occurred.');
            return;
        }
        this.bindToFile(files[0]);
    }
    bindToFile(file) {
        switch (file.type) {
            case 'image/png':
            case 'image/jpg':
            case 'image/jpeg':
                break;
            default:
                {
                    this.modalService.activate(ModalType.dialog, 'Unsupported image type.  Please choose an image of type .png, .jpeg, or .jpg', 'An error occurred.');
                    return;
                }
        }
        this.imageView.nativeElement.classList.remove('empty');
        this.imagePreview.nativeElement.classList.remove('empty');
        this.cropBox.nativeElement.classList.remove('empty');
        this.imageDragger.nativeElement.classList.remove('empty');
        this.fileName = file.name;
        this.fileType = file.type;
        const reader = new FileReader();
        const module = this;
        // We use a temporary Image object to interrogate the dropped image to determine its dimensions so that we can size
        // everything and set our orientation properly.
        const img = new Image();
        img.onload = () => {
            let startX = 0;
            let startY = 0;
            if ((img.naturalWidth / img.naturalHeight) < (this.outputImgWidth / this.outputImgHeight)) {
                // The image we have passed in is more portrait-y than the crop space
                //  o Min Zoom - height of image equals height of crop area.
                //  o Max Zoom - width of image equals width of crop area.
                module.minHeight = module.cropBox.nativeElement.clientHeight;
                module.maxWidth = module.cropBox.nativeElement.clientWidth;
                module.minWidth = Math.floor((module.minHeight * img.naturalWidth) / (img.naturalHeight));
                module.maxHeight = Math.floor((module.maxWidth * img.naturalHeight) / (img.naturalWidth));
                // start positions for max:
                startX = module.cropBox.nativeElement.offsetLeft;
                startY = ((module.cropBox.nativeElement.clientHeight - module.maxHeight) / 2) + module.cropBox.nativeElement.offsetTop;
            }
            else {
                // The image we have passed in is more landscape-y than the crop space
                //  o Min Zoom - width of image equals width of crop area.
                //  o Max Zoom - height of image equals height of crop area.
                module.minWidth = module.cropBox.nativeElement.clientWidth;
                module.maxHeight = module.cropBox.nativeElement.clientHeight;
                module.maxWidth = Math.floor((module.maxHeight * img.naturalWidth) / (img.naturalHeight));
                module.minHeight = Math.floor((module.minWidth * img.naturalHeight) / (img.naturalWidth));
                // start positions for max:
                startX = ((module.cropBox.nativeElement.clientWidth - module.maxWidth) / 2) + module.cropBox.nativeElement.offsetLeft;
                startY = module.cropBox.nativeElement.offsetTop;
            }
            module.imagePreview.nativeElement.style.cssText = `width: ${module.maxWidth}px; height: ${module.maxHeight}px; margin-left: ${startX}px; margin-top: ${startY}px; top: 50%; left: 50%;`;
            module.lastX = startX;
            module.lastY = startY;
            module.imageUrl$.next(img.src);
            module.imageChanged = true;
            module.zoomSlider.nativeElement.value = 100;
        };
        reader.onload = (e) => img.src = e.target.result;
        reader.readAsDataURL(file);
        this.fileBrowser.nativeElement.value = null;
    }
    zoomChange(ev) {
        // The image naturally fits inside the crop window; nothing to crop.
        if (this.maxHeight <= this.cropBox.nativeElement.clientHeight && this.maxWidth <= this.cropBox.nativeElement.clientWidth)
            return;
        const height = this.minHeight + ((this.zoomSlider.nativeElement.value / 100) * (this.maxHeight - this.minHeight));
        const width = this.minWidth + ((this.zoomSlider.nativeElement.value / 100) * (this.maxWidth - this.minWidth));
        this.lastX = this.lastX + ((this.imagePreview.nativeElement.clientWidth - width) / 2);
        this.lastY = this.lastY + ((this.imagePreview.nativeElement.clientHeight - height) / 2);
        this.imagePreview.nativeElement.style.cssText = 'width: ' + width + 'px; height: ' + height + 'px; margin-left: ' + this.lastX + 'px; margin-top: ' + this.lastY + 'px; top: 50%; left: 50%;';
    }
    onImageDraggerMouseDown(ev) {
        ev.preventDefault();
        const module = this;
        module.movingImage = true;
        module.draggerMouseX = ev.clientX;
        module.draggerMouseY = ev.clientY;
        document.onmouseup = onImageDraggerMouseUp;
        document.onmousemove = onImageDraggerMouseMove;
        function onImageDraggerMouseUp(event) {
            event.preventDefault();
            /* stop moving when mouse button is released: */
            document.onmouseup = null;
            document.onmousemove = null;
            module.movingImage = false;
        }
        function onImageDraggerMouseMove(mouseMoveEv) {
            if (!module.movingImage)
                return;
            mouseMoveEv.preventDefault();
            // calculate the new cursor position:
            const newX = module.draggerMouseX - mouseMoveEv.clientX;
            const newY = module.draggerMouseY - mouseMoveEv.clientY;
            module.draggerMouseX = mouseMoveEv.clientX;
            module.draggerMouseY = mouseMoveEv.clientY;
            module.repositionImage(module, newX, newY);
        }
    }
    repositionImage(module, xDelta, yDelta) {
        module.lastX = parseFloat(module.imagePreview.nativeElement.style.marginLeft) - xDelta;
        module.lastY = parseFloat(module.imagePreview.nativeElement.style.marginTop) - yDelta;
        module.imagePreview.nativeElement.style.marginLeft = `${module.lastX}px`;
        module.imagePreview.nativeElement.style.marginTop = `${module.lastY}px`;
    }
    onSubmitForm() {
        const img = this.imagePreview.nativeElement;
        // We use canvas to crop the image.  Canvas requires us to provide the native image dimensions
        // as well as the target dimensions, which may be zoomed.  We use the following ratio to
        // convert between the two sets of dimensions.
        const ratio = img.clientWidth / img.naturalWidth;
        const left = this.cropBox.nativeElement.offsetLeft - this.imagePreview.nativeElement.offsetLeft;
        const top = this.cropBox.nativeElement.offsetTop - this.imagePreview.nativeElement.offsetTop;
        const previewLeft = this.imagePreview.nativeElement.offsetLeft;
        const cropLeft = this.cropBox.nativeElement.offsetLeft;
        const previewWidth = this.imagePreview.nativeElement.clientWidth;
        const cropWidth = this.cropBox.nativeElement.clientWidth;
        const previewRight = previewLeft + previewWidth;
        const cropRight = cropLeft + cropWidth;
        // ratio should never be smaller than 1 so we don't blow up images beyond their native size
        const dstRatio = Math.max(Math.min(this.outputImgWidth, img.naturalWidth) / cropWidth, 1);
        let srcX = 0;
        let dstX = 0;
        let srcY = 0;
        let dstY = 0;
        if (left < 0) {
            srcX = 0;
            dstX = Math.abs(left);
        }
        else {
            srcX = left / ratio;
            dstX = 0;
        }
        if (top < 0) {
            srcY = 0;
            dstY = Math.abs(top);
        }
        else {
            srcY = top / ratio;
            dstY = 0;
        }
        // scale position offsets of the destination image
        dstX = dstX * dstRatio;
        dstY = dstY * dstRatio;
        let dstWidth = 0;
        let dstHeight = 0;
        // Determine the destination width
        if (previewLeft < cropLeft && previewRight >= cropRight)
            // case 1 image left <= crop left and image right >= crop right
            // --> desired width = crop width
            dstWidth = cropWidth;
        else if (previewLeft <= cropLeft && previewRight < cropRight)
            // case 2 image left <= crop left and image right < crop right
            // --> desired width = image right - crop left
            dstWidth = previewRight - cropLeft;
        else if (previewLeft > cropLeft && previewRight >= cropRight)
            // case 3 image left > crop left and image right >= crop right
            // --> desired width = crop right - image left
            dstWidth = cropRight - previewLeft;
        else
            // case 4 image left > crop left and image right < crop right
            // --> desired width = image width
            dstWidth = previewWidth;
        const previewTop = this.imagePreview.nativeElement.offsetTop;
        const cropTop = this.cropBox.nativeElement.offsetTop;
        const previewHeight = this.imagePreview.nativeElement.clientHeight;
        const cropHeight = this.cropBox.nativeElement.clientHeight;
        const previewBottom = previewTop + previewHeight;
        const cropBottom = cropTop + cropHeight;
        // Determine the destination height
        if (previewTop < cropTop && previewBottom >= cropBottom)
            // case 1 image Top <= crop Top and image Bottom >= crop Bottom
            // --> desired Height = crop Height
            dstHeight = cropHeight;
        else if (previewTop <= cropTop && previewBottom < cropBottom)
            // case 2 image Top <= crop Top and image Bottom < crop Bottom
            // --> desired Height = image Bottom - crop Top
            dstHeight = previewBottom - cropTop;
        else if (previewTop > cropTop && previewBottom >= cropBottom)
            // case 3 image Top > crop Top and image Bottom >= crop Bottom
            // --> desired Height = crop Bottom - image Top
            dstHeight = cropBottom - previewTop;
        else
            // case 4 image Top > crop Top and image Bottom < crop Bottom
            // --> desired Height = image Height
            dstHeight = previewHeight;
        let srcWidth = dstWidth / ratio;
        let srcHeight = dstHeight / ratio;
        // scale output image dimensions
        dstHeight = dstHeight * dstRatio;
        dstWidth = dstWidth * dstRatio;
        // Let's trim off any rounding errors that would cause the image to exceed the supported
        // bounds, even to the slightest degree; in some environments, including iOS 9.3, that will
        // cause images to render completely transparent.
        if ((srcX + srcWidth) > img.naturalWidth)
            srcWidth = img.naturalWidth - srcX;
        if ((srcY + srcHeight) > img.naturalHeight)
            srcHeight = img.naturalHeight - srcY;
        if ((dstX + dstWidth) > (cropWidth * dstRatio))
            dstWidth = (cropWidth * dstRatio) - dstX;
        if ((dstY + dstHeight) > (cropHeight * dstRatio))
            dstHeight = (cropHeight * dstRatio) - dstY;
        // Create a canvas that we will use to crop the image.
        const canvas = document.createElement('canvas');
        canvas.id = 'myCanvas';
        const context = canvas.getContext('2d');
        // The dimensions of the canvas should match the crop box, since that dictates the size of the output image.
        canvas.width = cropWidth * dstRatio;
        canvas.height = cropHeight * dstRatio;
        if (context !== null) {
            context.clearRect(0, 0, canvas.width, canvas.height);
            // Crop and draw the image into the canvas.
            context.drawImage(img, srcX, srcY, srcWidth, srcHeight, dstX, dstY, dstWidth, dstHeight);
        }
        // We specifically use .png as it supports transparency.
        const mimType = 'image/png';
        // Now, we need to convert the image into a blob.  On most browsers, we can take advantage of canvas.toBlob().
        // However, this is not supported in edge, in which case we have to manually do the conversion.
        this.fileNameOut.emit(this.fileName);
        if (typeof canvas.toBlob !== 'undefined')
            // Cool, the function is supported; let's convert to blob and then do the upload...
            canvas.toBlob(this.blobUploader, mimType);
        else {
            // Unfortunately, this browser doesn't support canvas.toBlob().  Instead, we take advantage of canvas.toDataURL(),
            // which has wider support.  We will then have to do some work to convert that string into a blob.
            const dataUrl = canvas.toDataURL(mimType);
            // here's what the dataUrl looks like:
            // data: [<mediatype>][;base64],<data>
            //
            // To get the base-64 encoded data, we just look for the comma and grab the rest.
            let dataString = dataUrl.split(',')[1];
            // Convert from base-64 to a byte-encoded string.
            dataString = atob(dataString);
            // Now convert to an actual byte array.
            const ab = new ArrayBuffer(dataString.length);
            const ia = new Uint8Array(ab);
            for (let i = 0; i < dataString.length; i++)
                ia[i] = dataString.charCodeAt(i);
            // Finally, construct our blob.
            const blob = new Blob([ab], { type: mimType });
            this.blobUploader(blob);
        }
    }
    resetTouchItemId(ev, module) {
        if (module !== null) {
            ev.preventDefault();
            module.touchItemId = null;
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.1", ngImport: i0, type: ImageUploadModalComponent, deps: [{ token: ModalService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.1", type: ImageUploadModalComponent, selector: "cl-image-upload-modal", inputs: { show$: "show$", blobUploader: "blobUploader", outputImgWidth: "outputImgWidth", outputImgHeight: "outputImgHeight", title: "title" }, outputs: { uploadSuccess: "uploadSuccess", fileNameOut: "fileNameOut" }, viewQueries: [{ propertyName: "cropBox", first: true, predicate: ["cropbox"], descendants: true }, { propertyName: "imagePreview", first: true, predicate: ["imagePreview"], descendants: true }, { propertyName: "zoomSlider", first: true, predicate: ["zoomSlider"], descendants: true }, { propertyName: "fileBrowser", first: true, predicate: ["fileBrowser"], descendants: true }, { propertyName: "imageDragger", first: true, predicate: ["imageDragger"], descendants: true }, { propertyName: "imageView", first: true, predicate: ["imageView"], descendants: true }], ngImport: i0, template: "<kendo-dialog *ngIf=\"(show$ | async)\" id=\"containerEditAvatar\" [title]=\"title\" (close)=\"closeModal()\">\n    <form #f=\"ngForm\" (ngSubmit)=\"onSubmitForm()\">\n        <div class=\"kendo-dialog-body mb-2\">\n            <div class=\"image-view empty\" #imageView id=\"image-view\" (drop)=\"onDropOnImageView($event)\" (dragover)=\"onDragOverImageView($event)\" (dragleave)=\"onDragLeaveImageView($event)\">\n                <img class=\"image-preview empty\" #imagePreview id=\"image-preview\" [src]=\"(imageUrl$ | async)\" />\n                <div class=\"crop-box empty\" #cropbox id=\"crop-box\" [ngStyle]=\"{'width': scaledWidth + 'px', 'height': scaledHeight + 'px', 'margin-left': scaledWidthOffset + 'px', 'margin-top': scaledHeightOffset + 'px' }\"></div>\n                <div class=\"image-dragger empty\" #imageDragger id=\"image-dragger\" (mousedown)=\"onImageDraggerMouseDown($event)\"></div>\n            </div>\n            <div class=\"image-zoom-slider\" *ngIf=\"fileName\">\n                <input id=\"zoomSlider\" #zoomSlider type=\"range\" min=\"0\" max=\"100\" step=\"1\" (input)=\"zoomChange($event)\" (change)=\"zoomChange($event)\" />\n            </div>\n            <input type=\"file\" id=\"fileBrowser\" #fileBrowser accept=\"image/png, image/jpeg, image/gif\" (change)=\"fileSelected($event)\" />\n            <button id=\"buttonBrowse\" class=\"btn btn-primary\" (click)=\"fileBrowser.click()\" type=\"button\">Browse...</button>\n        </div>\n\n        <kendo-dialog-actions layout=\"end\">\n            <span id=\"buttonContainer\" class=\"text-right inline-block\">\n                <button id=\"buttonSave\" class=\"btn btn-primary\" [disabled]=\"!imageChanged\" type=\"submit\">Save</button>\n                <button id=\"buttonCancel\" class=\"btn btn-default\" (click)=\"closeModal()\" onkeydown=\"if (event.keyCode == 9) { event.preventDefault(); document.getElementsByClassName('k-button k-bare k-button-icon k-window-action k-dialog-action k-dialog-close')[0].focus() }\">Cancel</button>\n            </span>\n        </kendo-dialog-actions>\n    </form>\n</kendo-dialog>\n", styles: [".crop-box{box-shadow:0 0 0 1000px #00000080;position:absolute;left:50%;top:50%}.crop-box.empty{display:none}.image-view{width:322px;height:322px;position:relative;overflow:hidden;background:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKAQMAAAC3/F3+AAAABlBMVEXf39////8zI3BgAAAAEUlEQVQIW2Nk38mIjH5wICMAez4Iyz2C/F8AAAAASUVORK5CYII=);border:1px solid #ccc;margin:1px 12px 1px 1px}.image-view.empty{border:2px dashed #ccc;background:none;margin:1px 12px 1px 1px}.image-view.empty:after{text-align:center;font-size:20px;width:60%;height:100%;margin-left:-30%;padding:48px 20px 0;position:absolute;top:35%;left:50%;content:\"Drag and drop image here\";border-radius:3px;background-clip:padding-box;box-sizing:border-box;color:#999;font-family:Arial,sans-serif}.image-view.empty.drag-over:after{color:#14892c}.image-view.empty.drag-over{border-color:#14892c}.image-preview.empty{visibility:hidden}.image-zoom-slider{padding:0;position:relative;width:260px;vertical-align:middle;margin:20px 5px 10px 25px;height:20px;line-height:20px}.image-dragger{width:100%;height:100%;position:absolute;cursor:move;background-color:transparent;left:0;top:0}.image-dragger.empty{display:none}.mb-2{margin-bottom:8px}.image-zoom-slider:before{content:\"\";left:-25px;width:15px;height:15px;background-size:15px;position:absolute;margin-top:0}.image-zoom-slider:after{content:\"\";right:-40px;width:30px;height:30px;background-size:30px;position:absolute;margin-top:-30px}@media screen and (-ms-high-contrast: active),screen and (-ms-high-contrast: none){.image-zoom-slider:before{content:\"\";left:-25px;width:15px;height:15px;background-size:15px;position:absolute;margin-top:10px}.image-zoom-slider:after{content:\"\";right:-40px;width:30px;height:30px;background-size:30px;position:absolute;margin-top:-60px}}#fileBrowser{display:none}#buttonBrowse{width:75px;margin-top:10px}#buttonSave,#buttonCancel{width:75px}#buttonContainer{width:100%;margin:5px}\n"], dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$1.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { kind: "directive", type: i2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2.NgForm, selector: "form:not([ngNoForm]):not([formGroup]),ng-form,[ngForm]", inputs: ["ngFormOptions"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "component", type: i5.DialogComponent, selector: "kendo-dialog", inputs: ["actions", "actionsLayout", "autoFocusedElement", "title", "width", "minWidth", "maxWidth", "height", "minHeight", "maxHeight", "animation", "themeColor"], outputs: ["action", "close"], exportAs: ["kendoDialog"] }, { kind: "component", type: i5.DialogActionsComponent, selector: "kendo-dialog-actions", inputs: ["actions", "layout"], outputs: ["action"] }, { kind: "pipe", type: i1$1.AsyncPipe, name: "async" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.1", ngImport: i0, type: ImageUploadModalComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cl-image-upload-modal', template: "<kendo-dialog *ngIf=\"(show$ | async)\" id=\"containerEditAvatar\" [title]=\"title\" (close)=\"closeModal()\">\n    <form #f=\"ngForm\" (ngSubmit)=\"onSubmitForm()\">\n        <div class=\"kendo-dialog-body mb-2\">\n            <div class=\"image-view empty\" #imageView id=\"image-view\" (drop)=\"onDropOnImageView($event)\" (dragover)=\"onDragOverImageView($event)\" (dragleave)=\"onDragLeaveImageView($event)\">\n                <img class=\"image-preview empty\" #imagePreview id=\"image-preview\" [src]=\"(imageUrl$ | async)\" />\n                <div class=\"crop-box empty\" #cropbox id=\"crop-box\" [ngStyle]=\"{'width': scaledWidth + 'px', 'height': scaledHeight + 'px', 'margin-left': scaledWidthOffset + 'px', 'margin-top': scaledHeightOffset + 'px' }\"></div>\n                <div class=\"image-dragger empty\" #imageDragger id=\"image-dragger\" (mousedown)=\"onImageDraggerMouseDown($event)\"></div>\n            </div>\n            <div class=\"image-zoom-slider\" *ngIf=\"fileName\">\n                <input id=\"zoomSlider\" #zoomSlider type=\"range\" min=\"0\" max=\"100\" step=\"1\" (input)=\"zoomChange($event)\" (change)=\"zoomChange($event)\" />\n            </div>\n            <input type=\"file\" id=\"fileBrowser\" #fileBrowser accept=\"image/png, image/jpeg, image/gif\" (change)=\"fileSelected($event)\" />\n            <button id=\"buttonBrowse\" class=\"btn btn-primary\" (click)=\"fileBrowser.click()\" type=\"button\">Browse...</button>\n        </div>\n\n        <kendo-dialog-actions layout=\"end\">\n            <span id=\"buttonContainer\" class=\"text-right inline-block\">\n                <button id=\"buttonSave\" class=\"btn btn-primary\" [disabled]=\"!imageChanged\" type=\"submit\">Save</button>\n                <button id=\"buttonCancel\" class=\"btn btn-default\" (click)=\"closeModal()\" onkeydown=\"if (event.keyCode == 9) { event.preventDefault(); document.getElementsByClassName('k-button k-bare k-button-icon k-window-action k-dialog-action k-dialog-close')[0].focus() }\">Cancel</button>\n            </span>\n        </kendo-dialog-actions>\n    </form>\n</kendo-dialog>\n", styles: [".crop-box{box-shadow:0 0 0 1000px #00000080;position:absolute;left:50%;top:50%}.crop-box.empty{display:none}.image-view{width:322px;height:322px;position:relative;overflow:hidden;background:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKAQMAAAC3/F3+AAAABlBMVEXf39////8zI3BgAAAAEUlEQVQIW2Nk38mIjH5wICMAez4Iyz2C/F8AAAAASUVORK5CYII=);border:1px solid #ccc;margin:1px 12px 1px 1px}.image-view.empty{border:2px dashed #ccc;background:none;margin:1px 12px 1px 1px}.image-view.empty:after{text-align:center;font-size:20px;width:60%;height:100%;margin-left:-30%;padding:48px 20px 0;position:absolute;top:35%;left:50%;content:\"Drag and drop image here\";border-radius:3px;background-clip:padding-box;box-sizing:border-box;color:#999;font-family:Arial,sans-serif}.image-view.empty.drag-over:after{color:#14892c}.image-view.empty.drag-over{border-color:#14892c}.image-preview.empty{visibility:hidden}.image-zoom-slider{padding:0;position:relative;width:260px;vertical-align:middle;margin:20px 5px 10px 25px;height:20px;line-height:20px}.image-dragger{width:100%;height:100%;position:absolute;cursor:move;background-color:transparent;left:0;top:0}.image-dragger.empty{display:none}.mb-2{margin-bottom:8px}.image-zoom-slider:before{content:\"\";left:-25px;width:15px;height:15px;background-size:15px;position:absolute;margin-top:0}.image-zoom-slider:after{content:\"\";right:-40px;width:30px;height:30px;background-size:30px;position:absolute;margin-top:-30px}@media screen and (-ms-high-contrast: active),screen and (-ms-high-contrast: none){.image-zoom-slider:before{content:\"\";left:-25px;width:15px;height:15px;background-size:15px;position:absolute;margin-top:10px}.image-zoom-slider:after{content:\"\";right:-40px;width:30px;height:30px;background-size:30px;position:absolute;margin-top:-60px}}#fileBrowser{display:none}#buttonBrowse{width:75px;margin-top:10px}#buttonSave,#buttonCancel{width:75px}#buttonContainer{width:100%;margin:5px}\n"] }]
        }], ctorParameters: () => [{ type: ModalService }], propDecorators: { cropBox: [{
                type: ViewChild,
                args: ['cropbox']
            }], imagePreview: [{
                type: ViewChild,
                args: ['imagePreview']
            }], zoomSlider: [{
                type: ViewChild,
                args: ['zoomSlider']
            }], fileBrowser: [{
                type: ViewChild,
                args: ['fileBrowser']
            }], imageDragger: [{
                type: ViewChild,
                args: ['imageDragger']
            }], imageView: [{
                type: ViewChild,
                args: ['imageView']
            }], show$: [{
                type: Input
            }], blobUploader: [{
                type: Input
            }], outputImgWidth: [{
                type: Input
            }], outputImgHeight: [{
                type: Input
            }], title: [{
                type: Input
            }], uploadSuccess: [{
                type: Output
            }], fileNameOut: [{
                type: Output
            }] } });

class DateReviverInterceptorService {
    constructor() {
        this.datePattern = /^\d{4}-\d{2}-\d{2}((T|\s*)\d{2}:\d{2}:\d{2}(\.\d*)?(Z)?)??$/;
    }
    convertDates(data) {
        if (data instanceof Array)
            data.forEach(e => this.convertDates(e));
        if (data instanceof Object)
            Object.keys(data).forEach(key => {
                let value = data[key];
                if (value instanceof Array)
                    value.forEach(e => this.convertDates(e));
                if (value instanceof Object)
                    this.convertDates(value);
                if (typeof value === 'string' && value != null && this.datePattern.test(value))
                    data[key] = new Date(value);
            });
    }
    intercept(req, next) {
        let headerValue = req.headers.get(CustomHttpHeaders.dateRevive);
        return next.handle(req.clone({ "headers": req.headers.delete(CustomHttpHeaders.dateRevive) })).pipe(tap(httpEvent => {
            if (headerValue && headerValue.length > 0 && httpEvent instanceof HttpResponse)
                this.convertDates(httpEvent.body);
        }));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.1", ngImport: i0, type: DateReviverInterceptorService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.1", ngImport: i0, type: DateReviverInterceptorService, providedIn: "root" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.1", ngImport: i0, type: DateReviverInterceptorService, decorators: [{
            type: Injectable,
            args: [{ "providedIn": "root" }]
        }] });

class ErrorInterceptorService {
    constructor(modalService) {
        this.modalService = modalService;
    }
    intercept(req, next) {
        let suppressedErrorCodes = [];
        let suppressAllErrorCodes = false;
        let headerValue = req.headers.get(CustomHttpHeaders.suppressedErrorCodes);
        if (headerValue && headerValue.length > 0) {
            if (headerValue === '*') {
                suppressAllErrorCodes = true;
            }
            else {
                headerValue.split(',').forEach(token => {
                    let statusCode = parseInt(token);
                    if (!isNaN(statusCode))
                        suppressedErrorCodes.push(parseInt(token));
                });
            }
        }
        return next.handle(req).pipe(catchError(err => {
            if (err instanceof HttpErrorResponse && !suppressAllErrorCodes && !suppressedErrorCodes.includes(err.status))
                switch (err.status) {
                    case 400:
                        let errorMessage = "We could not process your request.  Please try again.";
                        if (err.error && err.error.message && err.error.message.length > 0)
                            errorMessage = err.error.message;
                        this.modalService.activate(ModalType.dialog, errorMessage, "Error");
                        break;
                    case 401:
                        // handled by the redirect interceptor
                        break;
                    case 404:
                        this.modalService.activate(ModalType.dialog, "The requested resource was not found.", "Not Found");
                        break;
                    case 409:
                        this.modalService.activateOptimisticConcurrencyError();
                        break;
                    default:
                        this.modalService.activateUnhandledException(err.error, false);
                }
            return throwError(err);
        }));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.1", ngImport: i0, type: ErrorInterceptorService, deps: [{ token: ModalService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.1", ngImport: i0, type: ErrorInterceptorService, providedIn: "root" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.1", ngImport: i0, type: ErrorInterceptorService, decorators: [{
            type: Injectable,
            args: [{ "providedIn": "root" }]
        }], ctorParameters: () => [{ type: ModalService }] });

class RedirectInterceptorService {
    constructor(authService, router) {
        this.authService = authService;
        this.router = router;
    }
    intercept(req, next) {
        return next.handle(req).pipe(catchError(err => {
            if (err instanceof HttpErrorResponse)
                switch (err.status) {
                    case 401:
                        // If we're not authenticated we need to get the gateway url and redirect
                        this.authService.getAuthInfo()
                            .subscribe(auth => window.location.href = auth.gatewayUrl);
                        break;
                    case 403:
                        // Redirect on unauthorized response
                        this.router.navigate(['/']);
                        break;
                    case 412:
                        //if no rights take them to the 'You are not authorized to view this product' splash page
                        this.router.navigate(['/login/unauthorizedproduct']);
                        break;
                }
            return throwError(err);
        }));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.1", ngImport: i0, type: RedirectInterceptorService, deps: [{ token: AuthenticationService }, { token: i1.Router }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.1", ngImport: i0, type: RedirectInterceptorService, providedIn: "root" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.1", ngImport: i0, type: RedirectInterceptorService, decorators: [{
            type: Injectable,
            args: [{ "providedIn": "root" }]
        }], ctorParameters: () => [{ type: AuthenticationService }, { type: i1.Router }] });

class SessionExpiringModalService {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.1", ngImport: i0, type: SessionExpiringModalService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.1", ngImport: i0, type: SessionExpiringModalService, providedIn: "root" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.1", ngImport: i0, type: SessionExpiringModalService, decorators: [{
            type: Injectable,
            args: [{ "providedIn": "root" }]
        }] });

/*
 *  Indicates time remaining on a session, and watches for expiration to provide the user with
 *  a warning modal.
 */
class SessionService {
    constructor(modalService) {
        this.modalService = modalService;
        this.remainingTime = -1;
        this.modal = null;
        // Watch for changes each second
        setInterval(() => {
            // Update remaining time
            if (this.remainingTime == -1) {
                return;
            }
            this.remainingTime -= 1000;
            if (this.remainingTime <= 1000) {
                this.remainingTime = -1;
                window.location.href = "/login/logout";
                return;
            }
            // Display warning at 2m remaining
            if (this.remainingTime <= 120000) {
                modalService.show();
            }
            else {
                modalService.hide();
            }
        }, 1000);
    }
    /*
     * Sets the time remaining for the session.
     */
    setRemainingTime(value) {
        // Trimming off 5 seconds just for time skew
        this.remainingTime = value - 5000;
    }
    /*
     * Gets the time remaining for the session.
     */
    getRemainingTime() {
        return this.remainingTime;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.1", ngImport: i0, type: SessionService, deps: [{ token: SessionExpiringModalService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.1", ngImport: i0, type: SessionService, providedIn: "root" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.1", ngImport: i0, type: SessionService, decorators: [{
            type: Injectable,
            args: [{ "providedIn": "root" }]
        }], ctorParameters: () => [{ type: SessionExpiringModalService }] });

class SessionTimeoutInterceptorService {
    constructor(sessionService) {
        this.sessionService = sessionService;
    }
    intercept(req, next) {
        return next.handle(req).pipe(tap(httpEvent => {
            if (httpEvent instanceof HttpResponse) {
                // Look for our session timeout info
                let headerValue = httpEvent.headers.get(CustomHttpHeaders.sessionExpiration);
                if (headerValue && headerValue.length > 0) {
                    let timeRemaining = parseInt(headerValue);
                    if (!isNaN(timeRemaining))
                        this.sessionService.setRemainingTime(timeRemaining);
                }
            }
        }));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.1", ngImport: i0, type: SessionTimeoutInterceptorService, deps: [{ token: SessionService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.1", ngImport: i0, type: SessionTimeoutInterceptorService, providedIn: "root" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.1", ngImport: i0, type: SessionTimeoutInterceptorService, decorators: [{
            type: Injectable,
            args: [{ "providedIn": "root" }]
        }], ctorParameters: () => [{ type: SessionService }] });

class SpinnerInterceptorService {
    constructor(router) {
        this.router = router;
        // current version of ng-block-ui seems to be bugged we'll need to track this ourselves
        this.started = false;
        this.requestCount = 0;
        // when using the HttpClient requests to lazy loaded modules do not activate the spinner. activate it by listening for these events.
        this.router.events.subscribe(event => {
            if (event instanceof RouteConfigLoadStart) {
                this.requestCount++;
                if (!this.started) {
                    this.blockUi.start();
                    this.started = true;
                }
            }
            if (event instanceof RouteConfigLoadEnd)
                this.decrementSpinnerCount();
        });
    }
    decrementSpinnerCount() {
        this.requestCount--;
        if (this.requestCount < 0)
            this.requestCount = 0;
        if (this.requestCount === 0 && this.started) {
            this.blockUi.stop();
            this.started = false;
        }
    }
    intercept(req, next) {
        let headerValue = req.headers.get(CustomHttpHeaders.disableSpinner);
        // always increment this. If any request in the chain activates the spinner it will remain on until they're all complete
        this.requestCount++;
        if (headerValue && headerValue.length > 0) {
            // if disableSpinner header is present do nothing
        }
        else if (!this.started) {
            this.blockUi.start();
            this.started = true;
        }
        return next.handle(req.clone({ "headers": req.headers.delete(CustomHttpHeaders.disableSpinner) }))
            .pipe(finalize(() => this.decrementSpinnerCount()));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.1", ngImport: i0, type: SpinnerInterceptorService, deps: [{ token: i1.Router }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.1", ngImport: i0, type: SpinnerInterceptorService, providedIn: "root" }); }
}
__decorate([
    BlockUI()
], SpinnerInterceptorService.prototype, "blockUi", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.1", ngImport: i0, type: SpinnerInterceptorService, decorators: [{
            type: Injectable,
            args: [{ "providedIn": "root" }]
        }], ctorParameters: () => [{ type: i1.Router }], propDecorators: { blockUi: [] } });

class UtcDateInterceptorService {
    constructor() {
        this.datePattern = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z??$/;
    }
    convertDates(data) {
        if (data instanceof Array)
            data.forEach(e => this.convertDates(e));
        if (data instanceof Object)
            Object.keys(data).forEach(key => {
                let value = data[key];
                if (value instanceof Array)
                    value.forEach(e => this.convertDates(e));
                if (value instanceof Object)
                    this.convertDates(value);
                if (typeof value === 'string' && value != null && this.datePattern.test(value)) {
                    data[key] = new Date(value).toLocaleString();
                }
            });
    }
    intercept(req, next) {
        let headerValue = req.headers.get(CustomHttpHeaders.utcDate);
        return next.handle(req.clone({ "headers": req.headers.delete(CustomHttpHeaders.utcDate) })).pipe(tap(httpEvent => {
            if (headerValue && headerValue.length > 0 && httpEvent instanceof HttpResponse) {
                this.convertDates(httpEvent.body);
            }
        }));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.1", ngImport: i0, type: UtcDateInterceptorService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.1", ngImport: i0, type: UtcDateInterceptorService, providedIn: "root" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.1", ngImport: i0, type: UtcDateInterceptorService, decorators: [{
            type: Injectable,
            args: [{ "providedIn": "root" }]
        }] });

class IReleaseNoteService {
}

/**
 * Implements common functionality we generally do with kendo grid data, such as paging,
 * sorting and filtering.  Supports both client-side and server-side paging.
 * */
class KendoGridModel {
    get take() {
        return this.state.take;
    }
    get skip() {
        return this.state.skip;
    }
    set skip(value) {
        this.state.skip = value;
    }
    get sort() {
        return this.state.sort;
    }
    get filter() {
        return this.state.filter;
    }
    constructor(isServerSide = false) {
        this.state = {
            skip: 0,
            take: 10,
            sort: [],
            filter: {
                logic: 'and',
                filters: []
            }
        };
        /**
         * The well-formed object that houses the data and is in the format that the kendo grid expects.
         * */
        this.gridData = null;
        this.sourceData = [];
        this.setFilter(null);
        this.gridData = { data: this.sourceData, total: 0 };
        if (isServerSide) {
            this.refreshEvent = new Subject();
        }
    }
    setFilter(filter) {
        this.state.filter = filter;
    }
    /**
     * Loads the grid with all of the data.  You generally use this for client-side paging.
     *
     * @param sourceData
     * @param goToFirstPage
     */
    setSourceData(sourceData, goToFirstPage) {
        this.sourceData = sourceData;
        if (!this.sourceData) {
            return;
        }
        if (goToFirstPage) {
            this.state.skip = 0;
        }
        this.refreshHandler();
    }
    /**
     * Loads the grid with a page of data.   You generally use this for server-side paging.
     * In addition to the page of data, you also must provide the total count.
     *
     * @param sourceData
     * @param total
     */
    setPageData(sourceData, total) {
        this.sourceData = sourceData;
        if (!this.sourceData) {
            return;
        }
        this.gridData = { data: this.sourceData, total };
    }
    getSourceData() {
        return this.sourceData;
    }
    /**
     * Refreshes the grid.  For server-side paging, we simply invoke the refresh observable
     * so the host can go and get the next page.  For client-side paging, we use the local
     * kendo library to update the grid.
     * */
    refreshHandler() {
        if (this.refreshEvent) {
            this.refreshEvent.next();
        }
        else {
            this.refresh();
        }
    }
    refresh(goToFirstPage) {
        if (goToFirstPage) {
            this.state.skip = 0;
        }
        this.gridData = process(this.sourceData, this.state);
    }
    /**
     * Linking this method to the (pageChange) event in kendo grid will allow us to
     * automatically refresh the data each time the page changes.
     *
     * @param pageChangeEvent
     */
    onPageChange(pageChangeEvent) {
        this.state.take = pageChangeEvent.take;
        this.state.skip = pageChangeEvent.skip;
        this.refreshHandler();
    }
    /**
     * Linking this method to the (sortChange) event in kendo grid will allow us to
     * automatically refresh the data each time the sort changes.
     *
     * @param sortDescriptors
     */
    onSortChange(sortDescriptors) {
        this.state.sort = sortDescriptors;
        this.refreshHandler();
    }
    /**
     * Linking this method to the (dataStateChange) event in kendo grid will allow us to
     * automatically refresh the data each time the grid's state changes.
     *
     * @param state
     */
    onStateChange(state) {
        if (this.lastSkip === state.skip) {
            //This is not a page-change, but is some other kind of change (sort, filter, etc.)
            //For this type of change, we reset to the first page.
            state.skip = 0;
        }
        this.lastSkip = state.skip;
        this.state = state;
        this.refreshHandler();
    }
    /**
     * This method comes in handy for server-side paging.  This method will populate the
     * provided ServerSideSearchOptions dto with all of the necessary information to
     * load the next page of data from the server, based on the current state of the
     * kendo grid.
     *
     * @param searchFilters
     */
    populateServerSideSearchOptions(searchFilters) {
        if (!searchFilters) {
            return;
        }
        searchFilters.populate(this.skip, this.take, this.sort, this.filter);
    }
}

class LoggerService {
    constructor(httpClient, modalService) {
        this.httpClient = httpClient;
        this.modalService = modalService;
    }
    log(message, info) {
        try {
            const dataToLog = {
                message
            };
            if (info) {
                info.forEach((val, key) => {
                    if (val && JSON.stringify(val) === '{}') {
                        const newVal = {};
                        Object.getOwnPropertyNames(val).forEach(p => newVal[p] = val[p]);
                        dataToLog[key] = newVal;
                    }
                    else {
                        dataToLog[key] = val;
                    }
                });
            }
            this.httpClient
                .post(this.routePrefix, dataToLog)
                .subscribe(resp => this.modalService.activateUnhandledException(resp, true));
        }
        catch (e) {
            // swallowing exceptions to avoid recursion in the error hanlder.
        }
    }
}

class LoggerErrorHandler {
    constructor(loggerService, authService) {
        this.loggerService = loggerService;
        this.authService = authService;
        this.errorMap = new Map();
    }
    /**
     * Handles all angular errors that occur within the app by logging it then showing the user an error modal.
     *
     * @param error
     */
    handleError(error) {
        try {
            const currentDate = new Date();
            let msg;
            const info = new Map();
            const isPrimitiveOrArray = ((typeof error !== 'object' && typeof error !== 'function') || error === null) || error instanceof Array;
            if (isPrimitiveOrArray) {
                msg = error.toString();
                info.set('error', error);
            }
            else {
                if (error.toString() === '[object Object]') {
                    msg = JSON.stringify(error);
                    info.set('error', error);
                }
                else {
                    msg = error.stack || error.message || error.toString();
                    info.set('errorMessage', error.message);
                    info.set('errorStack', error.stack);
                    info.set('errorName', error.name);
                }
            }
            const errorMapItemValue = this.errorMap.has(msg) ? this.errorMap.get(msg) : null;
            const shouldLog = error.status != 500 //The error is not a server side error (we already log that)
                && (errorMapItemValue
                    ? errorMapItemValue.getTime() < currentDate.getTime() - 30000 // if it's been longer than a 30 seconds
                    : true // if we have not recieved this error yet
                );
            if (shouldLog) {
                this.errorMap.set(msg, currentDate);
                this.authService.getAuthInfo().subscribe(authInfo => {
                    if (authInfo?.isAuthenticated === true) {
                        this.loggerService.log(msg, info);
                    }
                });
            }
        }
        catch (exception) { }
        console.error(error); // Print it in the console for debug purposes.
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.1", ngImport: i0, type: LoggerErrorHandler, deps: [{ token: LoggerService }, { token: AuthenticationService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.1", ngImport: i0, type: LoggerErrorHandler, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.1", ngImport: i0, type: LoggerErrorHandler, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: LoggerService }, { type: AuthenticationService }] });

const LOGGER_PROVIDER = {
    provide: ErrorHandler,
    useClass: LoggerErrorHandler
};

const MODAL_DIMENSIONS_DEFAULT = { width: 550 };
class ModalComponent {
    constructor(modalService, changeDetector, sanitizer) {
        this.changeDetector = changeDetector;
        this.sanitizer = sanitizer;
        this.modalTypeConfirmation = ModalType.confirmation;
        this.modalTypeDialog = ModalType.dialog;
        this.modalTypeNavigation = ModalType.navigation;
        this.modalTypeOkCancel = ModalType.okcancel;
        this.modalTypePublish = ModalType.publish;
        this.modalTypeConfirmCancel = ModalType.confirmCancel;
        this.modalTypeContinueCancel = ModalType.continueCancel;
        this.modalTypeConfirmCancelHtml = ModalType.confirmCancelHtml;
        this.visible = false;
        this.doNotShowAgain = false;
        this.modalDimensions = MODAL_DIMENSIONS_DEFAULT;
        this.enableInnerHtml = false;
        modalService.activate = this.activate.bind(this);
        modalService.activateOptimisticConcurrencyError = this.activateOptimisticConcurrencyError.bind(this);
        modalService.activateUnhandledException = this.activateUnhandledException.bind(this);
    }
    activate(modalType = this.defaults.ModalType, message = this.defaults.message, title = this.defaults.title, cookie, modalDimensions, enableInnerHtml) {
        this.message = message;
        this.modalType = modalType;
        this.title = title;
        this.cookie = cookie;
        this.visible = true;
        this.errorMessage = null;
        this.doNotShowAgain = false;
        this.enableInnerHtml = enableInnerHtml;
        this.modalDimensions = modalDimensions ?? MODAL_DIMENSIONS_DEFAULT;
        if (modalType === ModalType.confirmCancelHtml) {
            this.message = this.sanitizer.sanitize(SecurityContext.HTML, this.message);
        }
        // when change detection is turned down kendo needs a little help here
        this.changeDetector.detectChanges();
        setTimeout(() => {
            // set focus on buttons for the purpose of submitted with the enter button
            if (this.modalType === ModalType.dialog || this.modalType === ModalType.navigation || this.modalType === ModalType.okcancel) {
                this.buttonOk = document.getElementById('buttonGenericDialogOk');
                this.buttonOk.focus();
            }
            if (this.modalType === ModalType.confirmation) {
                this.buttonYes = document.getElementById('buttonGenericDialogYes');
                this.buttonYes.focus();
            }
            if (this.modalType === ModalType.publish) {
                this.buttonNo = document.getElementById('buttonGenericDialogCancel');
                this.buttonNo.focus();
            }
            if (this.modalType === ModalType.continueCancel) {
                this.buttonContinue = document.getElementById('buttonGenericDialogContinue');
                this.buttonContinue.focus();
            }
        });
        let promise = new Promise(resolve => {
            this.negativeOnClick = () => {
                resolve(false);
                this.visible = false;
            };
            this.positiveOnClick = () => {
                // Set the cookie if checked
                if (this.cookie && this.doNotShowAgain) {
                    localStorage.setItem(cookie, "true");
                }
                resolve(true);
                this.visible = false;
            };
        });
        return promise;
    }
    activateOptimisticConcurrencyError() {
        let onModalClose = () => {
            window.location.reload();
        };
        this.activate(ModalType.dialog, ("The record you attempted to edit was modified by another user while you were making your edits. You will need to re-enter your changes and save again."), ("Error"))
            .then(onModalClose, onModalClose);
    }
    activateUnhandledException(error, detectChanges) {
        // Don't overwrite the current error if we're already showing an error.
        if (this.visible) {
            return;
        }
        let detect = () => {
            if (detectChanges) {
                this.changeDetector.detectChanges();
            }
        };
        this.activate(ModalType.dialog, null, ("Error")).then(detect, detect);
        let messages = [];
        if (error.origin != null)
            messages.push("Origin: " + error.origin);
        if (error.timeStamp)
            messages.push("Time Stamp: " + error.timeStamp);
        if (error.errorId)
            messages.push("Error ID: " + error.errorId);
        if (error.code)
            messages.push("Code: " + error.code);
        if (error.message)
            messages.push("Message: " + error.message);
        if (error.exceptionMessage)
            messages.push("Exception Message: " + error.exceptionMessage);
        if (error.exceptionType)
            messages.push("Exception Type: " + error.exceptionType);
        if (error.stackTrace)
            messages.push("Stack Trace: " + error.stackTrace);
        this.errorMessage = messages.join("\n");
        detect();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.1", ngImport: i0, type: ModalComponent, deps: [{ token: ModalService }, { token: i0.ChangeDetectorRef }, { token: i2$1.DomSanitizer }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.1", type: ModalComponent, selector: "cl-modal", ngImport: i0, template: "<input id=\"unexpected-error-modal-visible\" type=\"hidden\" value=\"{{visible && errorMessage != null}}\" />\n<kendo-dialog id=\"dialog-generic\" *ngIf=\"visible\" [title]=\"title\" [width]=\"modalDimensions.width\" [height]=\"modalDimensions.height\" (close)=\"negativeOnClick()\">\n    <div id=\"dialog-body\">\n        <p *ngIf=\"message != null && modalType != modalTypeConfirmCancelHtml && !enableInnerHtml\">{{message}}</p>\n        <span *ngIf=\"message != null && (modalType == modalTypeConfirmCancelHtml || enableInnerHtml)\" [innerHTML]=\"message\"></span>\n        <div *ngIf=\"errorMessage != null\">\n            <p>\n                An unexpected error occurred.\n                Please reference the following information when contacting support about the issue:\n            </p>\n            <pre style=\"max-height: 650px;\" id=\"unexpected-error-modal-error-message\">{{ errorMessage }}</pre>\n        </div>\n        <div *ngIf=\"cookie\" style=\"float:right;margin-top:20px;\">\n            <input type=\"checkbox\" id=\"cookieCheckbox\" name=\"cookieCheckbox\" class=\"k-checkbox\" [(ngModel)]=\"doNotShowAgain\" />\n            <label class=\"k-checkbox-label\" for=\"cookieCheckbox\">Don't show again</label>\n        </div>\n    </div>\n    <kendo-dialog-actions layout=\"end\">\n        <button id=\"buttonGenericDialogOk\"\n                class=\"btn btn-primary\"\n                style=\"width: 75px;\" primary=\"true\"\n                *ngIf=\"modalType == modalTypeDialog || modalType == modalTypeNavigation || modalType == modalTypeOkCancel\"\n                (click)=\"positiveOnClick()\">\n            Ok\n        </button>\n        <button id=\"buttonGenericDialogOk\"\n                class=\"btn btn-primary\"\n                style=\"width: 75px;\" primary=\"true\"\n                *ngIf=\"modalType == modalTypeConfirmCancel || modalType == modalTypeConfirmCancelHtml\"\n                (click)=\"positiveOnClick()\">\n            Confirm\n        </button>\n        <button id=\"buttonGenericDialogYes\"\n                class=\"btn btn-primary\"\n                style=\"width: 75px;\" primary=\"true\"\n                *ngIf=\"modalType == modalTypeConfirmation\"\n                (click)=\"positiveOnClick()\">\n            Yes\n        </button>\n        <button id=\"buttonGenericDialogNo\"\n                class=\"btn btn-default\"\n                style=\"width: 75px;\" primary=\"true\"\n                *ngIf=\"modalType == modalTypeConfirmation\"\n                (click)=\"negativeOnClick()\">\n            No\n        </button>\n        <button id=\"buttonGenericDialogCancel\"\n                class=\"btn btn-default\"\n                style=\"width: 75px;\" primary=\"true\"\n                *ngIf=\"modalType == modalTypeOkCancel || modalType == modalTypePublish || modalType == modalTypeConfirmCancel || modalType == modalTypeContinueCancel || modalType == modalTypeConfirmCancelHtml\"\n                (click)=\"negativeOnClick()\">\n            Cancel\n        </button>\n        <button id=\"buttonGenericDialogGoBack\"\n                class=\"btn btn-default\"\n                style=\"width:75px;\" primary=\"true\"\n                *ngIf=\"modalType == modalTypeNavigation\"\n                (click)=\"negativeOnClick()\">\n            Go Back\n        </button>\n        <button id=\"buttonGenericDialogPublish\"\n                class=\"btn btn-primary\"\n                style=\"width: 75px;\" primary=\"true\"\n                *ngIf=\"modalType == modalTypePublish\"\n                (click)=\"positiveOnClick()\">\n            Publish\n        </button>\n        <button id=\"buttonGenericDialogContinue\"\n                class=\"btn btn-primary\"\n                style=\"width: 75px;\" primary=\"true\"\n                *ngIf=\"modalType == modalTypeContinueCancel\"\n                (click)=\"positiveOnClick()\">\n            Continue\n        </button>\n    </kendo-dialog-actions>\n</kendo-dialog>", dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.CheckboxControlValueAccessor, selector: "input[type=checkbox][formControlName],input[type=checkbox][formControl],input[type=checkbox][ngModel]" }, { kind: "directive", type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "component", type: i5.DialogComponent, selector: "kendo-dialog", inputs: ["actions", "actionsLayout", "autoFocusedElement", "title", "width", "minWidth", "maxWidth", "height", "minHeight", "maxHeight", "animation", "themeColor"], outputs: ["action", "close"], exportAs: ["kendoDialog"] }, { kind: "component", type: i5.DialogActionsComponent, selector: "kendo-dialog-actions", inputs: ["actions", "layout"], outputs: ["action"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.1", ngImport: i0, type: ModalComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cl-modal', template: "<input id=\"unexpected-error-modal-visible\" type=\"hidden\" value=\"{{visible && errorMessage != null}}\" />\n<kendo-dialog id=\"dialog-generic\" *ngIf=\"visible\" [title]=\"title\" [width]=\"modalDimensions.width\" [height]=\"modalDimensions.height\" (close)=\"negativeOnClick()\">\n    <div id=\"dialog-body\">\n        <p *ngIf=\"message != null && modalType != modalTypeConfirmCancelHtml && !enableInnerHtml\">{{message}}</p>\n        <span *ngIf=\"message != null && (modalType == modalTypeConfirmCancelHtml || enableInnerHtml)\" [innerHTML]=\"message\"></span>\n        <div *ngIf=\"errorMessage != null\">\n            <p>\n                An unexpected error occurred.\n                Please reference the following information when contacting support about the issue:\n            </p>\n            <pre style=\"max-height: 650px;\" id=\"unexpected-error-modal-error-message\">{{ errorMessage }}</pre>\n        </div>\n        <div *ngIf=\"cookie\" style=\"float:right;margin-top:20px;\">\n            <input type=\"checkbox\" id=\"cookieCheckbox\" name=\"cookieCheckbox\" class=\"k-checkbox\" [(ngModel)]=\"doNotShowAgain\" />\n            <label class=\"k-checkbox-label\" for=\"cookieCheckbox\">Don't show again</label>\n        </div>\n    </div>\n    <kendo-dialog-actions layout=\"end\">\n        <button id=\"buttonGenericDialogOk\"\n                class=\"btn btn-primary\"\n                style=\"width: 75px;\" primary=\"true\"\n                *ngIf=\"modalType == modalTypeDialog || modalType == modalTypeNavigation || modalType == modalTypeOkCancel\"\n                (click)=\"positiveOnClick()\">\n            Ok\n        </button>\n        <button id=\"buttonGenericDialogOk\"\n                class=\"btn btn-primary\"\n                style=\"width: 75px;\" primary=\"true\"\n                *ngIf=\"modalType == modalTypeConfirmCancel || modalType == modalTypeConfirmCancelHtml\"\n                (click)=\"positiveOnClick()\">\n            Confirm\n        </button>\n        <button id=\"buttonGenericDialogYes\"\n                class=\"btn btn-primary\"\n                style=\"width: 75px;\" primary=\"true\"\n                *ngIf=\"modalType == modalTypeConfirmation\"\n                (click)=\"positiveOnClick()\">\n            Yes\n        </button>\n        <button id=\"buttonGenericDialogNo\"\n                class=\"btn btn-default\"\n                style=\"width: 75px;\" primary=\"true\"\n                *ngIf=\"modalType == modalTypeConfirmation\"\n                (click)=\"negativeOnClick()\">\n            No\n        </button>\n        <button id=\"buttonGenericDialogCancel\"\n                class=\"btn btn-default\"\n                style=\"width: 75px;\" primary=\"true\"\n                *ngIf=\"modalType == modalTypeOkCancel || modalType == modalTypePublish || modalType == modalTypeConfirmCancel || modalType == modalTypeContinueCancel || modalType == modalTypeConfirmCancelHtml\"\n                (click)=\"negativeOnClick()\">\n            Cancel\n        </button>\n        <button id=\"buttonGenericDialogGoBack\"\n                class=\"btn btn-default\"\n                style=\"width:75px;\" primary=\"true\"\n                *ngIf=\"modalType == modalTypeNavigation\"\n                (click)=\"negativeOnClick()\">\n            Go Back\n        </button>\n        <button id=\"buttonGenericDialogPublish\"\n                class=\"btn btn-primary\"\n                style=\"width: 75px;\" primary=\"true\"\n                *ngIf=\"modalType == modalTypePublish\"\n                (click)=\"positiveOnClick()\">\n            Publish\n        </button>\n        <button id=\"buttonGenericDialogContinue\"\n                class=\"btn btn-primary\"\n                style=\"width: 75px;\" primary=\"true\"\n                *ngIf=\"modalType == modalTypeContinueCancel\"\n                (click)=\"positiveOnClick()\">\n            Continue\n        </button>\n    </kendo-dialog-actions>\n</kendo-dialog>" }]
        }], ctorParameters: () => [{ type: ModalService }, { type: i0.ChangeDetectorRef }, { type: i2$1.DomSanitizer }] });

class NotAuthorizedComponent {
    constructor() { }
    ngOnInit() {
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.1", ngImport: i0, type: NotAuthorizedComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.1", type: NotAuthorizedComponent, selector: "cl-not-authorized", ngImport: i0, template: "<main class=\"row not-authorized-background\">\n    <div class=\"col-xs-12\">\n        <div class=\"not-authorized-label\">\n            <h1><strong><i class=\"fas fa-ban\" aria-hidden=\"true\"></i>&nbsp;<span role=\"alert\">Not\n                        Authorized</span>&nbsp;<i class=\"fas fa-ban\" aria-hidden=\"true\"></i></strong></h1>\n        </div>\n    </div>\n</main>\n", styles: [".not-authorized-background{text-align:center;background:repeating-linear-gradient(45deg,#b00020,#b00020 10px,#fff 10px 20px);margin-top:5px}.not-authorized-label{background-color:#b00020;color:#fff;display:inline-block;padding:0 12px}\n"] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.1", ngImport: i0, type: NotAuthorizedComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cl-not-authorized', template: "<main class=\"row not-authorized-background\">\n    <div class=\"col-xs-12\">\n        <div class=\"not-authorized-label\">\n            <h1><strong><i class=\"fas fa-ban\" aria-hidden=\"true\"></i>&nbsp;<span role=\"alert\">Not\n                        Authorized</span>&nbsp;<i class=\"fas fa-ban\" aria-hidden=\"true\"></i></strong></h1>\n        </div>\n    </div>\n</main>\n", styles: [".not-authorized-background{text-align:center;background:repeating-linear-gradient(45deg,#b00020,#b00020 10px,#fff 10px 20px);margin-top:5px}.not-authorized-label{background-color:#b00020;color:#fff;display:inline-block;padding:0 12px}\n"] }]
        }], ctorParameters: () => [] });

var PushNotificationPermissionEnum;
(function (PushNotificationPermissionEnum) {
    PushNotificationPermissionEnum["default"] = "default";
    PushNotificationPermissionEnum["granted"] = "granted";
    PushNotificationPermissionEnum["denied"] = "denied"; // the user has denied push notifications
})(PushNotificationPermissionEnum || (PushNotificationPermissionEnum = {}));

class PushNotificationSubscription {
}

var PushNotificationDeviceTypeEnum;
(function (PushNotificationDeviceTypeEnum) {
    PushNotificationDeviceTypeEnum[PushNotificationDeviceTypeEnum["WebBrowser"] = 0] = "WebBrowser";
    // Future:
    // Android = 1,
    // iOS = 2
})(PushNotificationDeviceTypeEnum || (PushNotificationDeviceTypeEnum = {}));

class PushNotificationService {
    constructor(http, activatedRoute, router) {
        this.http = http;
        this.activatedRoute = activatedRoute;
        this.router = router;
        this.routePrefix = 'api/pushnotification';
        // Used to notify whenever the push permission/subscription changes.
        this._permissionChanged = new BehaviorSubject(PushNotificationPermissionEnum.default);
        // Holds the current push permission/subscription.  See PushPermissionEnum for
        // possible values.
        this._permission = PushNotificationPermissionEnum.default;
        this._initialized = false;
        this._config = null;
        /**
         * Gets the configuration for push notifications for the current client/product.
         */
        this.getConfig = () => this.http.get(`${this.routePrefix}/config`).pipe(shareReplay(1));
        /**
         * Creates/updates the subscription for the given device.  We do this when (a) the user is subscribed
         * and (b) we detect changes in their subscription config.
         * @param deviceId
         * Uniquely identifies the device.  For web push, this is a unique identifier the provider generates for
         * the particular browser/origin on the user's device.  So a different browser or a different origin (product)
         * on the same physical device would get a distinct deviceId.
         * @param subscription
         * Contains information about the subscription.  Much of this is provider specific.
         * @returns
         */
        this.updatePushSubscription = (deviceId, subscription) => this.http.post(`${this.routePrefix}/subscription/${deviceId}`, subscription, {
            headers: new HttpHeaders({ [CustomHttpHeaders.disableSpinner]: 'Y' }),
        });
        /**
         * Deletes the subscription on the given device.  We should do this when the user unsubscribes from
         * push notifications.
         * @param deviceId
         * Uniquely identifies the device.  For web push, this is a unique identifier the provider generates for
         * the particular browser/origin on the user's device.  So a different browser or a different origin (product)
         * on the same physical device would get a distinct deviceId.
         */
        this.deletePushSubscription = (deviceId) => this.http.delete(`${this.routePrefix}/subscription/${deviceId}`, {
            headers: new HttpHeaders({ [CustomHttpHeaders.disableSpinner]: 'Y' }),
        });
        /**
         * Gets the subscription for the given device from the server.
         * @param deviceId
         * Uniquely identifies the device.  For web push, this is a unique identifier the provider generates for
         * the particular browser/origin on the user's device.  So a different browser or a different origin (product)
         * on the same physical device would get a distinct deviceId.
         */
        this.getPushSubscription = (deviceId) => this.http.get(`${this.routePrefix}/subscription/${deviceId}`, {
            headers: new HttpHeaders({ [CustomHttpHeaders.disableSpinner]: 'Y' }),
        });
    }
    /**
     * Notifies whenever the push permission/subscription changes.
     */
    get permissionChanged() {
        return this._permissionChanged.asObservable();
    }
    /**
     * Returns the current permission for push notifications as we understand it.
     */
    get permission() {
        return this._permission;
    }
    get isPushNotificationsSupported() {
        return OneSignal && OneSignal.isPushNotificationsSupported();
    }
    get isInitialized() {
        return this._initialized;
    }
    get config() {
        return this._config;
    }
    /**
     * Initializes everything for push notifications.  Should be called only one time from a top-
     * level component of the SPA.  After this method is called, the user is free to subscribe,
     * unsubscribe, and receive push notifications.
     */
    async startup(userId) {
        if (!userId || !userId.length) {
            throw "invalid userId";
        }
        this._config = await this.getConfig().pipe(first()).toPromise();
        if (!this._config.isEnabled) {
            console.log('Push Notifications are not enabled for this client/product');
            return;
        }
        OneSignal.push(() => {
            console.log('Setting OneSignal external userId to ' + userId);
            OneSignal.setExternalUserId(userId);
        });
        const initConfig = {
            // This is the most important piece of information required to configure
            // OneSignal - this is the OneSignal appId assigned to this particular
            // origin (client/product)
            appId: this._config.pushAppId,
            // OneSignal has their own button that hovers over the application.  This
            // button is enabled by default, and we don't want it, so we turn it off.
            notifyButton: {
                enable: false,
            },
            // By default, when a push-notification is clicked, OneSignal will open a
            // new tab unless it can find one whose URL EXACTLY matches (query params
            // and all).  Ugh.  That's no good.  We rather would like to focus on any
            // tab whose origin (domain + subdomain) matches.
            notificationClickHandlerMatch: 'origin',
            // Further reinforce that the behavior we want when a click occurs is not to
            // open a new tab, but rather to focus on the existing tab that matches, if any.
            notificationClickHandlerAction: 'focus',
            // Webhook config for OneSignal
            // https://documentation.onesignal.com/docs/webhooks
            webhooks: {
                cors: false,
                'notification.displayed': this._config.webhookUrl,
                'notification.clicked': this._config.webhookUrl,
                'notification.dismissed': this._config.webhookUrl,
            },
        };
        // Declare a reference to ourself b/c a lot of the OneSignal stuff is done
        // in pure javascript callbacks.
        const self = this;
        OneSignal.push(() => {
            // You can use trace logging if you're stuck on why OneSignal aint workin'!!!
            OneSignal.log.setLevel('warn'); // Switch to trace when debugging
            // One thing to keep in mind with service workers is that you can only have one
            // service worker per scope (path).  Another thing to keep in mind is that the
            // service worker manages EVERYTHING in regards to PWAs - from push notifications
            // to caching.  Okay, what am I getting at here?  Well, given that we're using
            // OneSignal's service worker to manage push notifications, what happens when
            // we later want to introduce other PWA features like caching?  We'll need to
            // add a new service worker, but won't it conflict with OneSignal?
            //
            // Fortunately, the browser allows more than one service worker, so long as each
            // service worker is assigned to its own scope/path.  Give this, what OneSignal
            // recommends is to install their service worker into a subfolder, and set the
            // scope to that path.  This way, if we ever have to introduce a new service
            // worker in the future, it won't conflict.
            //
            // https://documentation.onesignal.com/docs/onesignal-service-worker-faq
            // Custom Code Setup - Service Worker Customizations
            OneSignal.SERVICE_WORKER_PARAM = { scope: '/push/onesignal/' };
            OneSignal.SERVICE_WORKER_PATH = 'push/onesignal/OneSignalSDKWorker.js';
            OneSignal.SERVICE_WORKER_UPDATER_PATH = 'push/onesignal/OneSignalSDKUpdaterWorker.js';
            OneSignal.init(initConfig);
        });
        OneSignal.push(['getNotificationPermission', (permission) => {
                self.handleNotificationPermissionChange(permission);
            }]);
        OneSignal.push(() => {
            OneSignal.on('notificationPermissionChange', (permissionChange) => {
                self.handleNotificationPermissionChange(permissionChange.to);
            });
        });
        OneSignal.push(() => {
            // Occurs when the user's subscription changes to a new value.
            OneSignal.on('subscriptionChange', (isSubscribed) => {
                console.log('Push-Notification subscription state is now:', isSubscribed);
                self.reconcileConfig();
            });
        });
        OneSignal.push(() => {
            self.reconcileConfig();
        });
        this.registerForNotificationClick();
        // Finally, here is some sample code to handle an edge case.  In testing,
        // we somehow got OneSignal into a bad state and the service worker wouldn't
        // install.  The only way to fix was to install their service worker directly
        // as a workaround:
        //navigator.serviceWorker.register(' https://localhost:44364/push/onesignal/OneSignalSDKWorker.js?appId=88a2ec55-6a47-422d-bf2d-feec4ebf5a67?sdkVersion=151512 https://localhost:44364/push/onesignal/', { scope: '/push/onesignal/' });
        console.log('Push Notifications Initialized');
        this._initialized = true;
    }
    registerForNotificationClick() {
        const router = this.router;
        const activatedRoute = this.activatedRoute;
        OneSignal.push(() => {
            const onNotificationClicked = function (data) {
                if (data && data.url) {
                    const host = window.location.host;
                    const idx = data.url.indexOf(host);
                    console.log('host=' + window.location.host);
                    console.log('url=' + data.url);
                    if (idx >= 0) {
                        let route = data.url.substring(idx + host.length, data.url.length);
                        console.log('route=' + route);
                        const parsed = router.parseUrl(route);
                        const idx2 = route.indexOf('?');
                        if (idx2 >= 0) {
                            route = route.substring(0, idx2);
                        }
                        router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
                            router.navigate([route], {
                                queryParams: parsed.queryParams,
                                relativeTo: activatedRoute
                            });
                        });
                    }
                }
            };
            const handler = function (data) {
                console.log('begin notification clicked');
                onNotificationClicked(data);
                console.log('end notification clicked');
                console.log('re-registering');
                OneSignal.addListenerForNotificationOpened(handler);
            };
            // attach your handler for the first time
            OneSignal.addListenerForNotificationOpened(handler);
        });
    }
    /**
     * Compares the current OneSignal config and subscription status against what we have at
     * the server.  Updates if necessary.
     * */
    async reconcileConfig() {
        const promise = await Promise.all([
            OneSignal.getUserId(),
            OneSignal.isPushNotificationsEnabled(),
            OneSignal.getRegistrationId()
        ]);
        let deviceId = promise[0];
        let isSubscribed = promise[1];
        let pushEndpointUrl = promise[2];
        let userAgent = navigator.userAgent;
        let config = JSON.parse(JSON.stringify(OneSignal.config));
        if (config.userConfig) {
            // We don't need these properties since we don't leverage OneSignal's UI
            delete config.userConfig.notifyButton;
            delete config.userConfig.promptOptions;
        }
        // Keep here for debugging:
        // console.log('deviceId: ' + deviceId);
        // console.log('isSubscribed: ' + isSubscribed);
        // console.log('registration id: ' + pushEndpointUrl);
        // console.log('config: ' + JSON.stringify(config));
        if (deviceId) {
            this.getPushSubscription(deviceId).subscribe(subscription => {
                let somethingChanged = false;
                if (subscription) {
                    if (subscription.pushEndpointUrl != pushEndpointUrl) {
                        subscription.pushEndpointUrl = pushEndpointUrl;
                        somethingChanged = true;
                    }
                    if (JSON.stringify(config) != JSON.stringify(subscription.config)) {
                        subscription.config = config;
                        somethingChanged = true;
                    }
                    if (userAgent != subscription.userAgent) {
                        subscription.userAgent = userAgent;
                        somethingChanged = true;
                    }
                }
                else {
                    if (isSubscribed) {
                        subscription = new PushNotificationSubscription();
                        subscription.deviceType = PushNotificationDeviceTypeEnum.WebBrowser;
                        subscription.config = config;
                        subscription.pushEndpointUrl = pushEndpointUrl;
                        subscription.userAgent = userAgent;
                        somethingChanged = true;
                    }
                }
                if (!isSubscribed && subscription) {
                    this.deletePushSubscription(deviceId).subscribe();
                }
                else if (somethingChanged) {
                    delete subscription.userAgent;
                    this.updatePushSubscription(deviceId, subscription).subscribe();
                }
            });
        }
    }
    handleNotificationPermissionChange(permission) {
        console.log('Site Notification Permission:', permission); // 'default', 'granted', or 'denied'
        this._permission = permission;
        this._permissionChanged.next(permission);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.1", ngImport: i0, type: PushNotificationService, deps: [{ token: i1$2.HttpClient }, { token: i1.ActivatedRoute }, { token: i1.Router }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.1", ngImport: i0, type: PushNotificationService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.1", ngImport: i0, type: PushNotificationService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: i1$2.HttpClient }, { type: i1.ActivatedRoute }, { type: i1.Router }] });

/*
 * This component serves two purposes:
 * (1) Show the current permission/subscription for push notifications.
 * (2) Provide basic tools to allow the user to more easily manage the subscription.
 */
class PushNotificationsSubscriberComponent {
    constructor(modalService, pushNotificationService) {
        this.modalService = modalService;
        this.pushNotificationService = pushNotificationService;
        this.pushNotifySetupClass = 'fa fa-bell fa-2x';
        this.pushNotifyTooltip = 'test';
    }
    ngOnInit() {
        const self = this;
        this.pushNotificationService.permissionChanged.subscribe(permission => {
            this.handleNotificationPermissionChange(permission);
        });
    }
    get showComponent() {
        return this.pushNotificationService.isPushNotificationsSupported && this.pushNotificationService.isInitialized;
    }
    handleNotificationPermissionChange(permission) {
        switch (permission) {
            case PushNotificationPermissionEnum.denied:
                this.pushNotifySetupClass = 'fa fa-bell-slash fa-2x';
                this.pushNotifyTooltip = 'Push Notifications are disabled.  Click here to receive instructions on how you can re-enable.';
                break;
            case PushNotificationPermissionEnum.granted:
                this.pushNotifySetupClass = 'fa fa-bell-on fa-2x';
                this.pushNotifyTooltip = 'Push Notifications are enabled.  Click here to customize your notifications.';
                break;
            case PushNotificationPermissionEnum.default:
                this.pushNotifySetupClass = 'far fa-bell fa-2x';
                this.pushNotifyTooltip = 'Click here to enable push notifications.';
                break;
        }
    }
    bellClick(e) {
        const permission = this.pushNotificationService.permission;
        const config = this.pushNotificationService.config;
        switch (permission) {
            case PushNotificationPermissionEnum.denied:
                // Unfortunately, the browser won't let us show the native prompt again.  There's pretty
                // much nothing we can do to automatically resolve the situation for the user.  So instead,
                // we show a modal explaining the situation, with a link to a document that will show them
                // how to re-establish push notifications.
                this.modalService.activate(ModalType.dialog, `Push notifications are currently disallowed for this website on this device.  To re-enable push notifications, please follow the instructions listed <a href="${config.subscribeHelpDocUrl}" target="_blank">here</a>`, 'Push Notifications Disabled', undefined, undefined, true);
                break;
            case PushNotificationPermissionEnum.granted:
                // Navigate to the user profile and automatically select the communications tab.
                window.location.href = '/platform?p=userprofile&tab=Communications';
                break;
            case PushNotificationPermissionEnum.default:
                // At this point, the user hasn't accepted or denied push notifications, and the browser is
                // in a state that will allow us to show the native browser prompt.
                OneSignal.push(() => {
                    OneSignal.showNativePrompt();
                });
                break;
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.1", ngImport: i0, type: PushNotificationsSubscriberComponent, deps: [{ token: ModalService }, { token: PushNotificationService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.1", type: PushNotificationsSubscriberComponent, selector: "cl-push-notifications-subscriber", ngImport: i0, template: "<button *ngIf=\"showComponent\" (click)=\"bellClick($event)\" class=\"bell-button\" [title]=\"pushNotifyTooltip\">\r\n    <i [ngClass]=\"pushNotifySetupClass\" class=\"bell-image\"> </i>\r\n</button>", styles: [".bell-button{margin-left:5px;vertical-align:middle;border:none;background-color:transparent}.bell-image{transform:scale(.8);color:gray;padding:3px}\n"], dependencies: [{ kind: "directive", type: i1$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.1", ngImport: i0, type: PushNotificationsSubscriberComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cl-push-notifications-subscriber', template: "<button *ngIf=\"showComponent\" (click)=\"bellClick($event)\" class=\"bell-button\" [title]=\"pushNotifyTooltip\">\r\n    <i [ngClass]=\"pushNotifySetupClass\" class=\"bell-image\"> </i>\r\n</button>", styles: [".bell-button{margin-left:5px;vertical-align:middle;border:none;background-color:transparent}.bell-image{transform:scale(.8);color:gray;padding:3px}\n"] }]
        }], ctorParameters: () => [{ type: ModalService }, { type: PushNotificationService }] });

class UpdatePushSubscription {
}

//https://forum.ionicframework.com/t/inserting-html-via-angular-2-use-of-domsanitizationservice-bypasssecuritytrusthtml/62562/2
class SafePipe {
    constructor(_sanitizer) {
        this._sanitizer = _sanitizer;
    }
    transform(value, type) {
        switch (type) {
            case 'html':
                return this._sanitizer.bypassSecurityTrustHtml(value);
            case 'style':
                return this._sanitizer.bypassSecurityTrustStyle(value);
            case 'script':
                return this._sanitizer.bypassSecurityTrustScript(value);
            case 'url':
                return this._sanitizer.bypassSecurityTrustUrl(value);
            case 'resourceUrl':
                return this._sanitizer.bypassSecurityTrustResourceUrl(value);
            default:
                throw new Error(`Unable to bypass security for invalid type: ${type}`);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.1", ngImport: i0, type: SafePipe, deps: [{ token: i2$1.DomSanitizer }], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "17.3.1", ngImport: i0, type: SafePipe, name: "safe" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.1", ngImport: i0, type: SafePipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'safe'
                }]
        }], ctorParameters: () => [{ type: i2$1.DomSanitizer }] });

class ReleaseNoteComponent {
    constructor(releaseNoteService) {
        this.releaseNoteService = releaseNoteService;
        this.onDismissed = new EventEmitter(); // Use to to update UI, if needed.
    }
    onDismissReleaseNote() {
        if (this.releaseNote == null)
            return;
        this.releaseNoteService.acknowledgeNotification(this.releaseNote.notificationTypeId, this.releaseNote.audienceTypeId)
            .pipe(tap$1(() => {
            this.releaseNote = null;
            this.onDismissed.emit();
        })).subscribe();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.1", ngImport: i0, type: ReleaseNoteComponent, deps: [{ token: IReleaseNoteService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.1", type: ReleaseNoteComponent, selector: "cl-release-note", inputs: { releaseNote: "releaseNote" }, outputs: { onDismissed: "onDismissed" }, ngImport: i0, template: "<div class=\"alert settings-main-tile-color\" id=\"release-note-container\" *ngIf=\"releaseNote\">\n  <i class=\"fa fa-info-circle\"></i>\n  <span tabindex=\"0\" id=\"release-note\">{{releaseNote.message}} <a tabindex=\"0\" class=\"alert-link\" [href]=\"releaseNote.releaseNoteUrl\" target=\"_blank\">{{releaseNote.releaseNoteUrlText}}</a></span>\n  <button aria-label=\"Release Note Close\" tabindex=\"0\" class=\"close\" id=\"button-dismmiss-release-note\" (click)=\"onDismissReleaseNote()\"><i aria-hidden=\"true\" class=\"fa fa-times\"></i></button>\n</div>", styles: ["a:focus{color:#fff}\n", "a:hover{color:#fff}\n", ".alert{align-items:center;display:flex;margin-bottom:10px}\n", "span{flex-grow:1;margin:0 5px}\n"], dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.1", ngImport: i0, type: ReleaseNoteComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cl-release-note', template: "<div class=\"alert settings-main-tile-color\" id=\"release-note-container\" *ngIf=\"releaseNote\">\n  <i class=\"fa fa-info-circle\"></i>\n  <span tabindex=\"0\" id=\"release-note\">{{releaseNote.message}} <a tabindex=\"0\" class=\"alert-link\" [href]=\"releaseNote.releaseNoteUrl\" target=\"_blank\">{{releaseNote.releaseNoteUrlText}}</a></span>\n  <button aria-label=\"Release Note Close\" tabindex=\"0\" class=\"close\" id=\"button-dismmiss-release-note\" (click)=\"onDismissReleaseNote()\"><i aria-hidden=\"true\" class=\"fa fa-times\"></i></button>\n</div>", styles: ["a:focus{color:#fff}\n", "a:hover{color:#fff}\n", ".alert{align-items:center;display:flex;margin-bottom:10px}\n", "span{flex-grow:1;margin:0 5px}\n"] }]
        }], ctorParameters: () => [{ type: IReleaseNoteService }], propDecorators: { releaseNote: [{
                type: Input
            }], onDismissed: [{
                type: Output
            }] } });

var AudienceTypesEnum;
(function (AudienceTypesEnum) {
    AudienceTypesEnum[AudienceTypesEnum["EmployeesOnly"] = 1] = "EmployeesOnly";
    AudienceTypesEnum[AudienceTypesEnum["StudentsOnly"] = 2] = "StudentsOnly";
    AudienceTypesEnum[AudienceTypesEnum["All"] = 3] = "All";
})(AudienceTypesEnum || (AudienceTypesEnum = {}));

var NotificationTypesEnum;
(function (NotificationTypesEnum) {
    NotificationTypesEnum[NotificationTypesEnum["ReleaseNote"] = 1] = "ReleaseNote";
    NotificationTypesEnum[NotificationTypesEnum["PrivacyPolicyUpdate"] = 2] = "PrivacyPolicyUpdate";
})(NotificationTypesEnum || (NotificationTypesEnum = {}));

class PrivacyPolicyComponent {
    constructor(releaseNoteService) {
        this.releaseNoteService = releaseNoteService;
    }
    onDismissPrivacyPolicy() {
        if (this.privacyPolicy != null) {
            this.releaseNoteService.acknowledgeNotification(this.privacyPolicy.notificationTypeId, this.privacyPolicy.audienceTypeId)
                .subscribe(() => this.privacyPolicy = null);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.1", ngImport: i0, type: PrivacyPolicyComponent, deps: [{ token: IReleaseNoteService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.1", type: PrivacyPolicyComponent, selector: "cl-privacy-policy", inputs: { privacyPolicy: "privacyPolicy" }, ngImport: i0, template: "<div class=\"container-fluid alert\" id=\"privacy-policy-container\" *ngIf=\"privacyPolicy\">\n    <div class=\"row\">\n        <div class=\"col-xs-12\">\n            <div style=\"display:flex;\">\n                <span tabindex=\"0\" id=\"privacy-policy\"><i class=\"fa fa-info-circle\"></i> {{privacyPolicy.message}} <a tabindex=\"0\" class=\"alert-link\" [href]=\"privacyPolicy.releaseNoteUrl\" target=\"\">{{privacyPolicy.releaseNoteUrlText}}</a></span>\n                <button aria-label=\"Privacy Policy Close\" class=\"close\" tabindex=\"0\" id=\"button-dismiss-privacy-policy\" (click)=\"onDismissPrivacyPolicy()\"><i aria-hidden=\"true\" class=\"fa fa-times\"></i></button>\n            </div>\n        </div>\n    </div>\n</div>\n", styles: ["a:focus{color:#fff}\n", "a:hover{color:#fff}\n", ".alert{color:#fff;background:#0009;z-index:9999999999;bottom:0;position:fixed;width:100%;min-height:50px;max-height:500px;margin:0;border-radius:0;font-size:14px}\n", "span{margin-left:5px;flex-grow:1;text-align:center}\n", "button{margin-left:20px}\n"], dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.1", ngImport: i0, type: PrivacyPolicyComponent, decorators: [{
            type: Component,
            args: [{ changeDetection: ChangeDetectionStrategy.OnPush, selector: 'cl-privacy-policy', template: "<div class=\"container-fluid alert\" id=\"privacy-policy-container\" *ngIf=\"privacyPolicy\">\n    <div class=\"row\">\n        <div class=\"col-xs-12\">\n            <div style=\"display:flex;\">\n                <span tabindex=\"0\" id=\"privacy-policy\"><i class=\"fa fa-info-circle\"></i> {{privacyPolicy.message}} <a tabindex=\"0\" class=\"alert-link\" [href]=\"privacyPolicy.releaseNoteUrl\" target=\"\">{{privacyPolicy.releaseNoteUrlText}}</a></span>\n                <button aria-label=\"Privacy Policy Close\" class=\"close\" tabindex=\"0\" id=\"button-dismiss-privacy-policy\" (click)=\"onDismissPrivacyPolicy()\"><i aria-hidden=\"true\" class=\"fa fa-times\"></i></button>\n            </div>\n        </div>\n    </div>\n</div>\n", styles: ["a:focus{color:#fff}\n", "a:hover{color:#fff}\n", ".alert{color:#fff;background:#0009;z-index:9999999999;bottom:0;position:fixed;width:100%;min-height:50px;max-height:500px;margin:0;border-radius:0;font-size:14px}\n", "span{margin-left:5px;flex-grow:1;text-align:center}\n", "button{margin-left:20px}\n"] }]
        }], ctorParameters: () => [{ type: IReleaseNoteService }], propDecorators: { privacyPolicy: [{
                type: Input
            }] } });

class AuthGuard {
    constructor(authService) {
        this.authService = authService;
        this.canLoad = () => this.authService.getAuthInfo().pipe(tap(authInfo => {
            if (authInfo.isAuthenticated === false)
                window.location.href = authInfo.gatewayUrl;
        }), map(e => e.isAuthenticated));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.1", ngImport: i0, type: AuthGuard, deps: [{ token: AuthenticationService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.1", ngImport: i0, type: AuthGuard, providedIn: "root" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.1", ngImport: i0, type: AuthGuard, decorators: [{
            type: Injectable,
            args: [{ "providedIn": "root" }]
        }], ctorParameters: () => [{ type: AuthenticationService }] });

class DeactivateGuard {
    constructor() {
        this.canDeactivate = (component) => component.canDeactivate();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.1", ngImport: i0, type: DeactivateGuard, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.1", ngImport: i0, type: DeactivateGuard, providedIn: "root" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.1", ngImport: i0, type: DeactivateGuard, decorators: [{
            type: Injectable,
            args: [{ "providedIn": "root" }]
        }] });

class SanitizePastedTextDirective {
    constructor(el, control) {
        this.el = el;
        this.control = control;
    }
    onPaste(evt) {
        try {
            if (evt.cleanedHtml) {
                // This is a kendo-paste event.   Just update the cleanedHtml property
                // with sanitized text and we're good.
                evt.cleanedHtml = this.sanitizeText(evt.cleanedHtml);
            }
            else if (evt.clipboardData && evt.target && (evt.target.type === 'textarea' || evt.target.type === 'text') && (evt.target.attributes['formcontrolname']?.value !== 'href')) {
                // This is a standard HTML paste event into a textarea.  Prevent the 
                // event from bubbling further, as we'll update the element directly.
                //Unless element is an href input (SA-663).
                evt.preventDefault();
                // Get the text from the clipboard in plain format.  This actually removes 99% of the
                // of the html.
                const inputData = evt.clipboardData.getData('text/plain');
                // Now, inject the plain text.  
                const s = evt.target.value.substring(0, evt.target.selectionStart)
                    + this.sanitizeText(inputData) // Do additional sanitization
                    + evt.target.value.substring(evt.target.selectionEnd);
                evt.target.value = s;
            }
        }
        catch (e) {
            console.error(e);
        }
    }
    sanitizeText(input) {
        input = input?.trim();
        if (!input || !input.length) {
            return '';
        }
        const regEx = /(<([^>]+)>)/ig;
        if (!regEx.test(input)) {
            // Contains no HTML elements.
            return input;
        }
        const replaced = input.replaceAll('&nbsp;', ' ');
        const doc = new DOMParser().parseFromString(replaced, 'text/xml');
        if (doc.querySelector("parsererror")) {
            // The input HTML wasn't properly formatted, so the DOM Parser failed.  In this 
            // case, we just fall back to poor man's sanitization of removing all html tags
            return input.replace(regEx, '');
        }
        return doc.firstChild.textContent.replace(/\u00a0/g, ' ');
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.1", ngImport: i0, type: SanitizePastedTextDirective, deps: [{ token: i0.ElementRef }, { token: i2.NgControl }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.1", type: SanitizePastedTextDirective, selector: "[clSanitizePastedText]", host: { listeners: { "paste": "onPaste($event)" } }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.1", ngImport: i0, type: SanitizePastedTextDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[clSanitizePastedText]'
                }]
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: i2.NgControl }], propDecorators: { onPaste: [{
                type: HostListener,
                args: ['paste', ['$event']]
            }] } });

class Batch {
}

class MultiBatchResult {
}

class SearchFilter {
}

class SearchFilterItem {
}

class SortItem {
}

class ServerSideSearchOptions {
    static fromKendoState(state) {
        const options = new ServerSideSearchOptions();
        options.populateFromKendoState(state);
        return options;
    }
    static fromKendoParams(skip, take, kendoSort, kendoFilter) {
        const options = new ServerSideSearchOptions();
        options.populate(skip, take, kendoSort, kendoFilter);
        return options;
    }
    static fromKendoGridModel(gridModel) {
        const options = new ServerSideSearchOptions();
        options.populateFromKendoGridModel(gridModel);
        return options;
    }
    populateFromKendoState(state) {
        this.populate(state.skip, state.take, state.sort, state.filter);
    }
    populateFromKendoGridModel(gridModel) {
        this.populate(gridModel.skip, gridModel.take, gridModel.sort, gridModel.filter);
    }
    /**
     * Populates this object based on the provided filter/sort/paging settings that generally come from
     * a kendo grid.
     * @param skip
     * @param take
     * @param kendoSort
     * @param kendoFilter
     */
    populate(skip, take, kendoSort, kendoFilter) {
        this.skip = skip;
        this.take = take;
        if (kendoSort && kendoSort.length > 0) {
            kendoSort.forEach(gridSortItem => {
                {
                    if (gridSortItem.dir && gridSortItem.dir.length > 0) {
                        this.sortItems = new Array(0);
                        let sortItem = new SortItem();
                        sortItem.direction = gridSortItem.dir;
                        sortItem.field = gridSortItem.field;
                        this.sortItems.push(sortItem);
                    }
                }
            });
        }
        if (kendoFilter && kendoFilter.filters && kendoFilter.filters.length > 0) {
            this.filter = new Array();
            kendoFilter.filters.forEach(filter => {
                let c = filter;
                if (!c.filters) {
                    throw "expected CompositeFilterDescriptor";
                }
                let searchFilter = new SearchFilter();
                this.filter.push(searchFilter);
                searchFilter.filterItems = new Array();
                searchFilter.logicOperator = c.logic;
                c.filters.forEach(filter => {
                    let c2 = filter;
                    // Kendo technically supports a filter structure where CompositeFilterDescriptor
                    // may contain descendants that are also CompositeFilterDescriptor.  We currently
                    // don't support this craziness.
                    if (c2.filters) {
                        throw "we currently don't support descendant CompositeFilterDescriptor instances";
                    }
                    let f = filter;
                    let searchFilterItem = new SearchFilterItem();
                    searchFilterItem.field = f.field;
                    searchFilterItem.operator = f.operator;
                    searchFilterItem.value = f.value;
                    searchFilter.filterItems.push(searchFilterItem);
                });
            });
        }
    }
}

/*
 * Modal displayed when a session is expiring so the user can stay logged in or log out.
 */
class SessionExpiringModalComponent {
    constructor(sessionService, modalService, http) {
        this.sessionService = sessionService;
        this.modalService = modalService;
        this.http = http;
        this.visible = false;
        modalService.show = this.show.bind(this);
        modalService.hide = this.hide.bind(this);
    }
    /*
     * Gets the time remaining in a format of M:SS.
     */
    getTimeRemaining() {
        // Break into seconds and minutes
        let seconds = Math.floor(this.sessionService.getRemainingTime() / 1000);
        let minutes = Math.floor(seconds / 60);
        seconds = seconds % 60;
        let time = minutes.toString() + ":";
        if (seconds < 10) {
            time = time + "0";
        }
        return time + seconds.toString();
    }
    /*
     * Shows the session expiring modal.
     */
    show() {
        this.visible = true;
    }
    /*
     * Hides the session expiring modal.
     */
    hide() {
        this.visible = false;
    }
    /*
     * Logs the user out of the system.
     */
    logout() {
        window.location.href = "/login/logout";
    }
    /*
     * Makes a keepalive request to the application to keep the user logged in.
     */
    keepAlive() {
        // Hit the keep alive endpoint
        this.http.get("/login/keepalive").subscribe();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.1", ngImport: i0, type: SessionExpiringModalComponent, deps: [{ token: SessionService }, { token: SessionExpiringModalService }, { token: i1$2.HttpClient }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.1", type: SessionExpiringModalComponent, selector: "cl-session-expiring-modal", ngImport: i0, template: "<kendo-dialog id=\"dialog-session-expiration\" *ngIf=\"visible\" title=\"Inactivity Warning\" (close)=\"logout()\" [width]=\"550\">\n  <div id=\"dialog-session-expiration-body\">\n      <p>Your account has been inactive for too long. If you wish to continue, please indicate so now. Otherwise, you will be logged out in {{getTimeRemaining()}}.</p>\n  </div>\n  <kendo-dialog-actions layout=\"end\">\n    <button id=\"buttonSessionExpirationContinue\" class=\"btn btn-primary\" primary=\"true\" (click)=\"keepAlive()\">Continue</button>\n    <button id=\"buttonSessionExpirationLogout\" class=\"btn btn-default\" primary=\"true\" (click)=\"logout()\">Logout</button>\n  </kendo-dialog-actions>\n</kendo-dialog>", dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i5.DialogComponent, selector: "kendo-dialog", inputs: ["actions", "actionsLayout", "autoFocusedElement", "title", "width", "minWidth", "maxWidth", "height", "minHeight", "maxHeight", "animation", "themeColor"], outputs: ["action", "close"], exportAs: ["kendoDialog"] }, { kind: "component", type: i5.DialogActionsComponent, selector: "kendo-dialog-actions", inputs: ["actions", "layout"], outputs: ["action"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.1", ngImport: i0, type: SessionExpiringModalComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cl-session-expiring-modal', template: "<kendo-dialog id=\"dialog-session-expiration\" *ngIf=\"visible\" title=\"Inactivity Warning\" (close)=\"logout()\" [width]=\"550\">\n  <div id=\"dialog-session-expiration-body\">\n      <p>Your account has been inactive for too long. If you wish to continue, please indicate so now. Otherwise, you will be logged out in {{getTimeRemaining()}}.</p>\n  </div>\n  <kendo-dialog-actions layout=\"end\">\n    <button id=\"buttonSessionExpirationContinue\" class=\"btn btn-primary\" primary=\"true\" (click)=\"keepAlive()\">Continue</button>\n    <button id=\"buttonSessionExpirationLogout\" class=\"btn btn-default\" primary=\"true\" (click)=\"logout()\">Logout</button>\n  </kendo-dialog-actions>\n</kendo-dialog>" }]
        }], ctorParameters: () => [{ type: SessionService }, { type: SessionExpiringModalService }, { type: i1$2.HttpClient }] });

class TimeSpan {
}

class TooltipComponent {
    constructor(changeDetector) {
        this.changeDetector = changeDetector;
        this.iconClick = new EventEmitter();
        this.anchorAlign = { horizontal: 'right', vertical: 'middle' };
        this.popupAlign = { horizontal: 'left', vertical: 'middle' };
        // Tracks whether or not the popup is being initiated due to touch.  If so, we ignore mouse
        // events.  This is especially necessary on platforms such as iOS, where the browser will
        // generate both touch AND mouse events in response to touch.
        this.isTouch = false;
        // We have a separate flag to control showing of the underlying div.  This is to help workaround 
        // a known kendo bug.  When the kendo-popup is added into the DOM, the popup aligment doesn't work
        // consistently.  As a workaround, Telerik recommended we register for the open() event, which will
        // force kendo to invoke detectChanges().  That sort of works, but has the side affect of the 
        // popup visibliy moving into position.  To make it work flawlessly, we hide the underlying div 
        // initially, and then make it visible and invoke detectChanges() directly on the next cycle.
        this.showDiv = false;
        this.showTooltip = false;
    }
    touchStart(event) {
        this.isTouch = true;
        this.popupTouchClick();
    }
    mouseEnter(event) {
        if (this.isTouch) {
            return;
        }
        this.showTooltip = true;
        this.toggleDiv();
    }
    mouseLeave(event) {
        if (this.isTouch) {
            return;
        }
        this.showTooltip = false;
        this.toggleDiv();
    }
    click(event) {
        if (this.isTouch) {
            return;
        }
        this.popupTouchClick();
    }
    popupTouchClick() {
        this.showDiv = false;
        this.showTooltip = !this.showTooltip;
        this.iconClick.emit();
        this.toggleDiv();
    }
    // We have a separate flag to control showing of the underlying div.  This is to help workaround 
    // a known kendo bug.  When the kendo-popup is added into the DOM, the popup aligment doesn't work
    // consistently.  As a workaround, Telerik recommended we register for the open() event, which will
    // force kendo to invoke detectChanges().  That sort of works, but has the side affect of the 
    // popup visibliy moving into position.  To make it work flawlessly, we hide the underlying div 
    // initially, and then make it visible and invoke detectChanges() directly on the next cycle.
    toggleDiv() {
        setTimeout(() => {
            this.showDiv = this.showTooltip;
            this.changeDetector.detectChanges();
        }, 1);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.1", ngImport: i0, type: TooltipComponent, deps: [{ token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.1", type: TooltipComponent, selector: "cl-tooltip", inputs: { message: "message", iconClass: "iconClass", maxWidth: "maxWidth", anchorAlign: "anchorAlign", popupAlign: "popupAlign" }, outputs: { iconClick: "iconClick" }, viewQueries: [{ propertyName: "anchor", first: true, predicate: ["anchor"], descendants: true }], ngImport: i0, template: `
    <i #anchor
    (touchstart)="touchStart($event)"
    (mouseenter)="mouseEnter($event)"
    (mouseleave)="mouseLeave($event)"
    (click)="click($event)"
    [ngClass]="iconClass || 'fa fa-question-circle'"
    style="padding: 0.6rem 0.6rem"
    attr.aria-label={{message}}></i>
    <kendo-popup [animate]="false"
      [anchor]="$any(anchor)"
      [anchorAlign]="anchorAlign"
      [popupAlign]="popupAlign"
      [popupClass]="'su-tooltip'"
      [ngStyle]="maxWidth && { 'white-space': 'normal', 'overflow': 'visible' }"
      *ngIf="showTooltip">
      <div *ngIf="showDiv" [innerHTML]="message | safe: 'html'" [ngStyle]="maxWidth && { 'max-width.px': maxWidth }"></div>
    </kendo-popup>
 `, isInline: true, styles: ["::ng-deep .su-tooltip{padding:5px;margin-left:5px;font-size:18px}\n", ".fa{cursor:pointer}\n"], dependencies: [{ kind: "directive", type: i1$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$1.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { kind: "component", type: i2$2.PopupComponent, selector: "kendo-popup", inputs: ["animate", "anchor", "anchorAlign", "collision", "popupAlign", "copyAnchorStyles", "popupClass", "positionMode", "offset", "margin"], outputs: ["anchorViewportLeave", "close", "open", "positionChange"], exportAs: ["kendo-popup"] }, { kind: "pipe", type: SafePipe, name: "safe" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.1", ngImport: i0, type: TooltipComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cl-tooltip', template: `
    <i #anchor
    (touchstart)="touchStart($event)"
    (mouseenter)="mouseEnter($event)"
    (mouseleave)="mouseLeave($event)"
    (click)="click($event)"
    [ngClass]="iconClass || 'fa fa-question-circle'"
    style="padding: 0.6rem 0.6rem"
    attr.aria-label={{message}}></i>
    <kendo-popup [animate]="false"
      [anchor]="$any(anchor)"
      [anchorAlign]="anchorAlign"
      [popupAlign]="popupAlign"
      [popupClass]="'su-tooltip'"
      [ngStyle]="maxWidth && { 'white-space': 'normal', 'overflow': 'visible' }"
      *ngIf="showTooltip">
      <div *ngIf="showDiv" [innerHTML]="message | safe: 'html'" [ngStyle]="maxWidth && { 'max-width.px': maxWidth }"></div>
    </kendo-popup>
 `, styles: ["::ng-deep .su-tooltip{padding:5px;margin-left:5px;font-size:18px}\n", ".fa{cursor:pointer}\n"] }]
        }], ctorParameters: () => [{ type: i0.ChangeDetectorRef }], propDecorators: { message: [{
                type: Input
            }], iconClass: [{
                type: Input
            }], maxWidth: [{
                type: Input
            }], iconClick: [{
                type: Output
            }], anchorAlign: [{
                type: Input
            }], popupAlign: [{
                type: Input
            }], anchor: [{
                type: ViewChild,
                args: ["anchor"]
            }] } });

class ListOfStringSettingComponent {
    constructor() {
        this.changed = new EventEmitter();
    }
    ngOnInit() {
        if (!this.setting.currentValueListString) {
            this.setting.currentValueListString = [];
        }
        this.valueIsValid = true;
        if (!this.inputAlreadyExistsMessage) {
            this.inputAlreadyExistsMessage = 'That value has already been added';
        }
        if (!this.invalidInputMessage) {
            this.invalidInputMessage = 'That value is not valid';
        }
        if (!this.placeholder) {
            this.placeholder = '';
        }
    }
    sanitizeValue(value) {
        if (!value)
            return '';
        return value.trim();
    }
    checkValueAlreadyExists(value) {
        value = this.sanitizeValue(value);
        return this.setting.currentValueListString
            .some(listString => listString.toLocaleLowerCase() === value.toLocaleLowerCase());
    }
    addValue() {
        this.valueChanged();
        const value = this.sanitizeValue(this.valueToAdd);
        if (this.valueIsValid && value) {
            if (this.checkValueAlreadyExists(value)) {
                this.valueAlreadyExists = true;
                return;
            }
            this.setting.currentValueListString.push(value);
            this.valueToAdd = '';
            this.changed.emit();
        }
    }
    deleteValue(value) {
        value = this.sanitizeValue(value);
        const index = this.setting.currentValueListString.indexOf(value);
        if (index >= 0) {
            this.setting.currentValueListString.splice(index, 1);
            this.changed.emit();
        }
    }
    valueChanged() {
        const value = this.sanitizeValue(this.valueToAdd);
        this.valueAlreadyExists = false;
        this.valueIsValid = true;
        if (this.inputPattern && !value.match(this.inputPattern)) {
            this.valueIsValid = false;
        }
        else if (this.checkValueAlreadyExists(value)) {
            this.valueAlreadyExists = true;
        }
        else {
            this.valueIsValid = true;
        }
    }
    typing() {
        this.valueAlreadyExists = false;
        this.valueIsValid = true;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.1", ngImport: i0, type: ListOfStringSettingComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.1", type: ListOfStringSettingComponent, selector: "cl-list-of-string-setting", inputs: { setting: "setting", invalidInputMessage: "invalidInputMessage", inputPattern: "inputPattern", inputAlreadyExistsMessage: "inputAlreadyExistsMessage", placeholder: "placeholder" }, outputs: { changed: "changed" }, ngImport: i0, template: "<div class=\"col-md-3\">\r\n    <label style=\"display: inline-block\">{{setting.displayName}}</label>&nbsp;\r\n    <cl-tooltip message=\"{{setting.description}}\"></cl-tooltip>\r\n</div>\r\n<div class=\"col-md-3\" style=\"display:flex\">\r\n    <div style=\"width:100%; padding-right:10px\">\r\n        <input id=\"{{setting.settingName}}-input\" type=\"text\" class=\"form-control\" [(ngModel)]=\"valueToAdd\" (input)=\"typing()\" (change)=\"valueChanged()\" (keyup.enter)=\"addValue()\" [placeholder]=\"placeholder\" />\r\n        <span *ngIf=\"!valueIsValid\" class=\"label label-danger\">{{invalidInputMessage}}</span>\r\n        <span *ngIf=\"valueAlreadyExists\" class=\"label label-danger\">{{inputAlreadyExistsMessage}}</span>\r\n    </div>\r\n    <div>\r\n        <button class=\"btn btn-primary\" id=\"add-{{setting.settingName}}\" (click)=\"addValue()\" [disabled]=\"!valueToAdd || valueToAdd.length === 0\">ADD</button>\r\n    </div>\r\n</div>\r\n<div *ngIf=\"setting.currentValueListString.length > 0\" class=\"col-md-6\">\r\n    <span *ngFor=\"let value of setting.currentValueListString\" class=\"tag label label-info\" style=\"background-color: #00aced; font-size:100%; margin: 4px; display:inline-block\">\r\n        <span class=\"tag-value\" id=\"{{setting.settingName}}-tag-value\">{{value}}</span>\r\n        <a id=\"{{setting.settingName}}-tag-value-delete\" style=\"margin-left: 4px\" (click)=\"deleteValue(value)\"><i class=\"fas fa-times\"></i></a>\r\n    </span>\r\n</div>\r\n", styles: [".switch-container{padding-left:0;padding-right:0;padding-top:3px}.edit-button-container{padding-left:0;padding-right:0}.k-numerictextbox{width:100%}.no-gutter{padding-left:0;padding-right:0}.email-container-margin{margin-right:30px}.sms-container-margin{margin-left:30px}.main-toggle-wrapper{padding-top:10px;padding-bottom:10px}.main-toggle{margin-top:7px;padding-right:0}.main-toggle-size{font-size:12px}.main-toggle-label{display:inline-block;padding-left:0}.margin-bottom-30{margin-bottom:30px}.padding-left-0{padding-left:0}.padding-bottom-10{padding-bottom:10px}.setting-text{display:inline-block}@media (min-width: 1350px) and (max-width: 1800px){.col-lg-1{width:12%}}@media (min-width: 1200px) and (max-width: 1350px){.col-lg-1{width:15%}}\n"], dependencies: [{ kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "component", type: TooltipComponent, selector: "cl-tooltip", inputs: ["message", "iconClass", "maxWidth", "anchorAlign", "popupAlign"], outputs: ["iconClick"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.1", ngImport: i0, type: ListOfStringSettingComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cl-list-of-string-setting', template: "<div class=\"col-md-3\">\r\n    <label style=\"display: inline-block\">{{setting.displayName}}</label>&nbsp;\r\n    <cl-tooltip message=\"{{setting.description}}\"></cl-tooltip>\r\n</div>\r\n<div class=\"col-md-3\" style=\"display:flex\">\r\n    <div style=\"width:100%; padding-right:10px\">\r\n        <input id=\"{{setting.settingName}}-input\" type=\"text\" class=\"form-control\" [(ngModel)]=\"valueToAdd\" (input)=\"typing()\" (change)=\"valueChanged()\" (keyup.enter)=\"addValue()\" [placeholder]=\"placeholder\" />\r\n        <span *ngIf=\"!valueIsValid\" class=\"label label-danger\">{{invalidInputMessage}}</span>\r\n        <span *ngIf=\"valueAlreadyExists\" class=\"label label-danger\">{{inputAlreadyExistsMessage}}</span>\r\n    </div>\r\n    <div>\r\n        <button class=\"btn btn-primary\" id=\"add-{{setting.settingName}}\" (click)=\"addValue()\" [disabled]=\"!valueToAdd || valueToAdd.length === 0\">ADD</button>\r\n    </div>\r\n</div>\r\n<div *ngIf=\"setting.currentValueListString.length > 0\" class=\"col-md-6\">\r\n    <span *ngFor=\"let value of setting.currentValueListString\" class=\"tag label label-info\" style=\"background-color: #00aced; font-size:100%; margin: 4px; display:inline-block\">\r\n        <span class=\"tag-value\" id=\"{{setting.settingName}}-tag-value\">{{value}}</span>\r\n        <a id=\"{{setting.settingName}}-tag-value-delete\" style=\"margin-left: 4px\" (click)=\"deleteValue(value)\"><i class=\"fas fa-times\"></i></a>\r\n    </span>\r\n</div>\r\n", styles: [".switch-container{padding-left:0;padding-right:0;padding-top:3px}.edit-button-container{padding-left:0;padding-right:0}.k-numerictextbox{width:100%}.no-gutter{padding-left:0;padding-right:0}.email-container-margin{margin-right:30px}.sms-container-margin{margin-left:30px}.main-toggle-wrapper{padding-top:10px;padding-bottom:10px}.main-toggle{margin-top:7px;padding-right:0}.main-toggle-size{font-size:12px}.main-toggle-label{display:inline-block;padding-left:0}.margin-bottom-30{margin-bottom:30px}.padding-left-0{padding-left:0}.padding-bottom-10{padding-bottom:10px}.setting-text{display:inline-block}@media (min-width: 1350px) and (max-width: 1800px){.col-lg-1{width:12%}}@media (min-width: 1200px) and (max-width: 1350px){.col-lg-1{width:15%}}\n"] }]
        }], propDecorators: { setting: [{
                type: Input
            }], invalidInputMessage: [{
                type: Input
            }], inputPattern: [{
                type: Input
            }], inputAlreadyExistsMessage: [{
                type: Input
            }], placeholder: [{
                type: Input
            }], changed: [{
                type: Output
            }] } });

class StyleColorsService {
    get primaryColor() {
        if (this._primaryColor)
            return this._primaryColor;
        this._primaryColor = this.getElementComputedColor('primary-color');
        return this._primaryColor;
    }
    get secondaryColor() {
        if (this._secondaryColor)
            return this._secondaryColor;
        this._secondaryColor = this.getElementComputedColor('secondary-color');
        return this._secondaryColor;
    }
    constructor(document) {
        // use special css classes we build into our client styles to determine this value
        this._primaryColor = null;
        // use special css classes we build into our client styles to determine this value
        this._secondaryColor = null;
        // this is a workaround becuse you can't inject the Documetn type in a lib project yet
        this._document = document;
    }
    getElementComputedColor(className) {
        // if another element is using the class we need then use that to set the value and return it
        let element = this._document.querySelector(`.${className}`);
        if (element)
            return getComputedStyle(element).color;
        // if not then add an element temporarily so we can get it's value
        element = this._document.createElement('input');
        element.type = 'hidden';
        element.classList.add(className);
        this._document.body.appendChild(element);
        // capture the value and clean up the extra element
        const result = getComputedStyle(element).color;
        this._document.body.removeChild(element);
        return result;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.1", ngImport: i0, type: StyleColorsService, deps: [{ token: DOCUMENT }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.1", ngImport: i0, type: StyleColorsService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.1", ngImport: i0, type: StyleColorsService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }] });

class TitleComponent {
    constructor(router, activatedRoute, titleService, authService) {
        this.router = router;
        this.activatedRoute = activatedRoute;
        this.titleService = titleService;
        this.authService = authService;
        this.$title = this.router.events.pipe(filter(event => event instanceof NavigationEnd), map(() => this.getChild(this.activatedRoute)), mergeMap((route) => route.data), map((data) => data["title"]));
        this.$vm = combineLatest([
            this.$title,
            this.authService.getAuthInfo()
        ]).pipe(map(([title, authInfo]) => {
            if (title)
                this.titleService.setTitle(authInfo.productName + ": " + title);
            else
                this.titleService.setTitle(authInfo.productName);
        }));
    }
    getChild(activatedRoute) {
        if (activatedRoute.firstChild) {
            return this.getChild(activatedRoute.firstChild);
        }
        else {
            return activatedRoute;
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.1", ngImport: i0, type: TitleComponent, deps: [{ token: i1.Router }, { token: i1.ActivatedRoute }, { token: i2$1.Title }, { token: AuthenticationService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.1", type: TitleComponent, selector: "cl-title", ngImport: i0, template: '{{ $vm | async }}', isInline: true, dependencies: [{ kind: "pipe", type: i1$1.AsyncPipe, name: "async" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.1", ngImport: i0, type: TitleComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'cl-title',
                    template: '{{ $vm | async }}',
                }]
        }], ctorParameters: () => [{ type: i1.Router }, { type: i1.ActivatedRoute }, { type: i2$1.Title }, { type: AuthenticationService }] });

class StringRequirementComponent {
    constructor() {
        this.isBlankItemId$ = new BehaviorSubject('');
        this.isNotBlankItemId$ = new BehaviorSubject('');
        this.selectedOperation$ = new BehaviorSubject('');
        this.lookupOperators$ = new BehaviorSubject([]);
        this.condition$ = new BehaviorSubject({});
        this.isFirstLoad = true;
        this.vm$ = combineLatest([
            this.condition$,
            this.selectedOperation$,
            this.lookupOperators$,
            this.isBlankItemId$,
            this.isNotBlankItemId$,
        ]).pipe(map(([condition, selectedOperation, lookupOperators, isBlankItemId, isNotBlankItemId]) => ({
            condition,
            isBlankItemId,
            selectedOperation,
            lookupOperators,
            isNotBlankItemId
        })), tap((data) => {
            if (this.isFirstLoad) {
                let operatorItemId = data.condition?.operation?.itemId ?? '';
                this.textInputFormGroup.controls['operationDropdown'].setValue(operatorItemId);
                this.textInputFormGroup.controls['textInput'].setValue(data.condition?.value[0] ?? '');
                if (data.isBlankItemId === operatorItemId || data.isNotBlankItemId === operatorItemId) {
                    this.textInputFormGroup.controls['textInput'].setValue('');
                    this.textInputFormGroup.controls['textInput'].clearValidators();
                    this.textInputFormGroup.controls['textInput'].disable();
                }
                this.isFirstLoad = false;
            }
        }));
        this.textInputFormGroup = new UntypedFormGroup({
            operationDropdown: new UntypedFormControl('', [Validators.required, Validators.minLength(1)]),
            textInput: new UntypedFormControl('', [Validators.required, this.noWhitespaceValidator])
        });
    }
    set operators(operators) {
        // Filter operators
        var filteredOperators = [{ itemId: '', itemName: 'Select an item...' }];
        filteredOperators.push(...operators);
        this.lookupOperators$.next(filteredOperators);
        const isBlankOp = filteredOperators.find(o => o.itemName === "Is Blank");
        const isNotBlankOp = filteredOperators.find(o => o.itemName === "Is Not Blank");
        if (isBlankOp) {
            this.isBlankItemId$.next(isBlankOp.itemId);
        }
        if (isNotBlankOp) {
            this.isNotBlankItemId$.next(isNotBlankOp.itemId);
        }
    }
    set condition(condition) {
        if (condition) {
            this.condition$.next(condition);
        }
        else {
            this.condition$.next({ value: [] });
        }
    }
    get f() { return this.textInputFormGroup.controls; }
    ;
    onOperatorChanged(selectedOperationId) {
        this.selectedOperation$.next(selectedOperationId);
        let conditionToEdit = this.condition$.getValue();
        let operators = this.lookupOperators$.getValue();
        conditionToEdit.operation = operators[operators.findIndex(p => p.itemId === selectedOperationId)];
        if (conditionToEdit.operation.itemId !== '' &&
            (conditionToEdit.operation.itemId === this.isBlankItemId$.getValue()
                || conditionToEdit.operation.itemId === this.isNotBlankItemId$.getValue())) {
            conditionToEdit.value[0] = '';
            this.textInputFormGroup.controls['textInput'].setValue('');
            this.textInputFormGroup.controls['textInput'].clearValidators();
            this.textInputFormGroup.controls['textInput'].disable();
        }
        else {
            this.textInputFormGroup.controls['textInput'].setValidators([Validators.required, this.noWhitespaceValidator]);
            this.textInputFormGroup.controls['textInput'].enable();
        }
        this.textInputFormGroup.controls['textInput'].updateValueAndValidity();
        this.condition$.next(conditionToEdit);
    }
    onValueChanged(keyPressedEvent) {
        var stringValue = keyPressedEvent.currentTarget.value;
        var conditionToEdit = this.condition$.getValue();
        conditionToEdit.value[0] = stringValue;
        this.condition$.next(conditionToEdit);
    }
    noWhitespaceValidator(control) {
        const isWhitespace = (control.value || '').trim().length === 0;
        const isValid = !isWhitespace;
        return isValid ? null : { 'whitespace': true };
    }
    getConditionValueAndValidity() {
        return { isValid: this.textInputFormGroup.valid, conditionToSave: this.condition$.getValue() };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.1", ngImport: i0, type: StringRequirementComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.1", type: StringRequirementComponent, selector: "cl-string-requirement", inputs: { operators: "operators", condition: "condition" }, providers: [PopupService, ResizeBatchService], ngImport: i0, template: "<ng-container *ngIf=\"vm$ | async as vm\">\r\n    <div class=\"label-container\">\r\n        <label class=\"type-label\">String</label>\r\n        <cl-tooltip message=\"You can provide a value for the field you would like to match. Please make sure the operator is what you expect.\"></cl-tooltip>\r\n    </div>\r\n    <form [formGroup]=\"textInputFormGroup\">\r\n        <div class=\"dropdown-container\">\r\n            <!-- The dropdown list with operators -->\r\n            <label style=\"display:inline-block;\">Match if &nbsp;</label>\r\n            <kendo-dropdownlist name=\"operationId\"\r\n                                id=\"operator-dropdown\"\r\n                                [data]=\"vm.lookupOperators\"\r\n                                textField=\"itemName\"\r\n                                valueField=\"itemId\"\r\n                                [valuePrimitive]=\"true\"\r\n                                (valueChange)=\"onOperatorChanged($event)\"\r\n                                formControlName=\"operationDropdown\">\r\n            </kendo-dropdownlist>\r\n            <cl-error-validation-message *ngIf=\"(f.operationDropdown.touched || f.operationDropdown.dirty) && !f.operationDropdown.value\"\r\n                                         id=\"operation-dropdown-error\"\r\n                                         message=\"Required\">\r\n            </cl-error-validation-message>\r\n        </div>\r\n        <div class=\"string-input-container\">\r\n            <textarea id=\"requirement-textarea\"\r\n                      class=\"form-control\"\r\n                      rows=\"2\"\r\n                      (keyup)=\"onValueChanged($event)\"\r\n                      formControlName=\"textInput\">\r\n            </textarea>\r\n            <div *ngIf=\"!textInputFormGroup.valid\">\r\n                <cl-error-validation-message *ngIf=\"((f.textInput.touched || f.textInput.dirty) && (!f.textInput.value || f.textInput.hasError('whitespace')))\"\r\n                                             id=\"text-input-error\"\r\n                                             message=\"Required\">\r\n                </cl-error-validation-message>\r\n            </div>\r\n        </div>\r\n    </form>\r\n</ng-container>\r\n", styles: ["form{padding-bottom:10px}.label-container{float:left;width:20%}.label-container .type-label{display:inline;margin-right:5px}.dropdown-container{float:right;width:80%;white-space:nowrap;margin-bottom:8px}.dropdown-container cl-error-validation-message{display:table;margin-left:60px}.string-input-container{max-width:500px;padding-left:20%}.numeric-input-container{margin-left:20%}.numeric-input-container input,.numeric-input-container div{display:inline;white-space:nowrap}.numeric-input-container #input-number{max-width:500px}.numeric-input-container cl-error-validation-message{display:table}.date-input-container{margin-left:20%}.date-input-container cl-error-validation-message.first-validator{display:block}.date-input-container cl-error-validation-message.second-validator{display:block;margin-left:10px}.error-spacer{display:block}.list-input-container{margin-left:20%}.list-input-container cl-error-validation-message{display:block}.list-input-container kendo-multiselect{display:inline-flex}.boolean-input-container{float:right;width:80%;white-space:nowrap;margin-bottom:8px}.boolean-input-container cl-error-validation-message{display:table}kendo-dropdownlist{margin-right:8px}.k-input,.k-picker{min-width:12.4em;width:auto}.radio-group{margin-left:10px;display:inline-block}label{display:inline-block}.left-column{box-sizing:border-box;padding-left:10px;width:20%;display:inline-block}.right-column{width:80%;display:inline-block}::ng-deep .list-input-combo-box .k-input-inner,.list-input-multiselect{width:400px}\n"], dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i2.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "component", type: i3.DropDownListComponent, selector: "kendo-dropdownlist", inputs: ["customIconClass", "showStickyHeader", "icon", "svgIcon", "loading", "data", "value", "textField", "valueField", "adaptiveMode", "title", "subtitle", "popupSettings", "listHeight", "defaultItem", "disabled", "itemDisabled", "readonly", "filterable", "virtual", "ignoreCase", "delay", "valuePrimitive", "tabindex", "tabIndex", "size", "rounded", "fillMode", "leftRightArrowsNavigation", "id"], outputs: ["valueChange", "filterChange", "selectionChange", "open", "opened", "close", "closed", "focus", "blur"], exportAs: ["kendoDropDownList"] }, { kind: "component", type: ErrorValidationMessageComponent, selector: "cl-error-validation-message", inputs: ["accessibilityMessage", "message"] }, { kind: "component", type: TooltipComponent, selector: "cl-tooltip", inputs: ["message", "iconClass", "maxWidth", "anchorAlign", "popupAlign"], outputs: ["iconClick"] }, { kind: "pipe", type: i1$1.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.1", ngImport: i0, type: StringRequirementComponent, decorators: [{
            type: Component,
            args: [{ changeDetection: ChangeDetectionStrategy.OnPush, selector: 'cl-string-requirement', providers: [PopupService, ResizeBatchService], template: "<ng-container *ngIf=\"vm$ | async as vm\">\r\n    <div class=\"label-container\">\r\n        <label class=\"type-label\">String</label>\r\n        <cl-tooltip message=\"You can provide a value for the field you would like to match. Please make sure the operator is what you expect.\"></cl-tooltip>\r\n    </div>\r\n    <form [formGroup]=\"textInputFormGroup\">\r\n        <div class=\"dropdown-container\">\r\n            <!-- The dropdown list with operators -->\r\n            <label style=\"display:inline-block;\">Match if &nbsp;</label>\r\n            <kendo-dropdownlist name=\"operationId\"\r\n                                id=\"operator-dropdown\"\r\n                                [data]=\"vm.lookupOperators\"\r\n                                textField=\"itemName\"\r\n                                valueField=\"itemId\"\r\n                                [valuePrimitive]=\"true\"\r\n                                (valueChange)=\"onOperatorChanged($event)\"\r\n                                formControlName=\"operationDropdown\">\r\n            </kendo-dropdownlist>\r\n            <cl-error-validation-message *ngIf=\"(f.operationDropdown.touched || f.operationDropdown.dirty) && !f.operationDropdown.value\"\r\n                                         id=\"operation-dropdown-error\"\r\n                                         message=\"Required\">\r\n            </cl-error-validation-message>\r\n        </div>\r\n        <div class=\"string-input-container\">\r\n            <textarea id=\"requirement-textarea\"\r\n                      class=\"form-control\"\r\n                      rows=\"2\"\r\n                      (keyup)=\"onValueChanged($event)\"\r\n                      formControlName=\"textInput\">\r\n            </textarea>\r\n            <div *ngIf=\"!textInputFormGroup.valid\">\r\n                <cl-error-validation-message *ngIf=\"((f.textInput.touched || f.textInput.dirty) && (!f.textInput.value || f.textInput.hasError('whitespace')))\"\r\n                                             id=\"text-input-error\"\r\n                                             message=\"Required\">\r\n                </cl-error-validation-message>\r\n            </div>\r\n        </div>\r\n    </form>\r\n</ng-container>\r\n", styles: ["form{padding-bottom:10px}.label-container{float:left;width:20%}.label-container .type-label{display:inline;margin-right:5px}.dropdown-container{float:right;width:80%;white-space:nowrap;margin-bottom:8px}.dropdown-container cl-error-validation-message{display:table;margin-left:60px}.string-input-container{max-width:500px;padding-left:20%}.numeric-input-container{margin-left:20%}.numeric-input-container input,.numeric-input-container div{display:inline;white-space:nowrap}.numeric-input-container #input-number{max-width:500px}.numeric-input-container cl-error-validation-message{display:table}.date-input-container{margin-left:20%}.date-input-container cl-error-validation-message.first-validator{display:block}.date-input-container cl-error-validation-message.second-validator{display:block;margin-left:10px}.error-spacer{display:block}.list-input-container{margin-left:20%}.list-input-container cl-error-validation-message{display:block}.list-input-container kendo-multiselect{display:inline-flex}.boolean-input-container{float:right;width:80%;white-space:nowrap;margin-bottom:8px}.boolean-input-container cl-error-validation-message{display:table}kendo-dropdownlist{margin-right:8px}.k-input,.k-picker{min-width:12.4em;width:auto}.radio-group{margin-left:10px;display:inline-block}label{display:inline-block}.left-column{box-sizing:border-box;padding-left:10px;width:20%;display:inline-block}.right-column{width:80%;display:inline-block}::ng-deep .list-input-combo-box .k-input-inner,.list-input-multiselect{width:400px}\n"] }]
        }], propDecorators: { operators: [{
                type: Input
            }], condition: [{
                type: Input
            }] } });

class NumberRequirementComponent {
    constructor() {
        this.isBlankItemId$ = new BehaviorSubject('');
        this.isNotBlankItemId$ = new BehaviorSubject('');
        this.selectedOperation$ = new BehaviorSubject('');
        this.lookupOperators$ = new BehaviorSubject([]);
        this.condition$ = new BehaviorSubject({});
        this.isFirstLoad = true;
        this.vm$ = combineLatest([
            this.condition$,
            this.selectedOperation$,
            this.lookupOperators$,
            this.isBlankItemId$,
            this.isNotBlankItemId$,
        ]).pipe(map(([condition, selectedOperation, lookupOperators, isBlankItemId, isNotBlankItemId]) => ({
            condition,
            isBlankItemId,
            selectedOperation,
            lookupOperators,
            isValid: this.numericInputFormGroup.valid,
            isNotBlankItemId
        })), tap((data) => {
            if (this.isFirstLoad) {
                let operatorItemId = data.condition?.operation?.itemId ?? '';
                this.numericInputFormGroup.controls['operationDropdown'].setValue(operatorItemId);
                this.numericInputFormGroup.controls['numberInput'].setValue(data.condition?.value[0] ?? undefined);
                if (data.isBlankItemId === operatorItemId || data.isNotBlankItemId === operatorItemId) {
                    this.numericInputFormGroup.controls['numberInput'].setValue('');
                    this.numericInputFormGroup.controls['numberInput'].clearValidators();
                    this.numericInputFormGroup.controls['numberInput'].disable();
                }
                this.isFirstLoad = false;
            }
        }));
        this.numericInputFormGroup = new UntypedFormGroup({
            operationDropdown: new UntypedFormControl('', [Validators.required, Validators.minLength(1)]),
            numberInput: new UntypedFormControl(undefined, [Validators.required])
        });
    }
    set operators(operators) {
        // Filter operators
        var filteredOperators = [{ itemId: '', itemName: 'Select an item...' }];
        filteredOperators.push(...operators);
        this.lookupOperators$.next(filteredOperators);
        const isBlankOp = filteredOperators.find(o => o.itemName === "Is Blank");
        const isNotBlankOp = filteredOperators.find(o => o.itemName === "Is Not Blank");
        if (isBlankOp) {
            this.isBlankItemId$.next(isBlankOp.itemId);
        }
        if (isNotBlankOp) {
            this.isNotBlankItemId$.next(isNotBlankOp.itemId);
        }
    }
    set condition(condition) {
        if (condition) {
            this.condition$.next(condition);
        }
        else {
            this.condition$.next({ value: [] });
        }
    }
    get f() { return this.numericInputFormGroup.controls; }
    ;
    onOperatorChanged(selectedOperationId) {
        this.selectedOperation$.next(selectedOperationId);
        let conditionToEdit = this.condition$.getValue();
        let operators = this.lookupOperators$.getValue();
        conditionToEdit.operation = operators[operators.findIndex(p => p.itemId === selectedOperationId)];
        if (conditionToEdit.operation.itemId !== '' &&
            (conditionToEdit.operation.itemId === this.isBlankItemId$.getValue() ||
                conditionToEdit.operation.itemId === this.isNotBlankItemId$.getValue())) {
            conditionToEdit.value[0] = undefined;
            this.numericInputFormGroup.controls['numberInput'].setValue('');
            this.numericInputFormGroup.controls['numberInput'].clearValidators();
            this.numericInputFormGroup.controls['numberInput'].disable();
        }
        else {
            this.numericInputFormGroup.controls['numberInput'].setValidators([Validators.required]);
            this.numericInputFormGroup.controls['numberInput'].enable();
        }
        this.numericInputFormGroup.controls['numberInput'].updateValueAndValidity();
        this.condition$.next(conditionToEdit);
    }
    onValueChanged(changeEvent) {
        var numberValue = changeEvent.currentTarget.value;
        var conditionToEdit = this.condition$.getValue();
        conditionToEdit.value[0] = numberValue;
        this.condition$.next(conditionToEdit);
    }
    getConditionValueAndValidity() {
        return { isValid: this.numericInputFormGroup.valid, conditionToSave: this.condition$.getValue() };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.1", ngImport: i0, type: NumberRequirementComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.1", type: NumberRequirementComponent, selector: "cl-number-requirement", inputs: { operators: "operators", condition: "condition" }, providers: [PopupService, ResizeBatchService], ngImport: i0, template: "<ng-container *ngIf=\"vm$ | async as vm\">\r\n    <div class=\"label-container\">\r\n        <label class=\"type-label\">Numeric</label>\r\n        <cl-tooltip message=\"Select an operator and value in relation to an acceptable answer to match.\"></cl-tooltip>\r\n    </div>\r\n    <form [formGroup]=\"numericInputFormGroup\">\r\n        <div class=\"dropdown-container\">\r\n            <!-- The dropdown list with operators -->\r\n            <label style=\"display:inline-block;\">Match if &nbsp;</label>\r\n            <kendo-dropdownlist name=\"operationId\"\r\n                                id=\"operator-dropdown\"\r\n                                [data]=\"vm.lookupOperators\"\r\n                                textField=\"itemName\"\r\n                                valueField=\"itemId\"\r\n                                [valuePrimitive]=\"true\"\r\n                                (valueChange)=\"onOperatorChanged($event)\"\r\n                                formControlName=\"operationDropdown\">\r\n            </kendo-dropdownlist>\r\n            <cl-error-validation-message *ngIf=\"(f.operationDropdown.touched || f.operationDropdown.dirty) && !f.operationDropdown.value\"\r\n                                         id=\"operation-dropdown-error\"\r\n                                         message=\"Required\">\r\n            </cl-error-validation-message>\r\n        </div>\r\n\r\n        <div class=\"numeric-input-container\">\r\n            <input class=\"form-control criteria-data-field-value\"\r\n                   id=\"input-number\"\r\n                   required\r\n                   type=\"number\"\r\n                   formControlName=\"numberInput\"\r\n                   (change)=\"onValueChanged($event)\"\r\n                   (keyup)=\"onValueChanged($event)\" />\r\n            <div *ngIf=\"!numericInputFormGroup.valid\">\r\n                <cl-error-validation-message *ngIf=\"((f.numberInput.touched || f.numberInput.dirty) && !f.numberInput.value)\"\r\n                                             id=\"number-input-error\"\r\n                                             message=\"Required\">\r\n                </cl-error-validation-message>\r\n            </div>\r\n        </div>\r\n\r\n    </form>\r\n</ng-container>\r\n", styles: ["form{padding-bottom:10px}.label-container{float:left;width:20%}.label-container .type-label{display:inline;margin-right:5px}.dropdown-container{float:right;width:80%;white-space:nowrap;margin-bottom:8px}.dropdown-container cl-error-validation-message{display:table;margin-left:60px}.string-input-container{max-width:500px;padding-left:20%}.numeric-input-container{margin-left:20%}.numeric-input-container input,.numeric-input-container div{display:inline;white-space:nowrap}.numeric-input-container #input-number{max-width:500px}.numeric-input-container cl-error-validation-message{display:table}.date-input-container{margin-left:20%}.date-input-container cl-error-validation-message.first-validator{display:block}.date-input-container cl-error-validation-message.second-validator{display:block;margin-left:10px}.error-spacer{display:block}.list-input-container{margin-left:20%}.list-input-container cl-error-validation-message{display:block}.list-input-container kendo-multiselect{display:inline-flex}.boolean-input-container{float:right;width:80%;white-space:nowrap;margin-bottom:8px}.boolean-input-container cl-error-validation-message{display:table}kendo-dropdownlist{margin-right:8px}.k-input,.k-picker{min-width:12.4em;width:auto}.radio-group{margin-left:10px;display:inline-block}label{display:inline-block}.left-column{box-sizing:border-box;padding-left:10px;width:20%;display:inline-block}.right-column{width:80%;display:inline-block}::ng-deep .list-input-combo-box .k-input-inner,.list-input-multiselect{width:400px}\n"], dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i2.NumberValueAccessor, selector: "input[type=number][formControlName],input[type=number][formControl],input[type=number][ngModel]" }, { kind: "directive", type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2.RequiredValidator, selector: ":not([type=checkbox])[required][formControlName],:not([type=checkbox])[required][formControl],:not([type=checkbox])[required][ngModel]", inputs: ["required"] }, { kind: "directive", type: i2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i2.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "component", type: i3.DropDownListComponent, selector: "kendo-dropdownlist", inputs: ["customIconClass", "showStickyHeader", "icon", "svgIcon", "loading", "data", "value", "textField", "valueField", "adaptiveMode", "title", "subtitle", "popupSettings", "listHeight", "defaultItem", "disabled", "itemDisabled", "readonly", "filterable", "virtual", "ignoreCase", "delay", "valuePrimitive", "tabindex", "tabIndex", "size", "rounded", "fillMode", "leftRightArrowsNavigation", "id"], outputs: ["valueChange", "filterChange", "selectionChange", "open", "opened", "close", "closed", "focus", "blur"], exportAs: ["kendoDropDownList"] }, { kind: "component", type: ErrorValidationMessageComponent, selector: "cl-error-validation-message", inputs: ["accessibilityMessage", "message"] }, { kind: "component", type: TooltipComponent, selector: "cl-tooltip", inputs: ["message", "iconClass", "maxWidth", "anchorAlign", "popupAlign"], outputs: ["iconClick"] }, { kind: "pipe", type: i1$1.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.1", ngImport: i0, type: NumberRequirementComponent, decorators: [{
            type: Component,
            args: [{ changeDetection: ChangeDetectionStrategy.OnPush, selector: 'cl-number-requirement', providers: [PopupService, ResizeBatchService], template: "<ng-container *ngIf=\"vm$ | async as vm\">\r\n    <div class=\"label-container\">\r\n        <label class=\"type-label\">Numeric</label>\r\n        <cl-tooltip message=\"Select an operator and value in relation to an acceptable answer to match.\"></cl-tooltip>\r\n    </div>\r\n    <form [formGroup]=\"numericInputFormGroup\">\r\n        <div class=\"dropdown-container\">\r\n            <!-- The dropdown list with operators -->\r\n            <label style=\"display:inline-block;\">Match if &nbsp;</label>\r\n            <kendo-dropdownlist name=\"operationId\"\r\n                                id=\"operator-dropdown\"\r\n                                [data]=\"vm.lookupOperators\"\r\n                                textField=\"itemName\"\r\n                                valueField=\"itemId\"\r\n                                [valuePrimitive]=\"true\"\r\n                                (valueChange)=\"onOperatorChanged($event)\"\r\n                                formControlName=\"operationDropdown\">\r\n            </kendo-dropdownlist>\r\n            <cl-error-validation-message *ngIf=\"(f.operationDropdown.touched || f.operationDropdown.dirty) && !f.operationDropdown.value\"\r\n                                         id=\"operation-dropdown-error\"\r\n                                         message=\"Required\">\r\n            </cl-error-validation-message>\r\n        </div>\r\n\r\n        <div class=\"numeric-input-container\">\r\n            <input class=\"form-control criteria-data-field-value\"\r\n                   id=\"input-number\"\r\n                   required\r\n                   type=\"number\"\r\n                   formControlName=\"numberInput\"\r\n                   (change)=\"onValueChanged($event)\"\r\n                   (keyup)=\"onValueChanged($event)\" />\r\n            <div *ngIf=\"!numericInputFormGroup.valid\">\r\n                <cl-error-validation-message *ngIf=\"((f.numberInput.touched || f.numberInput.dirty) && !f.numberInput.value)\"\r\n                                             id=\"number-input-error\"\r\n                                             message=\"Required\">\r\n                </cl-error-validation-message>\r\n            </div>\r\n        </div>\r\n\r\n    </form>\r\n</ng-container>\r\n", styles: ["form{padding-bottom:10px}.label-container{float:left;width:20%}.label-container .type-label{display:inline;margin-right:5px}.dropdown-container{float:right;width:80%;white-space:nowrap;margin-bottom:8px}.dropdown-container cl-error-validation-message{display:table;margin-left:60px}.string-input-container{max-width:500px;padding-left:20%}.numeric-input-container{margin-left:20%}.numeric-input-container input,.numeric-input-container div{display:inline;white-space:nowrap}.numeric-input-container #input-number{max-width:500px}.numeric-input-container cl-error-validation-message{display:table}.date-input-container{margin-left:20%}.date-input-container cl-error-validation-message.first-validator{display:block}.date-input-container cl-error-validation-message.second-validator{display:block;margin-left:10px}.error-spacer{display:block}.list-input-container{margin-left:20%}.list-input-container cl-error-validation-message{display:block}.list-input-container kendo-multiselect{display:inline-flex}.boolean-input-container{float:right;width:80%;white-space:nowrap;margin-bottom:8px}.boolean-input-container cl-error-validation-message{display:table}kendo-dropdownlist{margin-right:8px}.k-input,.k-picker{min-width:12.4em;width:auto}.radio-group{margin-left:10px;display:inline-block}label{display:inline-block}.left-column{box-sizing:border-box;padding-left:10px;width:20%;display:inline-block}.right-column{width:80%;display:inline-block}::ng-deep .list-input-combo-box .k-input-inner,.list-input-multiselect{width:400px}\n"] }]
        }], propDecorators: { operators: [{
                type: Input
            }], condition: [{
                type: Input
            }] } });

class BooleanRequirementComponent {
    constructor() {
        this.selectedOperation$ = new BehaviorSubject('');
        this.equalToOperator$ = new BehaviorSubject({});
        this.condition$ = new BehaviorSubject({});
        this.isFirstLoad = true;
        this.vm$ = combineLatest([
            this.condition$,
            this.selectedOperation$,
            this.equalToOperator$,
        ]).pipe(map(([condition, selectedOperation, equalToOperator]) => ({
            condition,
            selectedOperation,
            equalToOperator
        })), tap((data) => {
            if (this.isFirstLoad) {
                this.isFirstLoad = false;
                this.booleanInputFormGroup.controls['radioInput'].setValue(data.condition?.value[0] ?? undefined);
                this.condition$.next({ ...this.condition$.getValue(), operation: data.equalToOperator });
            }
        }));
        this.booleanInputFormGroup = new UntypedFormGroup({
            radioInput: new UntypedFormControl(undefined, [Validators.required])
        });
    }
    set operators(operators) {
        var equalToOperator = operators.find(o => o.itemName === "Equal To");
        this.equalToOperator$.next(equalToOperator);
        this.selectedOperation$.next(equalToOperator.itemId);
    }
    set condition(condition) {
        if (condition) {
            condition.operation = this.equalToOperator$.getValue();
            this.condition$.next(condition);
        }
        else {
            this.condition$.next({ value: [] });
        }
    }
    get f() { return this.booleanInputFormGroup.controls; }
    ;
    onChange(booleanSelected) {
        this.f.radioInput.setValue(booleanSelected);
        var conditionToEdit = this.condition$.getValue();
        conditionToEdit.value[0] = booleanSelected;
        conditionToEdit.operation = this.equalToOperator$.getValue();
        this.condition$.next(conditionToEdit);
    }
    getConditionValueAndValidity() {
        return { isValid: this.booleanInputFormGroup.valid, conditionToSave: this.condition$.getValue() };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.1", ngImport: i0, type: BooleanRequirementComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.1", type: BooleanRequirementComponent, selector: "cl-boolean-requirement", inputs: { operators: "operators", condition: "condition" }, ngImport: i0, template: "<ng-container *ngIf=\"vm$ | async as vm\">\r\n    <div class=\"label-container\">\r\n        <label class=\"type-label\">Yes/No</label>\r\n        <cl-tooltip message=\"Select whether the answer to the field should be Yes or No to match.\"></cl-tooltip>\r\n    </div>\r\n    <form [formGroup]=\"booleanInputFormGroup\">\r\n        <div class=\"boolean-input-container\">\r\n            <!-- The dropdown list with operators -->\r\n            <label style=\"display:inline-block;\">Match if equal to</label>\r\n            <div class=\"radio-group\">\r\n                <label>\r\n                    <input id=\"radio-yes\" formControlName=\"radioInput\" type=\"radio\" name=\"radioInput\" [value]=\"'Yes'\" (click)=\"onChange('Yes')\" />\r\n                    Yes &nbsp;\r\n                </label>\r\n                <label>\r\n                    <input id=\"radio-no\" formControlName=\"radioInput\" type=\"radio\" name=\"radioInput\" [value]=\"'No'\" (click)=\"onChange('No')\" />\r\n                    No\r\n                </label>\r\n            </div>\r\n            <cl-error-validation-message *ngIf=\"((f.radioInput.touched || f.radioInput.dirty) && !f.radioInput.value)\"\r\n                                             id=\"boolean-input-error\"\r\n                                             message=\"Required\">\r\n            </cl-error-validation-message>\r\n        </div>\r\n    </form>\r\n</ng-container>\r\n\r\n", styles: ["form{padding-bottom:10px}.label-container{float:left;width:20%}.label-container .type-label{display:inline;margin-right:5px}.dropdown-container{float:right;width:80%;white-space:nowrap;margin-bottom:8px}.dropdown-container cl-error-validation-message{display:table;margin-left:60px}.string-input-container{max-width:500px;padding-left:20%}.numeric-input-container{margin-left:20%}.numeric-input-container input,.numeric-input-container div{display:inline;white-space:nowrap}.numeric-input-container #input-number{max-width:500px}.numeric-input-container cl-error-validation-message{display:table}.date-input-container{margin-left:20%}.date-input-container cl-error-validation-message.first-validator{display:block}.date-input-container cl-error-validation-message.second-validator{display:block;margin-left:10px}.error-spacer{display:block}.list-input-container{margin-left:20%}.list-input-container cl-error-validation-message{display:block}.list-input-container kendo-multiselect{display:inline-flex}.boolean-input-container{float:right;width:80%;white-space:nowrap;margin-bottom:8px}.boolean-input-container cl-error-validation-message{display:table}kendo-dropdownlist{margin-right:8px}.k-input,.k-picker{min-width:12.4em;width:auto}.radio-group{margin-left:10px;display:inline-block}label{display:inline-block}.left-column{box-sizing:border-box;padding-left:10px;width:20%;display:inline-block}.right-column{width:80%;display:inline-block}::ng-deep .list-input-combo-box .k-input-inner,.list-input-multiselect{width:400px}\n"], dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i2.RadioControlValueAccessor, selector: "input[type=radio][formControlName],input[type=radio][formControl],input[type=radio][ngModel]", inputs: ["name", "formControlName", "value"] }, { kind: "directive", type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i2.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "component", type: ErrorValidationMessageComponent, selector: "cl-error-validation-message", inputs: ["accessibilityMessage", "message"] }, { kind: "component", type: TooltipComponent, selector: "cl-tooltip", inputs: ["message", "iconClass", "maxWidth", "anchorAlign", "popupAlign"], outputs: ["iconClick"] }, { kind: "pipe", type: i1$1.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.1", ngImport: i0, type: BooleanRequirementComponent, decorators: [{
            type: Component,
            args: [{ changeDetection: ChangeDetectionStrategy.OnPush, selector: 'cl-boolean-requirement', template: "<ng-container *ngIf=\"vm$ | async as vm\">\r\n    <div class=\"label-container\">\r\n        <label class=\"type-label\">Yes/No</label>\r\n        <cl-tooltip message=\"Select whether the answer to the field should be Yes or No to match.\"></cl-tooltip>\r\n    </div>\r\n    <form [formGroup]=\"booleanInputFormGroup\">\r\n        <div class=\"boolean-input-container\">\r\n            <!-- The dropdown list with operators -->\r\n            <label style=\"display:inline-block;\">Match if equal to</label>\r\n            <div class=\"radio-group\">\r\n                <label>\r\n                    <input id=\"radio-yes\" formControlName=\"radioInput\" type=\"radio\" name=\"radioInput\" [value]=\"'Yes'\" (click)=\"onChange('Yes')\" />\r\n                    Yes &nbsp;\r\n                </label>\r\n                <label>\r\n                    <input id=\"radio-no\" formControlName=\"radioInput\" type=\"radio\" name=\"radioInput\" [value]=\"'No'\" (click)=\"onChange('No')\" />\r\n                    No\r\n                </label>\r\n            </div>\r\n            <cl-error-validation-message *ngIf=\"((f.radioInput.touched || f.radioInput.dirty) && !f.radioInput.value)\"\r\n                                             id=\"boolean-input-error\"\r\n                                             message=\"Required\">\r\n            </cl-error-validation-message>\r\n        </div>\r\n    </form>\r\n</ng-container>\r\n\r\n", styles: ["form{padding-bottom:10px}.label-container{float:left;width:20%}.label-container .type-label{display:inline;margin-right:5px}.dropdown-container{float:right;width:80%;white-space:nowrap;margin-bottom:8px}.dropdown-container cl-error-validation-message{display:table;margin-left:60px}.string-input-container{max-width:500px;padding-left:20%}.numeric-input-container{margin-left:20%}.numeric-input-container input,.numeric-input-container div{display:inline;white-space:nowrap}.numeric-input-container #input-number{max-width:500px}.numeric-input-container cl-error-validation-message{display:table}.date-input-container{margin-left:20%}.date-input-container cl-error-validation-message.first-validator{display:block}.date-input-container cl-error-validation-message.second-validator{display:block;margin-left:10px}.error-spacer{display:block}.list-input-container{margin-left:20%}.list-input-container cl-error-validation-message{display:block}.list-input-container kendo-multiselect{display:inline-flex}.boolean-input-container{float:right;width:80%;white-space:nowrap;margin-bottom:8px}.boolean-input-container cl-error-validation-message{display:table}kendo-dropdownlist{margin-right:8px}.k-input,.k-picker{min-width:12.4em;width:auto}.radio-group{margin-left:10px;display:inline-block}label{display:inline-block}.left-column{box-sizing:border-box;padding-left:10px;width:20%;display:inline-block}.right-column{width:80%;display:inline-block}::ng-deep .list-input-combo-box .k-input-inner,.list-input-multiselect{width:400px}\n"] }]
        }], propDecorators: { operators: [{
                type: Input
            }], condition: [{
                type: Input
            }] } });

class DateRequirementComponent {
    constructor() {
        this.allowBetween = false;
        this.operators = [];
        this.isBlankItemId = '';
        this.isNotBlankItemId = '';
        this.betweenItemId = '';
        this.selectedOperation$ = new BehaviorSubject('');
        this.lookupOperators = [];
        this.condition$ = new BehaviorSubject({});
        this.isFirstLoad = true;
        this.vm$ = combineLatest([
            this.condition$,
            this.selectedOperation$,
        ]).pipe(map(([condition, selectedOperation]) => {
            if (this.isFirstLoad) {
                // Filter operators
                const filteredOperators = [{ itemId: '', itemName: 'Select an item...' }];
                let operatorsToUse = this.operators;
                if (!this.allowBetween)
                    operatorsToUse = operatorsToUse.filter(o => o.itemName !== 'Between');
                filteredOperators.push(...operatorsToUse);
                this.lookupOperators = filteredOperators;
                this.isBlankItemId = filteredOperators.find(o => o.itemName === 'Is Blank')?.itemId ?? '';
                this.isNotBlankItemId = filteredOperators.find(o => o.itemName === "Is Not Blank")?.itemId ?? '';
                if (this.allowBetween)
                    this.betweenItemId = filteredOperators.find(o => o.itemName === 'Between')?.itemId ?? '';
                let operatorItemId = condition?.operation?.itemId ?? '';
                this.dateInputFormGroup.controls.operationDropdown.setValue(operatorItemId);
                this.dateInputFormGroup.controls.firstDateInput.setValue(condition?.value[0] ? new Date(Date.parse(condition?.value[0])) : null);
                this.dateInputFormGroup.controls.secondDateInput.setValue(condition?.value[1] ? new Date(Date.parse(condition?.value[1])) : null);
                if (this.isBlankItemId === operatorItemId || this.isNotBlankItemId === operatorItemId) {
                    this.dateInputFormGroup.controls.firstDateInput.setValue('');
                    this.dateInputFormGroup.controls.secondDateInput.setValue('');
                    this.dateInputFormGroup.controls.firstDateInput.clearValidators();
                    this.dateInputFormGroup.controls.firstDateInput.disable();
                }
                this.isFirstLoad = false;
            }
            return {
                condition,
                selectedOperation
            };
        }));
        this.dateInputFormGroup = new UntypedFormGroup({
            operationDropdown: new UntypedFormControl('', [Validators.required, Validators.minLength(1)]),
            firstDateInput: new UntypedFormControl(null, [Validators.required]),
            secondDateInput: new UntypedFormControl(null)
        }, { validators: dateLessThan });
    }
    set condition(condition) {
        if (condition) {
            this.condition$.next(condition);
        }
        else {
            this.condition$.next({ value: [], source: '', field: '', operation: {} });
        }
    }
    get f() { return this.dateInputFormGroup.controls; }
    ;
    onOperatorChanged(selectedOperationId) {
        this.selectedOperation$.next(selectedOperationId);
        const conditionToEdit = this.condition$.getValue();
        conditionToEdit.operation = this.lookupOperators[this.lookupOperators.findIndex(p => p.itemId === selectedOperationId)];
        if (conditionToEdit.operation.itemId !== '' &&
            (conditionToEdit.operation.itemId === this.isBlankItemId ||
                conditionToEdit.operation.itemId === this.isNotBlankItemId)) {
            //If we select is blank remove values and validators
            conditionToEdit.value = [];
            this.dateInputFormGroup.controls.firstDateInput.setValue('');
            this.dateInputFormGroup.controls.secondDateInput.setValue('');
            this.dateInputFormGroup.controls.firstDateInput.clearValidators();
            this.dateInputFormGroup.controls.firstDateInput.disable();
            this.dateInputFormGroup.controls.secondDateInput.clearValidators();
            this.dateInputFormGroup.controls.secondDateInput.disable();
        }
        else if (conditionToEdit.operation.itemId !== '' && conditionToEdit.operation.itemId === this.betweenItemId) {
            //If we select Between add validators and enable both inputs
            conditionToEdit.value = [conditionToEdit.value[0]];
            this.dateInputFormGroup.controls.secondDateInput.setValue('');
            this.dateInputFormGroup.controls.firstDateInput.setValidators([Validators.required]);
            this.dateInputFormGroup.controls.firstDateInput.enable();
            this.dateInputFormGroup.controls.secondDateInput.setValidators([Validators.required]);
            this.dateInputFormGroup.controls.secondDateInput.enable();
        }
        else {
            conditionToEdit.value = [];
            this.dateInputFormGroup.controls.firstDateInput.setValue('');
            this.dateInputFormGroup.controls.secondDateInput.setValue('');
            this.dateInputFormGroup.controls.firstDateInput.setValidators([Validators.required]);
            this.dateInputFormGroup.controls.firstDateInput.enable();
            this.dateInputFormGroup.controls.secondDateInput.clearValidators();
            this.dateInputFormGroup.controls.secondDateInput.disable();
        }
        this.condition$.next(conditionToEdit);
        this.clearDateIfIsBlank();
    }
    // just remove any previously selected date if Is Blank operator is selected
    // to avoid having to deal cases where part of the date is in the UI, but the value bound is null.
    // We therefore can't tell between an empty date and a partially filled out date.
    // Since we don't need it for Is Blank operator, we'll ditch it.
    clearDateIfIsBlank() {
        const conditionToEdit = this.condition$.getValue();
        if (conditionToEdit.operation && (conditionToEdit.operation.itemId === this.isBlankItemId ||
            conditionToEdit.operation.itemId === this.isNotBlankItemId)) {
            conditionToEdit.value[0] = null;
            conditionToEdit.value[1] = null;
            this.f.firstDateInput.setValue(null);
            this.f.secondDateInput.setValue(null);
            this.condition$.next(conditionToEdit);
        }
    }
    updateDateValue(dateFieldIndex) {
        // Keep in mind, updateDateValue() can called if part of a date is typed or deleted and both are considered null until a valid date is entered.
        this.clearDateIfIsBlank();
        try {
            //this is saved as a string to prevent client side -> server side utc manipulation of the date
            const workingDate = (dateFieldIndex === 0 ? this.f.firstDateInput.value : this.f.secondDateInput.value);
            const yyyy = workingDate.getFullYear();
            const mm = workingDate.getMonth() + 1; // getMonth() is zero-based
            const dd = workingDate.getDate();
            var conditionToEdit = this.condition$.getValue();
            conditionToEdit.value[dateFieldIndex] = mm + '-' + dd + '-' + yyyy;
            this.condition$.next(conditionToEdit);
        }
        catch (Exception) {
            var conditionToEdit = this.condition$.getValue();
            conditionToEdit.value[dateFieldIndex] = null;
            this.condition$.next(conditionToEdit);
        }
    }
    getConditionValueAndValidity() {
        return { isValid: this.dateInputFormGroup.valid, conditionToSave: this.condition$.getValue() };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.1", ngImport: i0, type: DateRequirementComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.1", type: DateRequirementComponent, selector: "cl-date-requirement", inputs: { allowBetween: "allowBetween", operators: "operators", condition: "condition" }, providers: [PopupService, ResizeBatchService, DateInputModule], ngImport: i0, template: "<ng-container *ngIf=\"vm$ | async as vm\">\r\n    <div class=\"label-container\">\r\n        <label class=\"type-label\">Date</label>\r\n        <cl-tooltip message=\"Select an operator and value in relation to an acceptable answer to match.\"></cl-tooltip>\r\n    </div>\r\n    <form [formGroup]=\"dateInputFormGroup\">\r\n        <div class=\"dropdown-container\">\r\n            <!-- The dropdown list with operators -->\r\n            <label style=\"display:inline-block;\">Match if &nbsp;</label>\r\n            <kendo-dropdownlist name=\"operationId\"\r\n                                id=\"operator-dropdown\"\r\n                                [data]=\"lookupOperators\"\r\n                                textField=\"itemName\"\r\n                                valueField=\"itemId\"\r\n                                [valuePrimitive]=\"true\"\r\n                                (valueChange)=\"onOperatorChanged($event)\"\r\n                                formControlName=\"operationDropdown\">\r\n            </kendo-dropdownlist>\r\n            <cl-error-validation-message *ngIf=\"(f.operationDropdown.touched || f.operationDropdown.dirty) && !f.operationDropdown.value\"\r\n                                         id=\"operation-dropdown-error\"\r\n                                         message=\"Required\">\r\n            </cl-error-validation-message>\r\n        </div>\r\n\r\n        <div class=\"date-input-container\">\r\n            <div style=\"display: table-cell;\">\r\n                <kendo-datepicker id=\"criteria-data-field-modal-datepicker-1\"\r\n                                  formControlName=\"firstDateInput\"\r\n                                  (valueChange)=\"updateDateValue(0)\"\r\n                                  class=\"criteria-data-field-value\">\r\n                </kendo-datepicker>\r\n                <cl-error-validation-message *ngIf=\"(f.firstDateInput.touched || f.firstDateInput.dirty) && !f.firstDateInput.value\"\r\n                                             id=\"operation-dropdown-error\"\r\n                                             message=\"Required\"\r\n                                             class=\"first-validator\">\r\n                </cl-error-validation-message>\r\n            </div>\r\n            <div *ngIf=\"allowBetween && betweenItemId === vm.condition?.operation?.itemId ?? ''\" style=\"display: table-cell;\">\r\n                <span>&#8212;</span>\r\n                <kendo-datepicker id=\"criteria-data-field-modal-datepicker-2\"\r\n                                  formControlName=\"secondDateInput\"\r\n                                  (valueChange)=\"updateDateValue(1)\"\r\n                                  class=\"criteria-data-field-value\">\r\n                </kendo-datepicker>\r\n                <cl-error-validation-message *ngIf=\"(f.secondDateInput.touched || f.secondDateInput.dirty) && !f.secondDateInput.value\"\r\n                                             id=\"operation-dropdown-error\"\r\n                                             message=\"Required\"\r\n                                             class=\"second-validator\">\r\n                </cl-error-validation-message>\r\n                <cl-error-validation-message *ngIf=\"dateInputFormGroup.hasError('seconddatebefore')\"\r\n                                             id=\"secondDate-picker-maxError\"\r\n                                             message=\"End Date must be after Start Date\"\r\n                                             class=\"second-validator\">\r\n                </cl-error-validation-message>\r\n            </div>\r\n        </div>\r\n    </form>\r\n</ng-container>\r\n", styles: ["form{padding-bottom:10px}.label-container{float:left;width:20%}.label-container .type-label{display:inline;margin-right:5px}.dropdown-container{float:right;width:80%;white-space:nowrap;margin-bottom:8px}.dropdown-container cl-error-validation-message{display:table;margin-left:60px}.string-input-container{max-width:500px;padding-left:20%}.numeric-input-container{margin-left:20%}.numeric-input-container input,.numeric-input-container div{display:inline;white-space:nowrap}.numeric-input-container #input-number{max-width:500px}.numeric-input-container cl-error-validation-message{display:table}.date-input-container{margin-left:20%}.date-input-container cl-error-validation-message.first-validator{display:block}.date-input-container cl-error-validation-message.second-validator{display:block;margin-left:10px}.error-spacer{display:block}.list-input-container{margin-left:20%}.list-input-container cl-error-validation-message{display:block}.list-input-container kendo-multiselect{display:inline-flex}.boolean-input-container{float:right;width:80%;white-space:nowrap;margin-bottom:8px}.boolean-input-container cl-error-validation-message{display:table}kendo-dropdownlist{margin-right:8px}.k-input,.k-picker{min-width:12.4em;width:auto}.radio-group{margin-left:10px;display:inline-block}label{display:inline-block}.left-column{box-sizing:border-box;padding-left:10px;width:20%;display:inline-block}.right-column{width:80%;display:inline-block}::ng-deep .list-input-combo-box .k-input-inner,.list-input-multiselect{width:400px}\n"], dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i2.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "component", type: i3.DropDownListComponent, selector: "kendo-dropdownlist", inputs: ["customIconClass", "showStickyHeader", "icon", "svgIcon", "loading", "data", "value", "textField", "valueField", "adaptiveMode", "title", "subtitle", "popupSettings", "listHeight", "defaultItem", "disabled", "itemDisabled", "readonly", "filterable", "virtual", "ignoreCase", "delay", "valuePrimitive", "tabindex", "tabIndex", "size", "rounded", "fillMode", "leftRightArrowsNavigation", "id"], outputs: ["valueChange", "filterChange", "selectionChange", "open", "opened", "close", "closed", "focus", "blur"], exportAs: ["kendoDropDownList"] }, { kind: "component", type: i4.DatePickerComponent, selector: "kendo-datepicker", inputs: ["focusableId", "cellTemplate", "monthCellTemplate", "yearCellTemplate", "decadeCellTemplate", "centuryCellTemplate", "weekNumberTemplate", "headerTitleTemplate", "navigationItemTemplate", "showOtherMonthDays", "activeView", "bottomView", "topView", "calendarType", "animateCalendarNavigation", "disabled", "readonly", "readOnlyInput", "popupSettings", "navigation", "min", "max", "incompleteDateValidation", "autoCorrectParts", "autoSwitchParts", "autoSwitchKeys", "enableMouseWheel", "allowCaretMode", "autoFill", "focusedDate", "value", "format", "twoDigitYearMax", "formatPlaceholder", "placeholder", "tabindex", "tabIndex", "disabledDates", "title", "subtitle", "rangeValidation", "disabledDatesValidation", "weekNumber", "size", "rounded", "fillMode", "adaptiveMode"], outputs: ["valueChange", "focus", "blur", "open", "close"], exportAs: ["kendo-datepicker"] }, { kind: "component", type: ErrorValidationMessageComponent, selector: "cl-error-validation-message", inputs: ["accessibilityMessage", "message"] }, { kind: "component", type: TooltipComponent, selector: "cl-tooltip", inputs: ["message", "iconClass", "maxWidth", "anchorAlign", "popupAlign"], outputs: ["iconClick"] }, { kind: "pipe", type: i1$1.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.1", ngImport: i0, type: DateRequirementComponent, decorators: [{
            type: Component,
            args: [{ changeDetection: ChangeDetectionStrategy.OnPush, selector: 'cl-date-requirement', providers: [PopupService, ResizeBatchService, DateInputModule], template: "<ng-container *ngIf=\"vm$ | async as vm\">\r\n    <div class=\"label-container\">\r\n        <label class=\"type-label\">Date</label>\r\n        <cl-tooltip message=\"Select an operator and value in relation to an acceptable answer to match.\"></cl-tooltip>\r\n    </div>\r\n    <form [formGroup]=\"dateInputFormGroup\">\r\n        <div class=\"dropdown-container\">\r\n            <!-- The dropdown list with operators -->\r\n            <label style=\"display:inline-block;\">Match if &nbsp;</label>\r\n            <kendo-dropdownlist name=\"operationId\"\r\n                                id=\"operator-dropdown\"\r\n                                [data]=\"lookupOperators\"\r\n                                textField=\"itemName\"\r\n                                valueField=\"itemId\"\r\n                                [valuePrimitive]=\"true\"\r\n                                (valueChange)=\"onOperatorChanged($event)\"\r\n                                formControlName=\"operationDropdown\">\r\n            </kendo-dropdownlist>\r\n            <cl-error-validation-message *ngIf=\"(f.operationDropdown.touched || f.operationDropdown.dirty) && !f.operationDropdown.value\"\r\n                                         id=\"operation-dropdown-error\"\r\n                                         message=\"Required\">\r\n            </cl-error-validation-message>\r\n        </div>\r\n\r\n        <div class=\"date-input-container\">\r\n            <div style=\"display: table-cell;\">\r\n                <kendo-datepicker id=\"criteria-data-field-modal-datepicker-1\"\r\n                                  formControlName=\"firstDateInput\"\r\n                                  (valueChange)=\"updateDateValue(0)\"\r\n                                  class=\"criteria-data-field-value\">\r\n                </kendo-datepicker>\r\n                <cl-error-validation-message *ngIf=\"(f.firstDateInput.touched || f.firstDateInput.dirty) && !f.firstDateInput.value\"\r\n                                             id=\"operation-dropdown-error\"\r\n                                             message=\"Required\"\r\n                                             class=\"first-validator\">\r\n                </cl-error-validation-message>\r\n            </div>\r\n            <div *ngIf=\"allowBetween && betweenItemId === vm.condition?.operation?.itemId ?? ''\" style=\"display: table-cell;\">\r\n                <span>&#8212;</span>\r\n                <kendo-datepicker id=\"criteria-data-field-modal-datepicker-2\"\r\n                                  formControlName=\"secondDateInput\"\r\n                                  (valueChange)=\"updateDateValue(1)\"\r\n                                  class=\"criteria-data-field-value\">\r\n                </kendo-datepicker>\r\n                <cl-error-validation-message *ngIf=\"(f.secondDateInput.touched || f.secondDateInput.dirty) && !f.secondDateInput.value\"\r\n                                             id=\"operation-dropdown-error\"\r\n                                             message=\"Required\"\r\n                                             class=\"second-validator\">\r\n                </cl-error-validation-message>\r\n                <cl-error-validation-message *ngIf=\"dateInputFormGroup.hasError('seconddatebefore')\"\r\n                                             id=\"secondDate-picker-maxError\"\r\n                                             message=\"End Date must be after Start Date\"\r\n                                             class=\"second-validator\">\r\n                </cl-error-validation-message>\r\n            </div>\r\n        </div>\r\n    </form>\r\n</ng-container>\r\n", styles: ["form{padding-bottom:10px}.label-container{float:left;width:20%}.label-container .type-label{display:inline;margin-right:5px}.dropdown-container{float:right;width:80%;white-space:nowrap;margin-bottom:8px}.dropdown-container cl-error-validation-message{display:table;margin-left:60px}.string-input-container{max-width:500px;padding-left:20%}.numeric-input-container{margin-left:20%}.numeric-input-container input,.numeric-input-container div{display:inline;white-space:nowrap}.numeric-input-container #input-number{max-width:500px}.numeric-input-container cl-error-validation-message{display:table}.date-input-container{margin-left:20%}.date-input-container cl-error-validation-message.first-validator{display:block}.date-input-container cl-error-validation-message.second-validator{display:block;margin-left:10px}.error-spacer{display:block}.list-input-container{margin-left:20%}.list-input-container cl-error-validation-message{display:block}.list-input-container kendo-multiselect{display:inline-flex}.boolean-input-container{float:right;width:80%;white-space:nowrap;margin-bottom:8px}.boolean-input-container cl-error-validation-message{display:table}kendo-dropdownlist{margin-right:8px}.k-input,.k-picker{min-width:12.4em;width:auto}.radio-group{margin-left:10px;display:inline-block}label{display:inline-block}.left-column{box-sizing:border-box;padding-left:10px;width:20%;display:inline-block}.right-column{width:80%;display:inline-block}::ng-deep .list-input-combo-box .k-input-inner,.list-input-multiselect{width:400px}\n"] }]
        }], propDecorators: { allowBetween: [{
                type: Input
            }], operators: [{
                type: Input
            }], condition: [{
                type: Input
            }] } });
const dateLessThan = (control) => {
    const date1Control = control.get('firstDateInput');
    const date2Control = control.get('secondDateInput');
    return date1Control && date2Control && date1Control.value && date2Control.value && date1Control.value > date2Control.value ? { seconddatebefore: true } : null;
};

class ListRequirementComponent {
    constructor() {
        this.isBlankItemId$ = new BehaviorSubject('');
        this.isNotBlankItemId$ = new BehaviorSubject('');
        this.selectedOperation$ = new BehaviorSubject('');
        this.lookupOperators$ = new BehaviorSubject([]);
        this.condition$ = new BehaviorSubject({});
        this.isFirstLoad = true;
        this.vm$ = combineLatest([
            this.condition$,
            this.selectedOperation$,
            this.lookupOperators$,
            this.isBlankItemId$,
            this.isNotBlankItemId$,
        ]).pipe(map(([condition, selectedOperation, lookupOperators, isBlankItemId, isNotBlankItemId]) => ({
            condition,
            isBlankItemId,
            selectedOperation,
            lookupOperators,
            isNotBlankItemId
        })), tap((data) => {
            if (this.isFirstLoad) {
                let operatorItemId = data.condition?.operation?.itemId ?? '';
                this.operationDropdown.setValue(operatorItemId);
                if (this.allowMultipleValues()) {
                    this.listInput.setValue(data.condition?.value ?? []);
                }
                else {
                    if (data.condition?.value && data.condition?.value?.length) {
                        this.valueInput.setValue(data.condition.value[0]);
                    }
                    else {
                        this.valueInput.setValue(null);
                    }
                }
                this.setValidators();
                this.isFirstLoad = false;
            }
        }));
        this.listInputFormGroup = new UntypedFormGroup({
            operationDropdown: new UntypedFormControl('', [Validators.required, Validators.minLength(1)]),
            // Stores the values when the operator is multi-value
            listInput: new UntypedFormControl([]),
            // Stores the value when the operator is single value
            valueInput: new UntypedFormControl(null)
        });
    }
    set operators(operators) {
        // Filter operators
        var filteredOperators = [{ itemId: '', itemName: 'Select an item...' }];
        filteredOperators.push(...operators);
        this.lookupOperators$.next(filteredOperators);
        const isBlankOp = filteredOperators.find(o => o.itemName === "Is Blank");
        const isNotBlankOp = filteredOperators.find(o => o.itemName === "Is Not Blank");
        if (isBlankOp) {
            this.isBlankItemId$.next(isBlankOp.itemId);
        }
        if (isNotBlankOp) {
            this.isNotBlankItemId$.next(isNotBlankOp.itemId);
        }
    }
    set condition(condition) {
        if (condition) {
            this.condition$.next(condition);
        }
        else {
            this.condition$.next({ value: [] });
        }
    }
    get f() { return this.listInputFormGroup.controls; }
    ;
    get listInput() { return this.f.listInput; }
    ;
    get valueInput() { return this.f.valueInput; }
    ;
    get operationDropdown() { return this.f.operationDropdown; }
    ;
    onOperatorChanged(selectedOperationId) {
        this.selectedOperation$.next(selectedOperationId);
        let conditionToEdit = this.condition$.getValue();
        let operators = this.lookupOperators$.getValue();
        conditionToEdit.operation = operators[operators.findIndex(p => p.itemId === selectedOperationId)];
        if (conditionToEdit.operation.itemId !== '' &&
            (conditionToEdit.operation.itemId === this.isBlankItemId$.getValue() ||
                conditionToEdit.operation.itemId === this.isNotBlankItemId$.getValue())) {
            conditionToEdit.value = [];
        }
        this.setValidators();
        this.listInput.updateValueAndValidity();
        this.valueInput.updateValueAndValidity();
        this.condition$.next(conditionToEdit);
    }
    clearControl(c) {
        c.setValue(null);
        c.clearValidators();
        c.disable();
    }
    setValidators() {
        if (this.operationDropdown.value && (this.operationDropdown.value === this.isBlankItemId$?.getValue() || this.operationDropdown.value === this.isNotBlankItemId$?.getValue())) {
            this.clearControl(this.listInput);
            this.clearControl(this.valueInput);
        }
        else if (this.allowMultipleValues()) {
            this.listInput.setValidators([Validators.required, this.noEmptyListValidator]);
            this.listInput.enable();
            this.clearControl(this.valueInput);
        }
        else {
            this.valueInput.setValidators([Validators.required]);
            this.valueInput.enable();
            this.clearControl(this.listInput);
        }
    }
    onMultiValueChanged(selectedItems) {
        var conditionToEdit = this.condition$.getValue();
        conditionToEdit.value = selectedItems;
        if (selectedItems.length === 0)
            conditionToEdit.value = [];
        this.condition$.next(conditionToEdit);
    }
    onSingleValueChanged(value) {
        var conditionToEdit = this.condition$.getValue();
        if (value && value.length) {
            conditionToEdit.value = [value];
        }
        else {
            conditionToEdit.value = [];
        }
        this.condition$.next(conditionToEdit);
    }
    noEmptyListValidator(control) {
        const isValid = !(control.value?.length === 0 ?? false);
        return isValid ? null : { 'emptylist': true };
    }
    getConditionValueAndValidity() {
        return { isValid: this.listInputFormGroup.valid, conditionToSave: this.condition$.getValue() };
    }
    allowMultipleValues() {
        const conditionToEdit = this.condition$.getValue();
        return conditionToEdit?.operation?.allowMultipleValues ? true : false;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.1", ngImport: i0, type: ListRequirementComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.1", type: ListRequirementComponent, selector: "cl-list-requirement", inputs: { operators: "operators", condition: "condition", listItems: "listItems" }, providers: [PopupService, ResizeBatchService], ngImport: i0, template: "<ng-container *ngIf=\"vm$ | async as vm\">\r\n    <div class=\"label-container\">\r\n        <label class=\"type-label\">List</label>\r\n        <cl-tooltip message=\"You can select which existing values for the field you would like to be required in order to match. Please make sure the operator is what you expect.\"></cl-tooltip>\r\n    </div>\r\n    <form [formGroup]=\"listInputFormGroup\">\r\n        <div class=\"dropdown-container\">\r\n            <!-- The dropdown list with operators -->\r\n            <label style=\"display:inline-block;\">Match if &nbsp;</label>\r\n            <kendo-dropdownlist name=\"operationId\"\r\n                                id=\"operator-dropdown\"\r\n                                [data]=\"vm.lookupOperators\"\r\n                                textField=\"itemName\"\r\n                                valueField=\"itemId\"\r\n                                [valuePrimitive]=\"true\"\r\n                                (valueChange)=\"onOperatorChanged($event)\"\r\n                                formControlName=\"operationDropdown\">\r\n            </kendo-dropdownlist>\r\n            <cl-error-validation-message *ngIf=\"(f.operationDropdown.touched || f.operationDropdown.dirty) && !f.operationDropdown.value\"\r\n                                         id=\"operation-dropdown-error\"\r\n                                         message=\"Required\">\r\n            </cl-error-validation-message>\r\n        </div>\r\n\r\n        <div class=\"list-input-container\">\r\n            <kendo-multiselect *ngIf=\"allowMultipleValues()\"\r\n                               class=\"form-control list-input-multiselect\"\r\n                               id=\"input-list\"\r\n                               formControlName=\"listInput\"\r\n                               [data]=\"listItems\"\r\n                               valueField=\"Key\"\r\n                               textField=\"Value\"\r\n                               [valuePrimitive]=\"true\"\r\n                               [placeholder]=\"'Select an item...'\"\r\n                               (valueChange)=\"onMultiValueChanged($event)\">\r\n            </kendo-multiselect>\r\n            <kendo-combobox *ngIf=\"!allowMultipleValues()\"\r\n                            id=\"input-drop-down\"\r\n                            formControlName=\"valueInput\"\r\n                            class=\"list-input-combo-box\"\r\n                            [data]=\"listItems\"\r\n                            textField=\"Value\"\r\n                            valueField=\"Key\"\r\n                            [valuePrimitive]=\"true\"\r\n                            [placeholder]=\"'Select an item...'\"\r\n                            [allowCustom]=\"false\"\r\n                            isRequired=\"true\"\r\n                            [suggest]=\"true\"\r\n                            (valueChange)=\"onSingleValueChanged($event)\">\r\n            </kendo-combobox>\r\n            <div *ngIf=\"listInput.errors && allowMultipleValues()\">\r\n                <cl-error-validation-message *ngIf=\"listInput.touched && (listInput.errors.required || listInput.errors.emptylist)\"\r\n                                             id=\"list-input-error\"\r\n                                             message=\"Required\">\r\n                </cl-error-validation-message>\r\n            </div>\r\n            <div *ngIf=\"valueInput.errors && !allowMultipleValues()\">\r\n                <cl-error-validation-message *ngIf=\"valueInput.touched && valueInput.errors.required\"\r\n                                             id=\"list-input-error\"\r\n                                             message=\"Required\">\r\n                </cl-error-validation-message>\r\n            </div>\r\n        </div>\r\n\r\n    </form>\r\n</ng-container>\r\n", styles: ["form{padding-bottom:10px}.label-container{float:left;width:20%}.label-container .type-label{display:inline;margin-right:5px}.dropdown-container{float:right;width:80%;white-space:nowrap;margin-bottom:8px}.dropdown-container cl-error-validation-message{display:table;margin-left:60px}.string-input-container{max-width:500px;padding-left:20%}.numeric-input-container{margin-left:20%}.numeric-input-container input,.numeric-input-container div{display:inline;white-space:nowrap}.numeric-input-container #input-number{max-width:500px}.numeric-input-container cl-error-validation-message{display:table}.date-input-container{margin-left:20%}.date-input-container cl-error-validation-message.first-validator{display:block}.date-input-container cl-error-validation-message.second-validator{display:block;margin-left:10px}.error-spacer{display:block}.list-input-container{margin-left:20%}.list-input-container cl-error-validation-message{display:block}.list-input-container kendo-multiselect{display:inline-flex}.boolean-input-container{float:right;width:80%;white-space:nowrap;margin-bottom:8px}.boolean-input-container cl-error-validation-message{display:table}kendo-dropdownlist{margin-right:8px}.k-input,.k-picker{min-width:12.4em;width:auto}.radio-group{margin-left:10px;display:inline-block}label{display:inline-block}.left-column{box-sizing:border-box;padding-left:10px;width:20%;display:inline-block}.right-column{width:80%;display:inline-block}::ng-deep .list-input-combo-box .k-input-inner,.list-input-multiselect{width:400px}\n"], dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i2.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "component", type: i3.ComboBoxComponent, selector: "kendo-combobox", inputs: ["icon", "svgIcon", "showStickyHeader", "focusableId", "allowCustom", "data", "value", "textField", "valueField", "valuePrimitive", "valueNormalizer", "placeholder", "adaptiveMode", "title", "subtitle", "popupSettings", "listHeight", "loading", "suggest", "clearButton", "disabled", "itemDisabled", "readonly", "tabindex", "tabIndex", "filterable", "virtual", "size", "rounded", "fillMode"], outputs: ["valueChange", "selectionChange", "filterChange", "open", "opened", "close", "closed", "focus", "blur", "inputFocus", "inputBlur"], exportAs: ["kendoComboBox"] }, { kind: "component", type: i3.DropDownListComponent, selector: "kendo-dropdownlist", inputs: ["customIconClass", "showStickyHeader", "icon", "svgIcon", "loading", "data", "value", "textField", "valueField", "adaptiveMode", "title", "subtitle", "popupSettings", "listHeight", "defaultItem", "disabled", "itemDisabled", "readonly", "filterable", "virtual", "ignoreCase", "delay", "valuePrimitive", "tabindex", "tabIndex", "size", "rounded", "fillMode", "leftRightArrowsNavigation", "id"], outputs: ["valueChange", "filterChange", "selectionChange", "open", "opened", "close", "closed", "focus", "blur"], exportAs: ["kendoDropDownList"] }, { kind: "component", type: i3.MultiSelectComponent, selector: "kendo-multiselect", inputs: ["showStickyHeader", "focusableId", "autoClose", "loading", "data", "value", "valueField", "textField", "tabindex", "tabIndex", "size", "rounded", "fillMode", "placeholder", "adaptiveMode", "title", "subtitle", "disabled", "itemDisabled", "checkboxes", "readonly", "filterable", "virtual", "popupSettings", "listHeight", "valuePrimitive", "clearButton", "tagMapper", "allowCustom", "valueNormalizer"], outputs: ["filterChange", "valueChange", "open", "opened", "close", "closed", "focus", "blur", "inputFocus", "inputBlur", "removeTag"], exportAs: ["kendoMultiSelect"] }, { kind: "component", type: ErrorValidationMessageComponent, selector: "cl-error-validation-message", inputs: ["accessibilityMessage", "message"] }, { kind: "component", type: TooltipComponent, selector: "cl-tooltip", inputs: ["message", "iconClass", "maxWidth", "anchorAlign", "popupAlign"], outputs: ["iconClick"] }, { kind: "pipe", type: i1$1.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.1", ngImport: i0, type: ListRequirementComponent, decorators: [{
            type: Component,
            args: [{ changeDetection: ChangeDetectionStrategy.OnPush, selector: 'cl-list-requirement', providers: [PopupService, ResizeBatchService], template: "<ng-container *ngIf=\"vm$ | async as vm\">\r\n    <div class=\"label-container\">\r\n        <label class=\"type-label\">List</label>\r\n        <cl-tooltip message=\"You can select which existing values for the field you would like to be required in order to match. Please make sure the operator is what you expect.\"></cl-tooltip>\r\n    </div>\r\n    <form [formGroup]=\"listInputFormGroup\">\r\n        <div class=\"dropdown-container\">\r\n            <!-- The dropdown list with operators -->\r\n            <label style=\"display:inline-block;\">Match if &nbsp;</label>\r\n            <kendo-dropdownlist name=\"operationId\"\r\n                                id=\"operator-dropdown\"\r\n                                [data]=\"vm.lookupOperators\"\r\n                                textField=\"itemName\"\r\n                                valueField=\"itemId\"\r\n                                [valuePrimitive]=\"true\"\r\n                                (valueChange)=\"onOperatorChanged($event)\"\r\n                                formControlName=\"operationDropdown\">\r\n            </kendo-dropdownlist>\r\n            <cl-error-validation-message *ngIf=\"(f.operationDropdown.touched || f.operationDropdown.dirty) && !f.operationDropdown.value\"\r\n                                         id=\"operation-dropdown-error\"\r\n                                         message=\"Required\">\r\n            </cl-error-validation-message>\r\n        </div>\r\n\r\n        <div class=\"list-input-container\">\r\n            <kendo-multiselect *ngIf=\"allowMultipleValues()\"\r\n                               class=\"form-control list-input-multiselect\"\r\n                               id=\"input-list\"\r\n                               formControlName=\"listInput\"\r\n                               [data]=\"listItems\"\r\n                               valueField=\"Key\"\r\n                               textField=\"Value\"\r\n                               [valuePrimitive]=\"true\"\r\n                               [placeholder]=\"'Select an item...'\"\r\n                               (valueChange)=\"onMultiValueChanged($event)\">\r\n            </kendo-multiselect>\r\n            <kendo-combobox *ngIf=\"!allowMultipleValues()\"\r\n                            id=\"input-drop-down\"\r\n                            formControlName=\"valueInput\"\r\n                            class=\"list-input-combo-box\"\r\n                            [data]=\"listItems\"\r\n                            textField=\"Value\"\r\n                            valueField=\"Key\"\r\n                            [valuePrimitive]=\"true\"\r\n                            [placeholder]=\"'Select an item...'\"\r\n                            [allowCustom]=\"false\"\r\n                            isRequired=\"true\"\r\n                            [suggest]=\"true\"\r\n                            (valueChange)=\"onSingleValueChanged($event)\">\r\n            </kendo-combobox>\r\n            <div *ngIf=\"listInput.errors && allowMultipleValues()\">\r\n                <cl-error-validation-message *ngIf=\"listInput.touched && (listInput.errors.required || listInput.errors.emptylist)\"\r\n                                             id=\"list-input-error\"\r\n                                             message=\"Required\">\r\n                </cl-error-validation-message>\r\n            </div>\r\n            <div *ngIf=\"valueInput.errors && !allowMultipleValues()\">\r\n                <cl-error-validation-message *ngIf=\"valueInput.touched && valueInput.errors.required\"\r\n                                             id=\"list-input-error\"\r\n                                             message=\"Required\">\r\n                </cl-error-validation-message>\r\n            </div>\r\n        </div>\r\n\r\n    </form>\r\n</ng-container>\r\n", styles: ["form{padding-bottom:10px}.label-container{float:left;width:20%}.label-container .type-label{display:inline;margin-right:5px}.dropdown-container{float:right;width:80%;white-space:nowrap;margin-bottom:8px}.dropdown-container cl-error-validation-message{display:table;margin-left:60px}.string-input-container{max-width:500px;padding-left:20%}.numeric-input-container{margin-left:20%}.numeric-input-container input,.numeric-input-container div{display:inline;white-space:nowrap}.numeric-input-container #input-number{max-width:500px}.numeric-input-container cl-error-validation-message{display:table}.date-input-container{margin-left:20%}.date-input-container cl-error-validation-message.first-validator{display:block}.date-input-container cl-error-validation-message.second-validator{display:block;margin-left:10px}.error-spacer{display:block}.list-input-container{margin-left:20%}.list-input-container cl-error-validation-message{display:block}.list-input-container kendo-multiselect{display:inline-flex}.boolean-input-container{float:right;width:80%;white-space:nowrap;margin-bottom:8px}.boolean-input-container cl-error-validation-message{display:table}kendo-dropdownlist{margin-right:8px}.k-input,.k-picker{min-width:12.4em;width:auto}.radio-group{margin-left:10px;display:inline-block}label{display:inline-block}.left-column{box-sizing:border-box;padding-left:10px;width:20%;display:inline-block}.right-column{width:80%;display:inline-block}::ng-deep .list-input-combo-box .k-input-inner,.list-input-multiselect{width:400px}\n"] }]
        }], propDecorators: { operators: [{
                type: Input
            }], condition: [{
                type: Input
            }], listItems: [{
                type: Input
            }] } });

class ClCommonAngularModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.1", ngImport: i0, type: ClCommonAngularModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.1", ngImport: i0, type: ClCommonAngularModule, declarations: [BreadcrumbComponent,
            ModalComponent,
            ReleaseNoteComponent,
            PrivacyPolicyComponent,
            SessionExpiringModalComponent,
            ErrorValidationMessageComponent,
            ButtonComponent,
            SafePipe,
            TooltipComponent,
            NotAuthorizedComponent,
            ListOfStringSettingComponent,
            ImageUploadModalComponent,
            ContainerComponent,
            PushNotificationsSubscriberComponent,
            TitleComponent,
            StringRequirementComponent,
            NumberRequirementComponent,
            BooleanRequirementComponent,
            DateRequirementComponent,
            ListRequirementComponent,
            SanitizePastedTextDirective], imports: [CommonModule,
            FormsModule,
            RouterModule,
            ReactiveFormsModule,
            DialogModule,
            DropDownsModule,
            PopupModule,
            DateInputsModule], exports: [BreadcrumbComponent,
            ModalComponent,
            ReleaseNoteComponent,
            PrivacyPolicyComponent,
            SessionExpiringModalComponent,
            ErrorValidationMessageComponent,
            ButtonComponent,
            SafePipe,
            TooltipComponent,
            NotAuthorizedComponent,
            ListOfStringSettingComponent,
            ImageUploadModalComponent,
            PushNotificationsSubscriberComponent,
            TitleComponent,
            StringRequirementComponent,
            NumberRequirementComponent,
            BooleanRequirementComponent,
            DateRequirementComponent,
            ListRequirementComponent,
            SanitizePastedTextDirective] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.1", ngImport: i0, type: ClCommonAngularModule, imports: [CommonModule,
            FormsModule,
            RouterModule,
            ReactiveFormsModule,
            DialogModule,
            DropDownsModule,
            PopupModule,
            DateInputsModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.1", ngImport: i0, type: ClCommonAngularModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        BreadcrumbComponent,
                        ModalComponent,
                        ReleaseNoteComponent,
                        PrivacyPolicyComponent,
                        SessionExpiringModalComponent,
                        ErrorValidationMessageComponent,
                        ButtonComponent,
                        SafePipe,
                        TooltipComponent,
                        NotAuthorizedComponent,
                        ListOfStringSettingComponent,
                        ImageUploadModalComponent,
                        ContainerComponent,
                        PushNotificationsSubscriberComponent,
                        TitleComponent,
                        StringRequirementComponent,
                        NumberRequirementComponent,
                        BooleanRequirementComponent,
                        DateRequirementComponent,
                        ListRequirementComponent,
                        SanitizePastedTextDirective
                    ],
                    imports: [
                        CommonModule,
                        FormsModule,
                        RouterModule,
                        ReactiveFormsModule,
                        DialogModule,
                        DropDownsModule,
                        PopupModule,
                        DateInputsModule
                    ],
                    exports: [
                        BreadcrumbComponent,
                        ModalComponent,
                        ReleaseNoteComponent,
                        PrivacyPolicyComponent,
                        SessionExpiringModalComponent,
                        ErrorValidationMessageComponent,
                        ButtonComponent,
                        SafePipe,
                        TooltipComponent,
                        NotAuthorizedComponent,
                        ListOfStringSettingComponent,
                        ImageUploadModalComponent,
                        PushNotificationsSubscriberComponent,
                        TitleComponent,
                        StringRequirementComponent,
                        NumberRequirementComponent,
                        BooleanRequirementComponent,
                        DateRequirementComponent,
                        ListRequirementComponent,
                        SanitizePastedTextDirective
                    ]
                }]
        }] });

class JsUtility {
    /**
     * compares two objects to see if they are the same
     * @param obj1
     * @param obj2
     */
    static equals(obj1, obj2) {
        return JSON.stringify(obj1) === JSON.stringify(obj2);
    }
    /**
     * copies an object without creating a reference to the same pointer
     * @param obj Object to copy
     */
    static clone(obj) {
        var copy;
        // Handle the 3 simple types, and null or undefined
        if (null == obj || "object" != typeof obj)
            return obj;
        // Handle Date
        if (obj instanceof Date) {
            copy = new Date();
            copy.setTime(obj.getTime());
            return copy;
        }
        // Handle Array
        if (obj instanceof Array) {
            copy = [];
            for (var i = 0, len = obj.length; i < len; i++) {
                copy[i] = this.clone(obj[i]);
            }
            return copy;
        }
        // Handle Object
        if (obj instanceof Object) {
            copy = {};
            for (var attr in obj) {
                if (obj.hasOwnProperty(attr))
                    copy[attr] = this.clone(obj[attr]);
            }
            return copy;
        }
        throw new Error("Unable to copy obj! Its type isn't supported.");
    }
    static titleCaseString(input) {
        if (!input) {
            return '';
        }
        else {
            return input.replace(/\w\S*/g, (txt => txt[0].toUpperCase() + txt.substr(1).toLowerCase()));
        }
    }
    // default date reviver function can be used with JSON.Parse() to automatically create date objects during deserialization
    static dateReviver(key, value) {
        let datePattern = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d{1,3})??Z??$/;
        if (typeof (value) === 'string' && value !== null && datePattern.test(value))
            return new Date(value);
        return value;
    }
    static coalesce(...arr) {
        if (!arr) {
            return null;
        }
        for (let i = 0; i < arr.length; i++) {
            let value = arr[i];
            if (value != null && typeof (value) !== "undefined") {
                return value;
            }
        }
        return null;
    }
    static convertDate(dt) {
        if (!dt) {
            return null;
        }
        return new Date(dt);
    }
}

const EXPERIENCE_MODULE_SETTINGS = new InjectionToken('ExperienceModuleSettings');
class ExperienceModule {
    static forRoot(experienceSettings) {
        return {
            ngModule: ExperienceModule,
            providers: [
                {
                    provide: EXPERIENCE_MODULE_SETTINGS,
                    useValue: experienceSettings,
                },
                {
                    deps: [
                        AuthenticationService,
                        EXPERIENCE_MODULE_SETTINGS,
                        NgZone,
                    ],
                    multi: true,
                    provide: APP_BOOTSTRAP_LISTENER,
                    useFactory: experienceInitializer,
                },
            ],
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.1", ngImport: i0, type: ExperienceModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.1", ngImport: i0, type: ExperienceModule }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.1", ngImport: i0, type: ExperienceModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.1", ngImport: i0, type: ExperienceModule, decorators: [{
            type: NgModule
        }] });
const experienceInitializer = (authenticationService, experienceSettings, ngZone) => async () => {
    authenticationService.getAuthInfo().subscribe(authInfo => {
        if (!authInfo.isExperienceEverywhere && !experienceSettings.debug)
            return;
        if (!authInfo.expAccessToken || !authInfo.expTenantAlias)
            return;
        const styleElement = document.createElement('style');
        styleElement.innerHTML = `
            .header-bar-section-menu>span:hover { background-color: unset; }
            .header-bar-section-menu>span:hover *,.header-bar-section-menu>span:focus * { color: unset; }
        `;
        document.head.appendChild(styleElement);
        const expApiUrl = authInfo.expApiUrl ?? experienceSettings.experienceUrl;
        let headerKitUrl = expApiUrl;
        if (!headerKitUrl) {
            headerKitUrl = experienceSettings.headerKitUrl;
        }
        else {
            if (!headerKitUrl.endsWith('/')) {
                headerKitUrl += '/';
            }
            headerKitUrl += 'headerkit/loader.js';
        }
        const scriptElement = document.createElement('script');
        scriptElement.async = true;
        scriptElement.src = headerKitUrl;
        scriptElement.onload = () => {
            const element = document.querySelector(experienceSettings.querySelector);
            const mutationCountMax = 1000;
            let mutationCount = 0;
            // configuration for initializing the header kit
            const overrides = {
                token: authInfo.expAccessToken,
                tenantAlias: authInfo.expTenantAlias,
                experience: expApiUrl
            };
            // element may or may not have been rendered yet
            if (element) {
                // if we found it then wire it up on the spot
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                headerkit.init(element, overrides);
            }
            else {
                // if we didn't find it then we'll hook into the mutator api to find it when it gets rendered
                ngZone.runOutsideAngular(() => {
                    const observer = new MutationObserver(() => {
                        mutationCount++;
                        // max mutations helps keep us from eating up memory if a third-party fires a ton of mutations
                        if (mutationCount > mutationCountMax)
                            observer.disconnect();
                        if (document.querySelector(experienceSettings.querySelector)) {
                            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                            // @ts-ignore
                            headerkit.init(document.querySelector(experienceSettings.querySelector), overrides);
                            observer.disconnect();
                        }
                    });
                    observer.observe(document.body, { childList: true, subtree: true });
                });
            }
        };
        document.head.appendChild(scriptElement);
    });
};

/*
 * Public API Surface of cl-common-angular
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ANALYTICS_INITIALIZIER_PROVIDER, AudienceTypesEnum, AuthGuard, AuthenticationService, Batch, BooleanRequirementComponent, BreadcrumbComponent, ButtonComponent, ClCommonAngularModule, ContainerComponent, CustomHttpHeaders, CustomModalBaseComponent, CustomModalService, DateRequirementComponent, DateReviverInterceptorService, DeactivateGuard, DownloadService, ErrorInterceptorService, ErrorValidationMessageComponent, ExperienceModule, IReleaseNoteService, ImageUploadModalComponent, JsUtility, KendoGridModel, LOGGER_PROVIDER, ListOfStringSettingComponent, ListRequirementComponent, LoggerService, ModalComponent, ModalService, ModalType, MultiBatchResult, NotAuthorizedComponent, NotificationTypesEnum, NumberRequirementComponent, PrivacyPolicyComponent, PushNotificationPermissionEnum, PushNotificationService, PushNotificationsSubscriberComponent, RedirectInterceptorService, ReleaseNoteComponent, SafePipe, SanitizePastedTextDirective, SearchFilter, SearchFilterItem, SecurityType, SecurityTypeHelper, ServerSideSearchOptions, SessionExpiringModalComponent, SessionExpiringModalService, SessionService, SessionTimeoutInterceptorService, SortItem, SpinnerInterceptorService, StringRequirementComponent, StyleColorsService, TimeSpan, TitleComponent, TooltipComponent, UpdatePushSubscription, UtcDateInterceptorService, dateLessThan, experienceInitializer };
